import React, { useEffect, useRef, useState } from "react";
import { shareViaFlutter } from "../../utils/shareLink";
import DashboardHeader from "../../components/Other/DashboardHeader";
import usePullToRefresh from "../../hooks/usePullToRefresh";
import PullToRefreshIndicator from "./PullToRefreshIndicator";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { baseSymbol, instrumentName } from "../../utils/instrumentFormat";
import {
  faBookmark as saved,
  faEdit,
  faTrash,
  faThumbtack,
  faEllipsisV,
  faPlay,
  faPause,
} from "@fortawesome/free-solid-svg-icons";
import {
  getProfile,
  getMyPost,
  savePost,
  tradingType,
  followUnfollow,
  repostPost,
  getComment,
  addComment,
  likeDislike,
  deletePost,
  pinPost,
  getOrder,
  getSettings,
  getPaymentCardsApi,
  makePaymentApi,
  setPrimaryMethod,
  getPaidPost,
  deleteComment,
  undoRepostPost,
  createPaymentIntent,
  generateReferralCode,
  getUserReferralCode,
  getGuideStatus,
  getGuideStatusMobile,
  markGuideAsShown,
  markGuideAsShownMobile,
  getLinkPreview,
  getGuideSetting,
} from "../../api/user";
import { extractFirstUrl, splitTextAndUrls, getTextOnlyLength, trimTextPreservingUrls } from "../../utils/urlUtils";
import LinkPreviewCard from "../../components/LinkPreviewCard/LinkPreviewCard";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { faHeart as empty } from "@fortawesome/free-regular-svg-icons";
import { faComment as empty2 } from "@fortawesome/free-regular-svg-icons";
// import logo from "../images/logo.png";
import GreenTick from "../../images/green-tick.png";
import PublicProfileHeader from "./PublicProfileHeader";
import ProfileRecordCard from "./ProfileRecordCard";
import HoldingSparkline from "./HoldingSparkline";
import NewPortfolioSection from "../Games/NewPortfolioSection";
import PerformanceSection from "./PerformanceSection";
import OwnerToolsBlock from "./OwnerToolsBlock";
import TrophyCase from "../MyProfile/TrophyCase";
import { faBookmark } from "@fortawesome/free-regular-svg-icons";
import {
  faLink,
  faEllipsisH,
  faArrowUpFromBracket,
  faHeart,
  faRepeat,
} from "@fortawesome/free-solid-svg-icons";
import {
  ProfileHeaderSkeleton,
  RecordCardSkeleton,
  OwnerToolsSkeleton,
} from "../../components/Skeleton/ProfileSkeleton";
import { leagueEndAt, leagueTypeKey } from "../../pages/Game/landing/leagueFormat";
import LockedLeagueTab from "./LockedLeagueTab";
import ListSkeleton from "../../components/Skeleton/ListSkeleton";
import PostListSkeleton from "../../components/Skeleton/PostListSkeleton";
import { PageError } from "../../components/Skeleton/LoadError";
import PageContainer from "../../components/pages/PageContainer";
import PageHeaderTitle from "../../components/pages/PageHeaderTitle";
import SubscriptionModal from "../../pages/stripe-payment/subscriptionModal";
import CardListForSubs from "../../pages/stripe-payment/card-detail-listing";
import AddCard from "../../pages/stripe-payment/addCard";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "../../pages/stripe-payment/stripePayment";
import { getStripe } from "../../utils/stripe";
import List from "../../pages/stripe-payment/list";
import { event } from "../../utils/event";
import UndoRepostModal from "../../components/Modals/repostModal";
import { PreviewVideo } from "../../pages/previewVideo";
import { formatPrice, SUBSCRIPTION_ENABLED, isPostLocked } from "../../utils/utils";
import { renderPostHtml } from "../../utils/postContent";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";
import { Link, useLocation } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import GameSideBar from "../Games/GameSideBar";
import ResetPortfolioModal from "../Modals/ResetPortfolioModal";
import CheckoutPortfolioForm from "../Modals/CheckoutPortfolioForm";
import Flag from "react-world-flags";
import {  IconExit,
  CommentIcon,
  HeartFilledIcon,
  HeartIcon,
  RepostIcon,
  SaveIcon,
  ShareIcon,
  TheDotsIcon,
  SaveIconFill } from "../../icons/icons";
import { COUNTRIES } from "../../icons/countryFlag";
import ReferAFriend from "./ReferAFriend";
import ProfileGuideSteps from "../guide/ProfileGuideSteps";
import GuideLauncher from "../guide/GuideLauncher";
import NewTraderGuide from "../guide/NewTraderGuide";
import { useNewTraderGuide } from "../../context/NewTraderGuideContext";
import { SkeletonBlock } from "../../components/Skeleton/Skeleton";

const galleryStyles = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
  gridGap: "20px",
};

const imageStyles = {
  width: "auto",
  height: "auto",
  objectFit: "cover",
  // border: "1px solid #ccc",
};

const linkStyles = {
  // background: "#f0f0f0",
  // padding: "5px",
  margin: "10px",
};

function calculateTimeDifference(created_at) {
  const currentDate = new Date();
  const createdAtDate = new Date(created_at);

  // Ensure time difference is non-negative
  const timeDifference = Math.max(
    0,
    currentDate.getTime() - createdAtDate.getTime()
  );

  const secondsInMs = 1000;
  const minutesInMs = secondsInMs * 60;
  const hoursInMs = minutesInMs * 60;
  const daysInMs = hoursInMs * 24;
  const monthsInMs = daysInMs * 30; // Note: Approximation, as months have varying numbers of days
  const yearsInMs = daysInMs * 365; // Note: Does not account for leap years

  if (timeDifference < secondsInMs) {
    return "just now";
  } else if (timeDifference < minutesInMs) {
    return Math.round(timeDifference / secondsInMs) + " s ago";
  } else if (timeDifference < hoursInMs) {
    return Math.round(timeDifference / minutesInMs) + " m ago";
  } else if (timeDifference < daysInMs) {
    return Math.round(timeDifference / hoursInMs) + " h ago";
  } else if (timeDifference < monthsInMs) {
    return Math.round(timeDifference / daysInMs) + " d ago";
  } else if (timeDifference < yearsInMs) {
    // Change 'm' to 'mo' to avoid confusion with 'minutes'
    return Math.round(timeDifference / monthsInMs) + " mo ago";
  } else {
    return Math.round(timeDifference / yearsInMs) + " y ago";
  }
}

const ProfilePage = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const game_id = props.game_id ?? null;
  const slug = props.slug ?? null;
  const profile_id = props.profile_id ?? null;
  // The whole league record, not just its id. GameProfile already fetches it to
  // resolve the slug, so passing it down costs nothing — and every piece of
  // League Play wording below needs to know WHICH KIND of competition this is,
  // which the id alone cannot say.
  const game = props.game ?? null;
  // Client League Play Profiles spec: "Public, Private, and Cash Games are all
  // the same" layout — only the text differs. leagueTypeKey is League Play's own
  // classifier (it checks is_cash_prize_league BEFORE public/private, because a
  // cash game is a cash game first), so a cash league is never mislabelled as a
  // public one here the way it would be off game_type alone.
  const isCashGame = !!game_id && leagueTypeKey(game) === "cash";
  // Item 7 — rank label. Item 9 — Record card title. Item 10 — supporting line.
  // Outside a league every one of these keeps its existing sitewide wording, so
  // /profile and /profile/:userId are untouched.
  const rankLabel = !game_id
    ? "LEADERBOARD"
    : isCashGame
    ? "GAME RANK"
    : "LEAGUE RANK";
  const recordTitle = !game_id
    ? "The Record"
    : isCashGame
    ? "Cash Game Record"
    : "League Record";
  const recordSubtitle = !game_id
    ? "Verified performance on QUSHi"
    : isCashGame
    ? "Verified cash game performance"
    : "Verified league performance";
  const [posts, setPosts] = useState([]);
  // Overview tab: 3 largest current holdings (by position size) for this profile.
  const [topHoldings, setTopHoldings] = useState([]);
  // Top Holdings is its own request keyed on the profile id, so it reveals
  // independently. Without this flag it showed "No holdings yet." while the
  // request was still in flight — a false empty state.
  const [topHoldingsLoading, setTopHoldingsLoading] = useState(true);
  const [profile, setProfile] = useState([]);
  const [commentOpenStates, setCommentOpenStates] = useState({});
  const [newComment, setNewComment] = useState("");
  const [commentImage, setCommentImage] = useState(null);
  const [commentImagePreview, setCommentImagePreview] = useState(null);
  const [newid, setNewId] = useState("");
  const [postComments, setPostComments] = useState({});
  const [replyingTo, setReplyingTo] = useState(null);
  const [expandedReplies, setExpandedReplies] = useState({});
  const [userImg, setUserImg] = useState("");
  const [trading, setTrade] = useState([]);
  // Profile tabs: posts | holdings | tradeHistory | performance — identical on
  // mobile and desktop now (Overview was removed on mobile). Default to Posts.
  const [activeProfileTab, setActiveProfileTab] = useState("posts");
  const [isDisabled, setIsDisabled] = useState(false);
  const [isSubscribe, setIsSubscribe] = useState(false);
  const [isOpenCardModal, setIsOpenCardModal] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [stripeKey, setStripeKey] = useState("");
  const [cards, setCards] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [isDataFeteched, setisDataFeteched] = useState(false);
  const [isDataFeteched1, setisDataFeteched1] = useState(false);
  const [isDataFeteched2, setisDataFeteched2] = useState(false);
  const [isDataFeteched3, setisDataFeteched3] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  // `loading` is the INITIAL page load only — it is never set back to true, so
  // a rendered profile can't revert to a skeleton. `postsLoading` covers the
  // posts region on its own (e.g. switching to Paid content), which reloads
  // without disturbing the rest of the page.
  const [loading, setLoading] = useState(true);
  const [postsLoading, setPostsLoading] = useState(true);
  // True only once the LIVE getProfile response is in. Financial regions (The
  // Record, QUSHi Coins) gate on this and never on the cache — see below.
  const [profileFresh, setProfileFresh] = useState(false);
  // Guards against posts being fetched twice (parallel effect + fetchProfile).
  const initialPostsStartedRef = useRef(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showFullDescription, setShowFullDescription] = useState([]);
  const [linkPreviewData, setLinkPreviewData] = useState({});
  // Which post's three-dot menu is open, by post id. It used to be a boolean
  // per list INDEX, so after a delete the next post slid into that index with
  // its menu already open — and a second "Delete" removed that post instead.
  const [openMenuPostId, setOpenMenuPostId] = useState(null);
  const [videoPlaying, setVideoPlaying] = useState([]);
  const [page, setPage] = useState(1);
  const openModal = () => setIsAddModalOpen(true);
  const closeModal = () => setIsAddModalOpen(false);
  // Cached per key and error-handled — see utils/stripe.
  const stripePromise = getStripe(stripeKey);
  let { userId } = useParams();
  const user_id = localStorage.getItem("user_id");
  // The id every section needs is already known at mount — from the route, the
  // game prop, or localStorage — so nothing has to wait for getProfile to learn
  // it. Posts and Top Holdings fire in PARALLEL with the profile request; each
  // section paints the moment its own response lands.
  const targetUserId = profile_id ?? userId ?? user_id ?? null;

  // Paint the header at 0ms from the last successful profile load instead of
  // waiting on the network. getProfile already writes userInfo to localStorage
  // on every load, so on your OWN profile the identity is always to hand.
  //
  // IDENTITY FIELDS ONLY. Every financial figure is deliberately excluded:
  // a stale balance, return % or coin count that silently corrects itself a
  // second later is far worse than a skeleton — the user may act on it.
  const readCachedIdentity = () => {
    if (userId && String(userId) !== String(user_id)) return null; // not us
    if (profile_id) return null;
    try {
      const u = JSON.parse(localStorage.getItem("userInfo") || "null");
      if (!u?.id) return null;
      return {
        id: u.id,
        uuid: u.uuid,
        full_name: u.full_name,
        user_name: u.user_name,
        image: u.image,
        country_code: u.country_code,
        country_of_origin: u.country_of_origin,
        biography: u.biography,
        title: u.title,
        link: u.link,
        green_tick: u.green_tick,
        created_at: u.created_at,
        last_reset: u.last_reset,
        trading_type_id: u.trading_type_id,
      };
    } catch (e) {
      return null;
    }
  };
  // "View as public" preview: owner viewing their own profile as others see it.
  const previewAsPublic =
    new URLSearchParams(location.search).get("view") === "public";
  // Public layout = viewing another user OR previewing own profile as public.
  //
  // Read this off targetUserId, not the route param. The league profile route is
  // /:slug/profile/:user_id and passes the id in as a PROP (profile_id), so
  // useParams().userId is undefined there — which used to render the owner's own
  // dashboard layout (Edit Profile, "View as public") while showing another
  // member's data. targetUserId already resolves prop -> param -> self, so one
  // source of truth covers both routes.
  const showPublicLayout =
    (targetUserId && String(targetUserId) !== String(user_id)) || previewAsPublic;
  // Client League Play Profiles spec, item 21 — the locked state.
  //
  // "When the league's portfolio visibility is set to Hidden during league,
  //  another member viewing that trader's League Profile sees Posts normally,
  //  Performance and League Record normally, and Holdings / Trade History in a
  //  locked state." Three conditions have to hold together:
  //
  //   - we are inside a league AND that league hides portfolios
  //   - the viewer is NOT the owner of this profile ("The profile's own owner
  //     can always see their own Holdings")
  //   - the league has not ended yet ("Once the league ends, both tabs become
  //     fully visible automatically")
  // leagueEndAt, not a raw parse of end_date. end_date is stored at MIDNIGHT of
  // the final day, so reading it as the end instant unlocked these two tabs a
  // full day early — at 00:00 on the league's last day, while the league was
  // still running and the portfolio was still supposed to be hidden. One rule,
  // shared with the status line and the backend finaliser. See leagueFormat.js.
  const leagueEnded = (() => {
    const end = leagueEndAt(game);
    return !!end && end.getTime() < Date.now();
  })();
  const portfolioLocked =
    !!game_id && !!game?.private_portfolio && showPublicLayout && !leagueEnded;

  // Client, League Play Dev Request, "League Profile Routing": "Add View QUSHi
  // Record › directly beneath Follow and Message and before the League Record
  // card… View QUSHi Record must open the trader's main public QUSHi profile."
  //
  // Only on a League Play profile (game_id), and only when looking at SOMEONE
  // ELSE (showPublicLayout is the public-facing layout — the one that carries
  // Follow and Message in the first place). On your own profile, or outside a
  // league, the link would point at the page you are already standing on, so it
  // is null and PublicProfileHeader renders nothing.
  const qushiRecordId = profile_id || profile?.id || null;
  const qushiRecordHref =
    game_id && showPublicLayout && qushiRecordId
      ? `/profile/${qushiRecordId}`
      : null;

  // Client League Play Profiles spec, item 2: "Competition eyebrow and the
  // dynamic league title above the profile, no container, left aligned to the
  // bio card."
  //
  // That is exactly what LeagueShell's `compact standalone` mode already renders
  // on Leaderboard, Watchlist and Portfolio, so GameProfile now wraps this
  // screen in the same component rather than this file printing a second copy of
  // the two lines. The shell brings its own header, its own container and its
  // own top offset — so inside a league this screen must stop bringing its own,
  // or they double up. Measured before this change: the league profile mounted
  // TWO DashboardHeaders (both fixed, both at x=0, exactly overlapping) and a
  // PageContainer that the shell would have nested inside.
  //
  // Same shape as LeaderboardSecton, which solved this first. Outside a league
  // nothing changes: Shell is still PageContainer with the identical props.
  const Shell = game_id ? React.Fragment : PageContainer;
  const shellProps = game_id ? {} : { gamePage: game_id && true };

  // Client League Play Profiles spec, item 13: the Posts tab is scoped to the
  // league.
  //
  // Two things used to keep league posts off a profile, and both had to change:
  // the request did not send game_id, and this list then dropped every post
  // that had one (`!post.game_id`). That pairing is correct on the MAIN profile
  // — /profile must not surface a league's private conversation — but inside a
  // league it removed exactly the posts the tab is supposed to show.
  //
  // So the rule is now one expression, read off the same flag as everything
  // else: in a league, this league's posts; outside one, the main app's.
  const profilePosts = posts.filter((p) =>
    game_id ? String(p.game_id) === String(game_id) : !p.game_id
  );
  // Private profile = the logged-in user's own dashboard view (route "/profile",
  // no id segment). Used to tint the pinned-post label + active tab in the
  // site's base dark green.
  const isPrivateProfile = !location.pathname.startsWith("/profile/");
  const [traderProfile, setTraderProfile] = useState(false);
  // Set when the profile request itself fails, so the skeleton is replaced by a
  // page error rather than sitting there forever.
  const [profileLoadFailed, setProfileLoadFailed] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loader, setLoader] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [showFullRepostDescription, setShowFullRepostDescription] = useState(
    []
  );
  const [isHovered, setIsHovered] = useState(false);
  const [isHovered1, setIsHovered1] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);
  const [loadingComment, setLoadingComment] = useState(false);
  // Mobile comment modal state
  const [mobileCommentModal, setMobileCommentModal] = useState({
    isOpen: false,
    postId: null,
    postIndex: null,
  });
  // Swipe to close state for mobile comment modal
  const [commentModalSwipe, setCommentModalSwipe] = useState({
    startY: 0,
    currentY: 0,
    isDragging: false,
  });
  const [keyboardHeight, setKeyboardHeight] = useState(0);
  const [last_page, setlast_page] = useState();
  const isMobileView = document.body.clientWidth <= 768; // You can adjust the breakpoint as needed
  const [preview, setPreview] = useState(false);
  const [activeImage, setActiveImage] = useState("");
  const videoExtensionsRegex = /\.(mp4|mov|avi|wmv)$/i;
  const [isPreviewVideo, setIsPreviewVideo] = useState(false);
  const [attachments, setAttachments] = useState("");
  const [currentVideoIndex, setCurrentVideoIndex] = useState(null);
  const [sidebarToggle] = useOutletContext();
  const [postUndo, setPostUndo] = useState(false);
  const [postUndoId, setPostUndoID] = useState("");
  const [showVideos, setShowVideos] = useState(
    new Array(posts?.length).fill(false)
  );
  const videoRefs = useRef([]);
  const [activeButtons, setActiveButtons] = useState("");
  const [isPortfolioResetModalOpen, setIsPortfolioResetModalOpen] =
    useState(false);
  // The "Start The Comeback" button in the $0 positions-closed email lands on
  // /profile?comeback=1 and opens The Comeback straight away. Own main profile
  // only — that is the one account The Comeback resets.
  useEffect(() => {
    if (
      location.pathname === "/profile" &&
      new URLSearchParams(location.search).get("comeback") === "1"
    ) {
      setIsPortfolioResetModalOpen(true);
    }
  }, [location.pathname, location.search]);
  const [isStripeModalOpen, setIsStripeModalOpen] = useState(false);
  const [clientSecret, setClientSecret] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isFlutterWebViewReady, setIsFlutterWebViewReady] = useState(false);
  const [deviceType, setDeviceType] = useState("Unknown");
  const [showProfileGuide, setShowProfileGuide] = useState(false);
  // Page Tips setting ("Show info icons") from /guide -- gates the green
  // launcher icon the same way FeedPage/NewPortfolioSection already do.
  const [guideIcon, setGuideIcon] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { guideActive: newTraderGuideActive, guideStep: newTraderGuideStep } = useNewTraderGuide();
  const [shouldPersistGuideSetting, setShouldPersistGuideSetting] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [referloading, setReferLoading] = useState(false);
  const [referralCode, setReferralCode] = useState(null);
  const [error, setError] = useState(null);
  //For Video

  const videosRef = useRef({});
  const [playing, setPlaying] = useState({});
  const [isMuted, setIsMuted] = useState(true); // Global mute state
   const [playingVideoId, setPlayingVideoId] = useState(null);
   const [isLoadingVideo, setIsLoadingVideo] = useState(true); // Track loading state
   const hasScrolledRef1 = useRef(false);
  const [pausedVideoId, setPausedVideoId] = useState(null);
  const commentTextareaRef = useRef(null);
  const commentSubmittingRef = useRef(false);
  const commentImageInputRef = useRef(null);
  const commentModalRef = useRef(null);
  // Ensures the one-time profile guide status is checked at most once per mount.
  // Without this guard, ProfileGuideSteps dismissing itself (e.g. no visible
  // targets in the mobile/public layout) flips showProfileGuide back to false,
  // which re-triggers the status fetch and re-shows the guide in an infinite
  // loop — the guide backdrop flashing on/off is the profile-page "flicker".
  const guideStatusCheckedRef = useRef(false);


  const [userReferralCode, setUserReferralCode] = useState("");


useEffect(() => {
  hasScrolledRef1.current = false; // ✅ Reset when route changes
}, [location.pathname]); // ✅ Runs when path changes

  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "g") {
        event.preventDefault();
        setShouldPersistGuideSetting(false);
        setShowProfileGuide(true);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  useEffect(() => {
    const sidebar = document.getElementById('sidebar');
    if (!sidebar) return;

    const checkSidebarOpen = () => {
      const isOpen = !sidebar.classList.contains('-translate-x-full');
      setIsSidebarOpen(isOpen);
    };

    checkSidebarOpen();

    const observer = new MutationObserver(checkSidebarOpen);
    observer.observe(sidebar, { attributes: true, attributeFilter: ['class'] });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const viewingOtherProfile = userId && userId !== user_id;
    // Only check once per mount. Re-running when showProfileGuide toggles back
    // to false (guide self-dismissed) would re-show the guide endlessly.
    if (loading || viewingOtherProfile || guideStatusCheckedRef.current) {
      return;
    }
    guideStatusCheckedRef.current = true;

    const fetchOneTimeGuideStatus = async () => {
      try {
        const response = isMobileView
          ? await getGuideStatusMobile()
          : await getGuideStatus();

        const shouldShow = response?.data?.guide_shown === false ||
          response?.data?.mobile_guide_shown === false;

        if (shouldShow) {
          setShouldPersistGuideSetting(true);
          setShowProfileGuide(true);
        }
      } catch (error) {
        console.log("Error fetching one-time guide status:", error);
      }
    };

    fetchOneTimeGuideStatus();
  }, [isMobileView, loading, userId, user_id]);

  useEffect(() => {
    const fetchGuideIconSetting = async () => {
      try {
        const response = await getGuideSetting();
        if (response?.data?.success && response?.data?.status === 200) {
          setGuideIcon(response?.data?.show_icon);
        }
      } catch (error) {
        console.log("Error fetching guide status:", error);
      }
    };

    fetchGuideIconSetting();
  }, []);

  const handleProfileGuideComplete = async (shouldPersist) => {
    if (shouldPersist) {
      try {
        if (isMobileView) {
          await markGuideAsShownMobile();
        } else {
          await markGuideAsShown();
        }
      } catch (error) {
        console.log("Failed to mark profile guide as shown:", error);
      }
    }
    setShouldPersistGuideSetting(false);
  };



// const handleVideoCanPlay = (id) => {
//   //  alert('tpss');
//   requestAnimationFrame(() => {
//     window.scrollBy(0, 1);
//     requestAnimationFrame(() => window.scrollBy(0, -1)); // Move back up
//   });
//   setIsLoadingVideo((prev) => ({ ...prev, [id]: false }));
// };


  const handleGenerateCode = async () => {
    try {
      setReferLoading(true);
      setError(null);

      const data = await generateReferralCode();
      setReferralCode(data.referral_code);
    } catch (err) {
      console.error(err);
      setError("Failed to generate referral code");
    } finally {
      setReferLoading(false);
    }
  };

const handleVideoCanPlay = (id, isVisible) => {
  const video = videosRef.current[id];
  if (!hasScrolledRef1.current) {
    hasScrolledRef1.current = true; // ✅ Set flag to prevent future runs
    if (isVisible) {
      video.play().catch((e) => console.warn("Autoplay blocked:", e));
      setPlaying((prev) => ({ ...prev, [id]: true }));
    } else {
      video.pause();
      setPlaying((prev) => ({ ...prev, [id]: false }));
    }
  }

  setIsLoadingVideo((prev) => ({ ...prev, [id]: false }));
};

  // useEffect(() => {
  //   const video = videosRef.current[posts.id];
  //   if (video) {
  //     video.load(); // ✅ Force browser to load video immediately
  //   }
  // }, []);

const handleVisibility = (id, isVisible) => {
  const video = videosRef.current[id];
  if (video) {
    if (isVisible) {
      video.play().catch((e) => console.warn("Autoplay blocked:", e));
      setPlaying((prev) => ({ ...prev, [id]: true }));
    } else {
      video.pause();
      setPlaying((prev) => ({ ...prev, [id]: false }));
    }
  }
};


    useEffect(() => {
    if (document.body.clientWidth <= 768) return; // Skip for mobile

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.getAttribute("data-id");
          handleVisibility(id, entry.isIntersecting);
        });
      },
      { threshold: 0.75 } // Trigger when 75% of video is visible
    );

    // ✅ Attach observer to each video
    Object.values(videosRef.current).forEach((video) => {
      if (video) observer.observe(video);
    });

    return () => {
      Object.values(videosRef.current).forEach((video) => {
        if (video) observer.unobserve(video);
      });
      observer.disconnect();
    };
  }, [posts]); // Runs when posts change

const checkVideosInView = () => {
  let newPlayingVideoId = playingVideoId;
  Object.entries(videosRef.current).forEach(([id, video]) => {
    if (video) {
      const rect = video.getBoundingClientRect();
      const videoHeight = rect.bottom - rect.top;
      const videoVisibleHeight = Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top);

      // Check if at least 10% of the video is visible in the viewport
      const isAtLeast10PercentVisible = videoVisibleHeight / videoHeight >= 0.1;
      const completelyOutOfView = rect.bottom <= 0 || rect.top >= window.innerHeight;

      if (isAtLeast10PercentVisible) {
        newPlayingVideoId = id;
      }

      if (completelyOutOfView && playingVideoId === id) {
        video.pause();
        setPausedVideoId(null);
        newPlayingVideoId = null;
      }
    }
  });

  // If a new video should be played, play it and update state
  if (newPlayingVideoId !== playingVideoId) {
    Object.values(videosRef.current).forEach((v) => v?.pause());
    if (newPlayingVideoId) {
      videosRef.current[newPlayingVideoId]?.play().catch(() => console.warn("Autoplay blocked"));
      // setPausedVideoId(null);
    }
    setPlayingVideoId(newPlayingVideoId);

            // 🧠 Clear the play icon if it's no longer on the currently playing video

      if (pausedVideoId && pausedVideoId !== playingVideoId) {
        setPausedVideoId(null);
      }
  }
};

// Attach scroll event listener
useEffect(() => {
  checkVideosInView(); // Check on mount
  window.addEventListener("scroll", checkVideosInView);

  return () => {
    window.removeEventListener("scroll", checkVideosInView);
  };
}, [playingVideoId]);



const togglePlay = (id) => {
  const video = videosRef.current[id];
  if (video) {
    const isPlaying = playing[id] ?? false; // default to false
    if (isPlaying) {
    //  alert('in if');
      video.pause();
      setPausedVideoId(id); // show overlay
    } else {
    //  alert('in else');
      video.play();
      setPausedVideoId(null); // hide overlay
    }

    setPlaying((prev) => ({ ...prev, [id]: !isPlaying }));
  }
};


  // const togglePlay = (id) => {
  //   const video = videosRef.current[id];
  //   if (video) {
  //     if (playing[id]) {
  //       video.pause();
  //     } else {
  //       video.play();
  //     }
  //     setPlaying((prev) => ({ ...prev, [id]: !prev[id] }));
  //   }
  // };

  const toggleMute = () => {
    setIsMuted((prevMuted) => {
      const newMuteState = !prevMuted;
      Object.values(videosRef.current).forEach((video) => {
        if (video) video.muted = newMuteState;
      });
      return newMuteState;
    });
  };



  useEffect(() => {
    const userAgent = navigator.userAgent;

    let device_type = "Unknown";

    if (/Android/i.test(userAgent)) {
      device_type = "A";
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      device_type = "I";
    } else {
      device_type = "W";
    }

    setDeviceType(device_type);

    // Inside the official app or not, from the page's own surface check
    // (public/index.html). The old "isFlutterInAppWebViewReady" storage key is
    // wiped by the app on logout, so after signing in again the iOS app fell
    // through to the Stripe checkout instead of Apple in-app purchase.
    setIsFlutterWebViewReady(
      window.QushiSurface
        ? window.QushiSurface.surface !== "browser"
        : localStorage.getItem("isFlutterInAppWebViewReady") === "true"
    );
  }, []); // Run once when component mounts

  const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

  const stripeResetPromise = getStripe(STRIPE_PUBLISHABLE_KEY);

  function getUserIdFromPath() {
    const path = window.location.pathname; // Get the current path
    const parts = path.split("/"); // Split the path into parts
    return parts[parts.length - 1]; // Return the last part (userId)
  }

  if (slug) {
    userId = getUserIdFromPath();
  }

  useEffect(() => {
    localStorage.setItem("toggle", "true");
    let lightbox = new PhotoSwipeLightbox({
      gallery: ".pswp-gallery",
      children: "a",
      pswpModule: () => import("photoswipe"),
    });
    lightbox.init();

    return () => {
      lightbox.destroy();
      lightbox = null;
    };
    // PhotoSwipe binds its click handler to the .pswp-gallery elements that
    // exist at init. Switching to Holdings / Trade History unmounts the posts
    // list, and coming back renders NEW gallery elements without that handler,
    // so a chart tap fell through to the plain <a href> and opened the raw
    // image — a full-page dead end inside the app. Re-init on tab switch too.
  }, [posts, activeProfileTab]);

  useEffect(() => {
    let commentLightbox = new PhotoSwipeLightbox({
      gallery: ".pswp-comment-gallery",
      children: "a",
      pswpModule: () => import("photoswipe"),
    });
    commentLightbox.init();

    return () => {
      commentLightbox.destroy();
      commentLightbox = null;
    };
  }, [postComments, commentOpenStates, mobileCommentModal]);

  // Track keyboard height so the comment modal slides above the keyboard
  // Also lock body scroll when modal is open to prevent background scrolling
  useEffect(() => {
    if (!mobileCommentModal.isOpen) {
      setKeyboardHeight(0);
      document.body.style.overflow = '';
      return;
    }

    document.body.style.overflow = 'hidden';

    const handleViewportResize = () => {
      if (window.visualViewport) {
        const viewportHeight = window.visualViewport.height;
        const windowHeight = window.innerHeight;
        const kbHeight = windowHeight - viewportHeight;
        setKeyboardHeight(Math.max(0, kbHeight));

        // Ensure input stays visible after keyboard resize
        if (kbHeight > 0 && commentTextareaRef.current) {
          setTimeout(() => {
            commentTextareaRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
          }, 100);
        }
      }
    };

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', handleViewportResize);
      window.visualViewport.addEventListener('scroll', handleViewportResize);
      handleViewportResize();
    }

    return () => {
      document.body.style.overflow = '';
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', handleViewportResize);
        window.visualViewport.removeEventListener('scroll', handleViewportResize);
      }
    };
  }, [mobileCommentModal.isOpen]);

  // Block background scroll when comment modal is open (non-passive listener required)
  useEffect(() => {
    const modalEl = commentModalRef.current;
    if (!mobileCommentModal.isOpen || !modalEl) return;

    const handleTouchMove = (e) => {
      // Allow scrolling inside the comment textarea, but contain it
      const textarea = e.target.closest('textarea');
      if (textarea) {
        const atTop = textarea.scrollTop <= 0;
        const atBottom = textarea.scrollTop + textarea.clientHeight >= textarea.scrollHeight - 1;
        const isScrollingUp = e.touches[0].clientY > (handleTouchMove._lastY || 0);
        const isScrollingDown = e.touches[0].clientY < (handleTouchMove._lastY || 0);
        handleTouchMove._lastY = e.touches[0].clientY;

        // If textarea is scrollable (content overflows), allow internal scroll
        const isScrollable = textarea.scrollHeight > textarea.clientHeight;
        if (isScrollable) {
          // Block only when at boundary to prevent outer feed from scrolling
          if ((atTop && isScrollingUp) || (atBottom && isScrollingDown)) {
            e.preventDefault();
          }
          // Otherwise let it scroll naturally within the textarea
        } else {
          // Textarea has no overflow, block to prevent outer scroll
          e.preventDefault();
        }
        return;
      }

      const scrollable = modalEl.querySelector('[data-comment-scroll]');
      if (scrollable && scrollable.contains(e.target)) {
        const atTop = scrollable.scrollTop <= 0;
        const atBottom = scrollable.scrollTop + scrollable.clientHeight >= scrollable.scrollHeight;
        const isScrollingUp = e.touches[0].clientY > (handleTouchMove._lastY || 0);
        const isScrollingDown = e.touches[0].clientY < (handleTouchMove._lastY || 0);
        handleTouchMove._lastY = e.touches[0].clientY;

        if ((atTop && isScrollingUp) || (atBottom && isScrollingDown)) {
          e.preventDefault();
        }
      } else {
        e.preventDefault();
      }
    };

    modalEl.addEventListener('touchmove', handleTouchMove, { passive: false });
    return () => {
      modalEl.removeEventListener('touchmove', handleTouchMove);
    };
  }, [mobileCommentModal.isOpen]);

  useEffect(() => {
    if (userId) {
      if (userId !== user_id) {
        setTraderProfile(true);
      } else {
        setTraderProfile(false);
      }
    } else {
      setTraderProfile(false);
    }
  }, [userId, user_id]);

  useEffect(() => {
    if (!isDataFeteched) getCards();
  }, [isDataFeteched]);

  useEffect(() => {
    if (!isDataFeteched1) fetchProfile();
  }, [userId, isDataFeteched1]);

  // Identity from cache, synchronously on mount — the header is on screen before
  // the first byte of the profile response arrives.
  useEffect(() => {
    const cached = readCachedIdentity();
    if (cached) {
      setProfile((prev) => (prev?.id ? prev : cached));
      setUserImg((prev) => prev || cached.image);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Posts, in parallel with the profile. The ref guard keeps this to exactly one
  // initial fetch — fetchPost advances `page`, so a double call would skip a
  // page of results.
  useEffect(() => {
    if (!targetUserId || initialPostsStartedRef.current) return;
    initialPostsStartedRef.current = true;
    fetchPost(targetUserId, 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetUserId]);

  useEffect(() => {
    if (!isDataFeteched2) fetchTrading();
  }, [isDataFeteched2]);

  useEffect(() => {
    if (!isDataFeteched3) fetchSetting();
  }, [isDataFeteched3]);

  // Used for dismiss a modal
  useEffect(() => {
    const handleDismissEvent = () => {
      setIsPortfolioResetModalOpen(false);
    };

    window.addEventListener("myDismissModalEvent", handleDismissEvent);

    return () => {
      window.removeEventListener("myDismissModalEvent", handleDismissEvent);
    };
  }, []);

    useEffect(() => {
    const fetchReferralCode = async () => {
      try {
        const response = await getUserReferralCode();
        if (response?.data?.referral_code) {
          setUserReferralCode(response.data.referral_code);
        } else {
          console.warn("No referral code found for user");
        }
      } catch (error) {
        console.error("Failed to fetch referral code:", error);
      }
    };

    fetchReferralCode();
  }, []);

  const handleImageLoaded = (event, imageIndex) => {
    const image = event.target;
    const linkElement = image.closest("a");
    linkElement.setAttribute("data-pswp-width", image.naturalWidth);
    linkElement.setAttribute("data-pswp-height", image.naturalHeight);
  };

  const handleLoadMore = async () => {
    try {
      const body = { user_id: userId ? userId : user_id, page };
      // Page 2 onwards has to carry the same scope as page 1, or an infinite
      // scroll inside a league would start pulling in main-app posts.
      if (game_id) body.game_id = game_id;
      setLoader(true);
      const response = await getMyPost(body);
      if (response?.data?.status === 200) {
        setPosts((prevPosts) => [...prevPosts, ...response.data.data.data]);
        setPage((pagePre) => pagePre + 1);
        setLoader(false);
      } else {
        setHasMore(false);
        setLoader(false);
      }
    } catch (error) {
      console.error("Error fetching more data:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
    // setItemsPerPage(itemsPerPage + 10);
    // setPage(page + 1);
    // const body = { user_id: userId ? userId : user_id, page };
    // try {
    //   const response = await getMyPost(body);
    //   if (response?.data?.status == 200) {
    //     setPosts((prevPosts) => [...prevPosts, ...response.data.data.data]);
    //     setlast_page(response?.data?.data?.last_page);
    //     setLoading(false);
    //   }
    // } catch (error) {
    //   console.error("Error:", error);
    // }
  };

  const getCards = async () => {
    const res = await getPaymentCardsApi();
    if (res?.data?.status === 200) {
      const card = res?.data?.data?.data.find((val) => val.is_active);
      setIsChecked(card?.is_active);
      setCards(res?.data?.data?.data);
      setisDataFeteched(true);
    } else {
      setisDataFeteched(false);
    }
  };

  const fetchProfile = async () => {
    setProfileLoadFailed(false);
    try {
      let response;
      if (profile_id) {
        response = await getProfile(profile_id, game_id);
      } else if (userId) {
        response = await getProfile(userId, game_id);
      } else {
        response = await getProfile();
      }
      if (response?.data?.data) {
        setisDataFeteched1(true);
        const profileData = response.data.data;
        if (!userId) {
          localStorage.setItem(
            "userInfo",
            JSON.stringify(response?.data?.data)
          );
          localStorage.setItem("img", response?.data?.data?.image);
          const myCustomEvent = new CustomEvent("profileEvent", {
            detail: {
              profileImg: response?.data?.data?.image,
              profileData: response?.data?.data,
            },
          });
          window.dispatchEvent(myCustomEvent);
        }

        setProfile(profileData);
        setUserImg(profileData.image);
        // Reveal the header the moment the profile itself is in hand.
        setProfileFresh(true);
        setLoading(false);
        // Fallback only: if no id was resolvable at mount, the parallel effect
        // above never ran, so start posts here off the id we just learned.
        if (!initialPostsStartedRef.current) {
          initialPostsStartedRef.current = true;
          fetchPost(profileData.id, 1);
        }
      } else {
        // A 200 with no payload used to leave `loading` true forever, which is
        // now an endless skeleton. Treat it as a load failure.
        setLoading(false);
        setProfileLoadFailed(true);
      }
    } catch (error) {
      setLoading(false);
      setisDataFeteched1(false);
      setProfileLoadFailed(true);
      console.error("Error:", error);
    }
  };

  // Retry entry point for the page error state.
  const retryProfile = () => {
    setLoading(true);
    setPostsLoading(true);
    // Let the posts request run again on retry.
    initialPostsStartedRef.current = false;
    setProfileFresh(false);
    setProfileLoadFailed(false);
    setisDataFeteched1(false);
  };

  const fetchTrading = async () => {
    try {
      const response = await tradingType();
      if (response) {
        setisDataFeteched2(true);
        setTrade(response.data.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleFollow = async (id) => {
    const body = {
      user_uuid: id,
      request_status: 2,
    };
    setIsDisabled(true);
    try {
      const response = await followUnfollow(body);

      if (response.status === 200) {
        if (response.data.status === 400) {
          setIsDisabled(false);
          toast.error(response.data.message);
        } else {
          setIsDisabled(false);
          fetchProfile();
        }
      }
    } catch (error) {
      setIsDisabled(false);
      console.error("Error:", error);
    }
  };

  const handleUnfollow = async (id) => {
    const body = {
      user_uuid: id,
      request_status: 1,
    };
    setIsDisabled(true);
    try {
      const response = await followUnfollow(body);
      if (response.status === 200) {
        setIsDisabled(false);
        fetchProfile();
      }
    } catch (error) {
      console.error("Error:", error);
      setIsDisabled(false);
    }
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleMouseEnter1 = () => {
    setIsHovered1(true);
  };

  const handleMouseLeave1 = () => {
    setIsHovered1(false);
  };

  const handleMouseEnter2 = () => {
    setIsHovered2(true);
  };

  const handleMouseLeave2 = () => {
    setIsHovered2(false);
  };

  const renderButton = () => {
    if (userId) {
      return (
        <div
          className={
            isMobileView
              ? "flex flex-col"
              : "flex flex-col mx-4 md:flex-row md:space-x-2 md:mx-20"
          }
        >
          <div className="flex-grow">
            {profile?.is_follow_by_me ? (
              <button
                onClick={() => handleUnfollow(profile.uuid)}
                disabled={isDisabled ? true : false}
                type="button"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                style={{
                  color: isHovered ? "white" : "#004c50",
                  background: isHovered ? "#004C50" : "white",
                  width: "100%",
                  border: "1px solid #004c50",
                  borderRadius: "8px",
                  fontSize: "0.875rem",
                  padding: "0.59rem 1.05rem",
                  textAlign: "center",
                  // marginRight: '0.5rem',
                  marginBottom: "0.5rem",
                  outline: "none",
                  transition: "background-color 0.2s, border-color 0.2s",
                }}
                className="font-bold"
                // className="text-primaryColor bg-white w-full hover:text-white border border-primaryColor hover:bg-primaryColor focus:ring-4 focus:outline-none focus:ring-green-300 rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-primaryColor dark:text-primaryColor dark:hover:text-white dark:hover:primaryColor dark:focus:ring-green-800 font-bold bg-primaryColor dark:bg-primaryColor"
              >
                FOLLOWING
              </button>
            ) : (
              <button
                type="button"
                onClick={() => handleFollow(profile.uuid)}
                disabled={isDisabled ? true : false}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                style={{
                  color: isHovered ? "white" : "#004c50",
                  background: isHovered ? "#004C50" : "white",
                  width: "100%",
                  border: "1px solid #004c50",
                  borderRadius: "8px",
                  fontSize: "0.875rem",
                  padding: "0.59rem 1.05rem",
                  textAlign: "center",
                  // marginRight: '0.5rem',
                  marginBottom: "0.5rem",
                  outline: "none",
                  transition: "background-color 0.2s, border-color 0.2s",
                }}
                className="font-bold"
                // className="text-primaryColor w-full hover:text-white border border-primaryColor hover:bg-primaryColor focus:ring-4 focus:outline-none focus:ring-green-300 rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-primaryColor dark:text-primaryColor dark:hover:text-white dark:hover:primaryColor dark:focus:ring-green-800 font-bold"
              >
                FOLLOW
              </button>
            )}
          </div>
          <div className="flex-grow">
            <button
              type="button"
              onClick={() => handleclick(profile)}
              onMouseEnter={handleMouseEnter1}
              onMouseLeave={handleMouseLeave1}
              style={{
                color: isHovered1 ? "white" : "#004c50",
                background: isHovered1 ? "#004C50" : "white",
                width: "100%",
                border: "1px solid #004c50",
                borderRadius: "8px",
                fontSize: "0.875rem",
                padding: "0.59rem 1.05rem",
                textAlign: "center",
                // marginRight: '0.5rem',
                marginBottom: "0.5rem",
                outline: "none",
                transition: "background-color 0.2s, border-color 0.2s",
              }}
              className="font-bold"
              // className="text-primaryColor w-full hover:text-white border border-primaryColor hover:bg-primaryColor focus:ring-4 focus:outline-none focus:ring-green-300 rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-primaryColor dark:text-primaryColor dark:hover:text-white dark:hover:primaryColor dark:focus:ring-green-800 font-bold"
            >
              MESSAGE
            </button>
          </div>
          {profile?.green_tick && SUBSCRIPTION_ENABLED && (
            <div
              className="flex-grow"
              onClick={() => {
                if (profile?.is_subscribed) {
                  navigate(`/paid-content/${userId}`);
                }
              }}
            >
              <button
                type="button"
                onClick={() => {
                  fetchPaidPost(profile?.id);
                }}
                className="text-primaryColor w-full hover:text-white border border-primaryColor hover:bg-primaryColor focus:ring-4 focus:outline-none focus:ring-green-300 rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-primaryColor dark:text-primaryColor dark:hover:text-white dark:hover:primaryColor dark:focus:ring-green-800 font-bold"
              >
                PAID CONTENT
              </button>
            </div>
          )}
        </div>
      );
    }
    return null;
  };

  const fetchPaidPost = async (id) => {
    // Region flag only. This used to set the PAGE flag, which blanked an
    // already-rendered profile back to a full-screen spinner.
    setPostsLoading(true);
    const body = { user_id: id, post_status: 2 };
    try {
      const response = await getPaidPost(body);
      if (response.data.status === 400) {
        toast.error(response.data.message);
      } else {
        setPosts(response.data.data.data);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setPostsLoading(false);
    }
  };

  const handleclick = (chat) => {
    // console.log(chat, "chat");
    localStorage.setItem("id", chat.id);
    localStorage.setItem("image", chat.image);

    if (game_id) {
      navigate(`/${slug}/chatHistory/${chat.id}`);
    } else {
      navigate(`/chatHistory/${chat.id}`);
    }
  };

  const handleCommentToggle = async (index, id, isOpen) => {
    // For mobile devices, open the modal instead of inline comments
    if (isMobileView) {
      setMobileCommentModal({
        isOpen: true,
        postId: id,
        postIndex: index,
      });
      // Fetch comments for the modal
      setLoadingComment(true);
      try {
        const response = await getComment(id);
        if (response?.status === 200) {
          const sortedChats = response?.data?.data.sort(
            (a, b) => new Date(a.created_at) - new Date(b.created_at)
          );
          setPostComments((prevComments) => ({
            ...prevComments,
            [id]: sortedChats,
          }));
        }
      } catch (error) {
        console.error("Error fetching comments:", error);
      } finally {
        setLoadingComment(false);
      }
      return;
    }

    // Desktop behavior - keep existing inline logic
    setLoadingComment(true);
    try {
      isOpen = isOpen !== undefined ? isOpen : !commentOpenStates[index];

      if (!isOpen) {
        setCommentOpenStates((prevStates) => ({
          ...prevStates,
          [index]: false,
        }));
        return;
      }
      const response = await getComment(id);
      if (response.status === 200) {
        setTimeout(() => {
          setLoadingComment(false);
        }, 1000);
        setCommentOpenStates((prevStates) => {
          const newState = {};
          Object.keys(prevStates).forEach((key) => {
            newState[key] = false;
          });
          return newState;
        });

        const sortedChats = response?.data?.data.sort(
          (a, b) => new Date(a.created_at) - new Date(b.created_at)
        );

        setPostComments((prevComments) => ({
          ...prevComments,
          [id]: sortedChats,
        }));

        setCommentOpenStates((prevStates) => ({
          ...prevStates,
          [index]: isOpen,
        }));
      }
    } catch (error) {
      setLoadingComment(false);
      console.error("Error fetching comments:", error);
    }
  };

  const handleAddComment = async (postId, index) => {
    if (commentSubmittingRef.current) return; // Prevent duplicate submissions

    if (newComment.length <= 255 && (newComment.trim() || commentImage)) {
      commentSubmittingRef.current = true;
      setIsDisabled(true);

      const formData = new FormData();
      formData.append('post_id', postId);
      if (replyingTo) formData.append('parent_id', replyingTo.commentId);
      if (newComment.trim()) formData.append('comment', newComment);
      if (commentImage) formData.append('image', commentImage);

      try {
        const response = await addComment(formData);
        // console.log(response, "res");
        if (response.status === 200) {
          if (response.data?.data?.moderation_status === 'pending_review') {
            toast.success(response.data?.data?.message);
          }

          // Auto-expand replies for the parent being replied to
          if (replyingTo) {
            setExpandedReplies((prev) => ({ ...prev, [replyingTo.commentId]: true }));
          }

          fetchPost(profile.id, 1);

          // For mobile modal, refresh comments in the modal
          if (isMobileView && mobileCommentModal.isOpen && mobileCommentModal.postId) {
            const commentsResponse = await getComment(mobileCommentModal.postId);
            if (commentsResponse?.status === 200) {
              const sortedChats = commentsResponse?.data?.data.sort(
                (a, b) => new Date(a.created_at) - new Date(b.created_at)
              );
              setPostComments((prevComments) => ({
                ...prevComments,
                [mobileCommentModal.postId]: sortedChats,
              }));
              // Update post comment count in posts array
              setPosts((prevPosts) =>
                prevPosts.map((post) => {
                  if (post?.repost?.id === mobileCommentModal.postId) {
                    return {
                      ...post,
                      repost: {
                        ...post.repost,
                        comments_count: (post.repost.comments_count || 0) + 1,
                      },
                    };
                  } else if (post.id === mobileCommentModal.postId) {
                    return {
                      ...post,
                      comments_count: (post.comments_count || 0) + 1,
                    };
                  }
                  return post;
                })
              );
            }
          } else {
            await getComment(postId);
            handleCommentToggle(index, postId, true);
            setCommentOpenStates((prevStates) => ({
              ...prevStates,
              [postId]: false,
            }));
          }

          setIsDisabled(false);
          setNewComment("");
          setCommentImage(null);
          setCommentImagePreview(null);
          setReplyingTo(null);
          if (commentTextareaRef.current) {
            commentTextareaRef.current.style.height = 'auto';
          }
        }
        if (!response.ok) {
          setIsDisabled(false);
        }
      } catch (error) {
        setIsDisabled(false);
        if (!error.response?.status) {
          toast.error("Could not post the comment. Try again.");
        }
        console.error(error);
      } finally {
        commentSubmittingRef.current = false;
      }
    } else {
      toast.error("Comment must be 255 characters or fewer.");
    }
  };

  const handleReply = (comment, postId) => {
    setReplyingTo({ commentId: comment.id, userName: comment.user.user_name, postId });
    setNewComment(`@${comment.user.user_name} `);
    if (commentTextareaRef.current) {
      commentTextareaRef.current.focus();
    }
  };

  const handleCancelReply = () => {
    setReplyingTo(null);
    setNewComment("");
  };

  const toggleReplies = (commentId) => {
    setExpandedReplies((prev) => ({ ...prev, [commentId]: !prev[commentId] }));
  };

  const fetchPost = async (id, page) => {
    // Item 13. get-all-post already understands game_id — the endpoint applies
    // `where('game_id', …)` alongside the user filter, so one extra key gives a
    // league-scoped profile feed with no backend change. Without it the request
    // came back with the user's WHOLE record (measured on user 437: 136 posts,
    // of which only 15 belong to league 352) and the browser threw the league
    // ones away, which is why the tab looked empty.
    const body = { user_id: id, page };
    if (game_id) body.game_id = game_id;
    try {
      const response = await getMyPost(body);
      if (response?.data?.status == 200) {
        setPosts(response?.data?.data?.data);
        setPage((pagePre) => pagePre + 1);
        setlast_page(response?.data?.data?.last_page);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      // Posts only. The page itself was already revealed by fetchProfile.
      setPostsLoading(false);
    }
  };

  const handleSavePost = async (postId) => {
    const postssss = posts.map((val) => {
      if (!val?.repost?.id && val?.id == postId) {
        val.is_saved = !val.is_saved;
      } else if (val?.repost?.id == postId) {
        val.repost.is_saved = !val.repost.is_saved;
      }
      return val;
    });
    setPosts(postssss);
    // console.log(postId);
    setIsDisabled(true);
    try {
      // Make API call to update like/dislike status
      const response = await savePost(postId);
      // console.log(response, "res");
      if (response.status === 200) {
        // toast.success(response.data.message);
        fetchPost(postId, 1);
        setIsDisabled(false);
      }
      if (response.status !== 200) {
        setIsDisabled(false);
        const postssss = posts.map((val) => {
          if (val?.id == postId) {
            val.is_saved = false;
          } else if (val?.repost?.id == postId) {
            val.repost.is_saved = false;
          }
          return val;
        });
        setPosts(postssss);
        throw new Error("Failed to save post");
      }
    } catch (error) {
      setIsDisabled(false);
      console.error(error);
      // Handle error
    }
  };

  const handleLikeDislike = async (postId, isLiked) => {
    const postssss = posts.map((val) => {
      if (!val?.repost?.id && val?.id == postId) {
        val.is_like_by_me = !val.is_like_by_me;
        val.total_likes =
          val.is_like_by_me == true ? val.total_likes + 1 : val.total_likes - 1;
      } else if (val?.repost?.id == postId) {
        val.repost.is_like_by_me = !val.repost.is_like_by_me;
        val.repost.total_likes =
          val.repost.is_like_by_me == true
            ? val.repost.total_likes + 1
            : val.repost.total_likes - 1;
      }
      return val;
    });
    setPosts(postssss);
    setIsDisabled(true);
    try {
      const response = await likeDislike(postId);
      // console.log(response, "res");
      if (response.status === 200) {
        // toast.success(response.data.message);
        fetchPost(profile.id, 1);
        setIsDisabled(false);
      }
      if (response.status !== 200) {
        const postssss = posts.map((val) => {
          if (val?.id == postId) {
            val.is_like_by_me = false;
            val.total_likes = val.total_likes > 0 ? val.total_likes - 1 : 0;
          } else if (val?.repost?.id == postId) {
            val.repost.is_like_by_me = false;
            val.repost.total_likes =
              val.repost.total_likes > 0 ? val.repost.total_likes - 1 : 0;
          }
          return val;
        });
        setPosts(postssss);
        setIsDisabled(false);
        throw new Error("Failed to update like/dislike status");
      }
    } catch (error) {
      const postssss = posts.map((val) => {
        if (val?.id == postId) {
          val.is_like_by_me = false;
          val.total_likes = val.total_likes > 0 ? val.total_likes - 1 : 0;
        } else if (val?.repost?.id == postId) {
          val.repost.is_like_by_me = false;
          val.repost.total_likes =
            val.repost.total_likes > 0 ? val.repost.total_likes - 1 : 0;
        }
        return val;
      });
      setPosts(postssss);
      setIsDisabled(false);
      console.error(error);
      // Handle error
    }
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleDeletePost = async (postId) => {
    setOpenMenuPostId(null);
    handleOpenModal();
    setNewId(postId);
  };

  const handleEditClick = (postId, createdAt) => {
    setOpenMenuPostId(null);
    if (isPostLocked(createdAt)) {
      toast.error("This post is locked. Your call is on the record.");
      return;
    }
    navigate(`/edit-post/${postId}`);
  };

  // Owner-only: pin / unpin a post to the profile. One pinned post per user —
  // the backend unpins the previous one. Refetch so the pinned post jumps to
  // the top of the feed with the "Pinned post" badge.
  const handlePinPost = async (postId) => {
    setOpenMenuPostId(null);
    try {
      const response = await pinPost(postId);
      if (response?.status === 200) {
        setPage(1);
        fetchPost(userId ? userId : user_id, 1);
      }
    } catch (error) {
      console.error("Error pinning post:", error);
      toast.error("Could not update the pinned post. Try again.");
    }
  };

  // Group current holdings by symbol, summing position value (qty x buy price),
  // and return the 3 largest positions descending — for the Overview tab.
  const computeTopHoldings = (rows) => {
    const map = {};
    (rows || []).forEach((t) => {
      const sym = t?.stock_symbol;
      if (!sym) return;
      const qty = parseFloat(t.order_quantity) || 0;
      const price = parseFloat(t.order_price) || 0;
      if (!map[sym]) {
        map[sym] = {
          stock_symbol: sym,
          company_name: t.company_name,
          quantity: 0,
          value: 0,
        };
      }
      map[sym].quantity += qty;
      map[sym].value += qty * price;
    });
    return Object.values(map)
      .sort((a, b) => b.value - a.value)
      .slice(0, 3);
  };

  useEffect(() => {
    if (!targetUserId) return undefined;
    let cancelled = false;
    setTopHoldingsLoading(true);
    (async () => {
      try {
        const res = await getOrder(3, targetUserId, null);
        if (!cancelled && res?.data?.status === 200) {
          setTopHoldings(computeTopHoldings(res?.data?.data?.data || []));
        }
      } catch (error) {
        console.error("top holdings fetch failed", error);
      } finally {
        if (!cancelled) setTopHoldingsLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetUserId]);

  // Shared Top Holdings content (header + list). Wrapped differently for the
  // mobile in-feed placement vs the desktop right-rail card.
  const renderTopHoldings = () => (
    <>
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-base font-bold text-gray-900">Top Holdings</h3>
        <button
          type="button"
          onClick={() =>
            setActiveProfileTab(
              !showPublicLayout && isMobileView ? "portfolio" : "holdings"
            )
          }
          className="text-sm font-semibold text-primaryColor hover:underline"
        >
          View all
        </button>
      </div>
      {topHoldingsLoading ? (
        <ListSkeleton
          rows={3}
          avatar={false}
          columns={1}
          columnWidths={[72]}
          divided={false}
          rowClassName="py-2.5"
          label="Top holdings loading"
        />
      ) : topHoldings.length === 0 ? (
        <p className="text-sm text-gray-500">No holdings yet.</p>
      ) : (
        <div className="divide-y divide-gray-100">
          {topHoldings.map((h) => (
            <div
              key={h.stock_symbol}
              className="flex items-center justify-between py-2.5"
            >
              <div className="min-w-0 pr-3">
                <p className="text-sm font-semibold text-gray-900">
                  {baseSymbol(h.stock_symbol)}
                </p>
                <p className="text-xs text-secondary truncate">
                  {instrumentName({ name: h.company_name, symbol: h.stock_symbol })}
                </p>
              </div>
              <div className="flex items-center gap-3 flex-shrink-0">
                <div className="text-right">
                  <p className="text-sm font-semibold text-gray-900">
                    $
                    {h.value.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </p>
                  <p className="text-xs text-gray-500">
                    {h.quantity.toLocaleString("en-US")} shares
                  </p>
                </div>
                <HoldingSparkline symbol={h.stock_symbol} />
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );

  const handleClick = () => {
    setActiveButtons("EditProfile");
    navigate("/edit-profile");
  };

  const userInfo = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : {};

  const handleDelete = async () => {
    setIsDisabled(true);
    try {
      const response = await deletePost(newid);
      if (response.status === 200) {
        setIsDisabled(false);
        setPosts((prevPosts) =>
          prevPosts.filter((post) =>
            post?.repost?.id ? post?.repost?.id !== newid : post.id !== newid
          )
        );
        toast.success("Post deleted.");
        fetchPost(profile.id, 1);
        handleCloseModal();
      } else {
        setIsDisabled(false);
        throw new Error("Failed to delete the post");
      }
    } catch (error) {
      setIsDisabled(false);
      console.error(error);
      toast.error("Could not delete the post. Try again.");
    }
  };

  // One menu at a time: opening a post's menu replaces whichever was open.
  const toggleDropdown = (postId) => {
    setOpenMenuPostId((prev) => (prev === postId ? null : postId));
  };

  // Close the open post menu on an outside click / tap or Esc.
  useEffect(() => {
    if (openMenuPostId === null) return undefined;
    const onPointer = (e) => {
      if (!e.target.closest?.("[data-post-menu]")) setOpenMenuPostId(null);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpenMenuPostId(null);
    };
    document.addEventListener("mousedown", onPointer);
    document.addEventListener("touchstart", onPointer);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onPointer);
      document.removeEventListener("touchstart", onPointer);
      document.removeEventListener("keydown", onKey);
    };
  }, [openMenuPostId]);

  // Switching profile tabs closes it too.
  useEffect(() => {
    setOpenMenuPostId(null);
  }, [activeProfileTab]);
  // const toggleDropdown = (index) => {
  //   setDropdownStates(prevStates => {
  //     const newDropdownStates = prevStates.map((state, i) => {
  //       // Close any other open dropdown except for the clicked one
  //       return i === index ? !state : false;
  //     });
  //     return newDropdownStates;
  //   });
  // };
  // const toggleDescription = () => {
  //   setShowFullDescription(!showFullDescription);
  // };

  const handleUndoRepost = async () => {
    try {
      const res = await undoRepostPost(postUndoId);
      if (res.status === 200) {
        fetchPost(profile.id, 1);
        setPostUndo(false);
        setIsDisabled(false);
      }
      if (!res.ok) {
        setIsDisabled(false);
      }
    } catch (error) {
      setIsDisabled(false);
      console.error(error);
    }
  };

  const handleUndoCancel = () => {
    setPostUndo(false);
  };

  const handleRepost = async (postId, obj, id) => {
    if (obj?.repost?.id) {
      setPostUndoID(id);
      setPostUndo(true);
    } else {
      setIsDisabled(true);
      try {
        const response = await repostPost(postId);
        if (response.status === 200) {
          fetchPost(profile.id, 1);
          setIsDisabled(false);
        }
        if (!response.ok) {
          setIsDisabled(false);
          throw new Error("Failed to update like/dislike status");
        }
      } catch (error) {
        setIsDisabled(false);
        console.error(error);
      }
    }
  };

  const handleSubscription = () => {
    setIsSubscribe(true);
  };

  const handleSubscribeCard = () => {
    setIsOpenCardModal(true);
    setIsSubscribe(false);
  };

  const handleSubscribeCancel = () => {
    setIsSubscribe(false);
  };

  const fetchSetting = async () => {
    try {
      const response = await getSettings();
      if (response) {
        setisDataFeteched3(true);
        setStripeKey(response.data.data.pk_key);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handlePaymentCard = async (val) => {
    if (cards && cards.length > 0) {
      setIsButtonDisabled(true);
      const card = cards.find((val) => val.is_active);
      const obj = {
        payment_method_id: card?.id,
        follower_id: userId,
        // "type":"card",
        // "token":"tok_visa",
        // "name_on_card":val.name_on_card,
        // "last_four_digit":"5678"
      };
      const res = await makePaymentApi(obj);
      if (res?.data?.status === 200) {
        setIsSubscribe(false);
        setIsOpenCardModal(false);
        setIsAddModalOpen(false);
        fetchProfile();
        setIsButtonDisabled(false);
        toast.success(res?.data?.message);
      } else {
        setIsButtonDisabled(false);
        toast.error(res?.data?.message);
      }
    } else {
      setIsButtonDisabled(false);
      toast.error("You have to add a card to make payments");
    }
  };

  const handlePaymentCancel = () => {
    setIsSubscribe(false);
    setIsOpenCardModal(false);
    setIsAddModalOpen(false);
  };

  const handlePrimaryValue = async (val) => {
    const res = await setPrimaryMethod(val?.id);
    if (res?.data?.status === 200) {
      getCards();
    } else {
      toast.error(res?.data?.message);
    }
  };

  const handleDeleteComment = async (id) => {
    setIsDisabled(true);
    try {
      const response = await deleteComment(id);
      if (response.status === 200) {
        // toast.success("Comment deleted successfully");
        fetchPost(profile?.id, 1);
        handleCommentToggle(true);
        setLoading(false);
        setIsDisabled(false);
      } else {
        setIsDisabled(false);
        throw new Error("Failed to delete the post");
      }
    } catch (error) {
      setLoading(false);
      setIsDisabled(false);
      console.error(error);
    }
  };
  const selectedTradingStyle =
    (trading &&
      trading.length > 0 &&
      trading.find((option) => option.id === profile.trading_type_id)?.type) ||
    "";

  // const handleShare = async (id) => {
  //   const urlToShare = `https://app.qushi.io/feed/${id}`;

  //   const shareData = {
  //     title: "QUSHI",
  //     text: "Check out this!",
  //     url: urlToShare,
  //   };

  //   try {
  //     if (navigator.share) {
  //       await navigator.share(shareData);
  //       // console.log("Data was shared successfully");
  //     } else {
  //       // Fallback for browsers that do not support navigator.share
  //       // You could copy the link to clipboard or display a modal with share options
  //       console.error("Web Share API is not supported in your browser.");
  //     }
  //   } catch (err) {
  //     console.error("Error sharing:", err);
  //   }
  // };


  const handleShare = async (id) => {
    const urlToShare = `https://app.qushi.io/feed/${id}`;

    const shareData = {
      title: "QUSHI",
      text: "Check out this!",
      url: urlToShare,
    };
    // Inside the QUSHi app the native sheet is Flutter's to open, over the
    // WebView — see utils/shareLink.js. This side must never open one there, or
    // the WebView's scroll view comes back broken. Browser paths below unchanged.
    if (shareViaFlutter(shareData)) return;
    try {
      if (navigator.share) {
        await navigator.clipboard.writeText(urlToShare);
        await navigator.share(shareData);
      } else {
        const el = document.createElement("textarea");
        el.value = urlToShare;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        const shareLinkPrompt = `Link copied\nShare this link: ${urlToShare}`;
        alert(shareLinkPrompt);
      }
    } catch (err) {
      console.error("Error sharing:", err);
    }
  };

  useEffect(() => {
    if (!posts || posts.length === 0) return;
    posts.forEach((post) => {
      const postId = post?.repost?.id || post.id;
      const description = post?.description;
      if (!description || linkPreviewData[postId] !== undefined) return;
      const url = extractFirstUrl(description);
      if (!url) return;
      let domain = null;
      try { domain = new URL(url).hostname.replace(/^www\./, ""); } catch {}
      const minimal = { url, site_name: domain, title: null, description: null, image: null, _loading: true };
      setLinkPreviewData((prev) => ({ ...prev, [postId]: minimal }));
      getLinkPreview(url)
        .then((data) => {
          const resolved = data && (data.title || data.description || data.image)
            ? data
            : { url, site_name: data?.site_name || domain, title: null, description: null, image: null };
          setLinkPreviewData((prev) => ({ ...prev, [postId]: resolved }));
        })
        .catch(() => {
          setLinkPreviewData((prev) => ({ ...prev, [postId]: { url, site_name: domain, title: null, description: null, image: null } }));
        });
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [posts]);

  const renderTextWithLinks = (text, hideUrl = false) => {
    if (!text) return null;
    // Posts now store sanitized B/I/U HTML. When a link-preview card is shown
    // for this post, strip the bare URL text so it isn't duplicated.
    const str = hideUrl
      ? String(text).replace(/https?:\/\/[^\s<]+/g, "")
      : String(text);
    return (
      <span
        className="post-content"
        dangerouslySetInnerHTML={{ __html: renderPostHtml(str) }}
      />
    );
  };

  const renderDescriptionDynamicLineBreaks = (description) => {
    // Check if description is null or undefined
    if (!description || description == null) {
      return null;
    }

    // Regular expression to match one or more newline characters
    const regex = /(\n+)/g;

    // Split the description by the regex, keeping the delimiter
    const parts = description.split(regex);

    return parts.map((part, index) => {
      if (part.match(regex)) {
        // For newline characters, return a series of <br /> elements equal to the count of \n minus 1
        return [...Array(part.length - 1)].map((_, brIndex) => (
          <br key={`br-${index}-${brIndex}`} />
        ));
      } else {
        // For regular text, return a paragraph
        return <p key={`text-${index}`}>{part}</p>;
      }
    });
  };
  const handleLinkClick = (link) => {
    const flutterMobile = localStorage.getItem("isFlutterInAppWebViewReady");
    if (flutterMobile) {
      event("profile", link);
    }
  };
  const portfolioNavi = (cash) => {
    if (userId && !game_id) {
      localStorage.setItem("totalCash", cash);
      navigate(`/portfolio/${userId}`, {
        state: { game_id: game_id },
      });
    } else if (userId && game_id) {
      localStorage.setItem("totalCash", cash);

      if (game_id) {
        navigate(`/${slug}/portfolio/${profile_id}`);
      } else {
        navigate(`/portfolio`);
      }
    } else {
      navigate(`/portfolio`);
    }
  };

  const navigateToFollowers = (user_name) => {
    if (!game_id) {
      if (userId) {
        navigate(`/followers/${userId}`, { state: { user_name } });
      } else {
        navigate(`/followers/${user_id}`, { state: { user_name } });
      }
    }
    if (game_id) {
      if (userId) {
        navigate(`/${slug}/followers/${userId}`, { state: { user_name } });
      }
    }
  };

  const navigateToPortfolio = (user_name) => {
    if (userId) {
      navigate(`/performance/${userId}`, { state: { user_name } });
    } else {
      navigate(`/performance/${user_id}`, { state: { user_name } });
    }
  };

  // Where a profile picture on this screen points. Client Rev 3 item 9: inside
  // league screens a profile picture must not link to the user's main QUSHi
  // profile record — it opens that member's LEAGUE profile instead, so the user
  // stays in the league context. Outside a league the links are unchanged.
  const profilePath = (targetUserId) => {
    if (!(game_id && slug)) return targetUserId ? `/profile/${targetUserId}` : "/profile";
    const id = targetUserId || user_id;
    return id ? `/${slug}/profile/${id}` : `/contest/${slug}`;
  };

  const navigateToUserProfile = (event, targetUserId) => {
    if (event) event.preventDefault();
    if (!targetUserId) return;
    if (mobileCommentModal?.isOpen) {
      setMobileCommentModal({ isOpen: false, postId: null, postIndex: null });
    }
    const profileUrl = game_id ? `/${slug}/profile/${targetUserId}` : `/profile/${targetUserId}`;
    window.open(profileUrl, '_blank');
  };

  const handleVideoClick1 = (postIndex, imageIndex) => {
    const key = `${postIndex}-${imageIndex}`;
    const videoRef = videoRefs.current[key];

    if (videoRef) {
      if (videoPlaying[key]) {
        videoRef.pause();
        setVideoPlaying((prev) => ({ ...prev, [key]: false }));
      } else {
        // Pause all other videos
        Object.keys(videoRefs.current).forEach((otherKey) => {
          if (otherKey !== key && videoRefs.current[otherKey]) {
            videoRefs.current[otherKey].pause();
            setVideoPlaying((prev) => ({ ...prev, [otherKey]: false }));
          }
        });
        videoRef
          .play()
          .then(() => {
            setVideoPlaying((prev) => ({ ...prev, [key]: true }));
          })
          .catch((error) => {
            console.error("Error playing video:", error);
          });
      }
    } else {
      setVideoPlaying((prev) => ({ ...prev, [key]: true }));
      const updatedShowVideos = [...showVideos];
      updatedShowVideos[postIndex] = true;
      if (videoRef) {
        videoRef.play();
      }
      setShowVideos(updatedShowVideos);
      console.warn(`No videoRef found for key: ${key}`);
    }
  };

  // const getVideoThumbnail = (videoUrl) => {
  //     const video1 = videoUrl + ".jpg";
  //     return video1;
  // };
  const handleCloseVideoClick = () => {
    setIsPreviewVideo(false);
    setAttachments("");
  };

  useEffect(() => {
  setIsLoadingVideo((prevLoadingState) => {
    const newLoadingState = { ...prevLoadingState }; // Preserve previous state
    posts.forEach((post) => {
      if (!(post.id in newLoadingState)) {
        newLoadingState[post.id] = true; // Set only for new posts
      }
    });
    return newLoadingState;
  });
}, [posts]);

  const showPreview = (image) => {
    setActiveImage(image);
    setPreview(true);
  };

  const resetPortfolio = () => {
    setIsPortfolioResetModalOpen(true); // Open the portfolio reset modal
    //   setTimeout(() => {
    //   const myCustomEvent = new Event("myDismissModalEvent");
    //   window.dispatchEvent(myCustomEvent);
    // }, 3000);
  };

  // Function to close the modal (Cancel action)
  const closeResetPortfolioModal = () => {
    setIsPortfolioResetModalOpen(false); // Close the modal
  };

  // Function to handle confirmation (Confirm action)
  const handleConfirm = async () => {
    // In the app the store sells the Comeback: Apple IAP on iOS, Google Play
    // Billing on Android. Android builds from before Play Billing do not set
    // __QUSHI_NATIVE__.playBilling and keep the Stripe checkout below.
    const playBilling =
      deviceType === "A" && window.__QUSHI_NATIVE__?.playBilling === true;
    if ((deviceType === "I" || playBilling) && isFlutterWebViewReady) {
      event("IAP");
      return;
    }

    setIsLoading(true); // Start loading
    try {
      const response = await createPaymentIntent();

      if (response?.data?.clientSecret) {
        const { clientSecret } = response.data;
        setClientSecret(clientSecret); // Store the clientSecret
        setIsPortfolioResetModalOpen(false); // Close the modal
        setIsStripeModalOpen(true); // Open the Stripe modal
      } else {
        console.error("No clientSecret found in response");
      }
    } catch (error) {
      console.error("Error fetching payment intent:", error);
      // Optionally handle user-facing error message
    } finally {
      setIsLoading(false); // Stop loading
    }
  };


  const handleStripeModalClose = () => {
    setIsStripeModalOpen(false); // Close the Stripe modal
  };

  // const videoRefs = useRef([]);
  // Regions backed by the getProfile response (header, The Record, owner tools)
  // wait on this and nothing else. Posts and Top Holdings have their own flags,
  // so all three reveal independently as their requests land.
  //
  // Section skeletons render immediately rather than behind the 250ms gate: the
  // skeleton and the real content occupy identical space here, so there is
  // nothing to "flash" — whereas a delay would leave the region blank first,
  // which reads as a broken page rather than a loading one.
  // Header: cached identity counts, so it paints instantly.
  const profileReady = Boolean(profile?.id);
  // The Record / QUSHi Coins: LIVE data only. Never render a money figure from
  // cache.
  const financialsReady = profileFresh;

  // Only the standalone Main Profile pulls to refresh here — a league member's
  // profile is GameProfile.jsx, which already wires its own instance of this
  // same hook.
  const { containerProps, isRefreshing, pullDistance } = usePullToRefresh({
    onRefresh: fetchProfile,
    disabled: !!game_id,
  });

  return (
    <>
      {/* Hidden file input for comment image upload */}
      <input
        type="file"
        ref={commentImageInputRef}
        accept="image/jpeg,image/png,image/webp,image/gif"
        className="hidden"
        onChange={(e) => {
          const file = e.target.files[0];
          if (file) {
            const allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/jpg', 'image/gif'];
            if (!allowedTypes.includes(file.type)) {
              toast.error("Choose a JPG, PNG, WEBP, or GIF image.");
              e.target.value = '';
              return;
            }
            if (file.size > 5 * 1024 * 1024) {
              toast.error("Image must be under 5 MB.");
              e.target.value = '';
              return;
            }
            setCommentImage(file);
            setCommentImagePreview(URL.createObjectURL(file));
          }
          e.target.value = '';
        }}
      />
      {/* Inside a league the shell above owns the header (GameProfile renders
          it once, with the game attached). See `Shell` above. */}
      {!game_id && <DashboardHeader toggle={sidebarToggle} />}
      {/* NO page-level loading gate. The layout renders immediately and every
          region swaps itself independently the moment its own request resolves,
          so sections fill in one by one instead of all at once. A single
          `!loading ? page : skeleton` swap made every section appear together
          no matter how the requests were timed. */}
      {profileLoadFailed ? (
        <>
          {!game_id && (
            <PageHeaderTitle
              title="Profile"
              showDesktopTitle={false}
              mobileTopClass="mt-[52px]"
            />
          )}
          <Shell {...shellProps}>
            <PageError
              title="This profile could not be loaded"
              body="Check your connection and try again."
              onRetry={retryProfile}
            />
          </Shell>
        </>
      ) : (
        <>
          {/* Desktop: suppress the "Profile" title + grey divider line (like the
              Portfolio page) so the profile content rises and shows more above
              the fold. Mobile: tighten the top clearance from mt-16 (64px) down
              to just clear the fixed 50px top bar, removing the dead space above
              the avatar. */}
          {!game_id && (
            <PageHeaderTitle
              title="Profile"
              showDesktopTitle={false}
              mobileTopClass="mt-[52px]"
            />
          )}
          <Shell {...shellProps}>
            {/* The legacy in-page league menu (Posts / Buy-Sell / Charts /
                Portfolio / Leaderboard + Exit League). Inside a league the left
                rail IS the league's nav, so this was a second, older copy of it
                standing beside the profile — measured at x=284 on a 1440px
                screen, right where the client's design puts the profile itself.
                Every other League Play screen dropped it during the redesign
                (see the identical note in LeaderboardSecton); the profile was
                the last one still carrying it. Outside a league it never
                rendered anyway — `slug` is null there. */}
            {slug && !game_id && (
              <>
                <GameSideBar
                  gamePage={game_id && true}
                  activeMenu=""
                  slug={slug}
                />
              </>
            )}

            {/* pb-20 on mobile only: the app's bottom navigation is
                `fixed bottom-0` and 64px tall, and nothing here reserved space
                for it. On a long profile that goes unnoticed, but the League
                Play profile is short (empty Posts tab), so the page simply ran
                out of scroll with its last rows still underneath the bar.
                Measured at 390px on /testing-public/profile/372, scrolled fully
                to the bottom (scrollY 153 = maxScroll): the four profile tabs
                sat at y 795-828 while the nav starts at y 780 — the whole tab
                bar was covered, which is why Holdings and Trade History could
                not be reached by hand at all. The bar is `md:hidden`, so the
                clearance is too. */}
            <div
              className={`md:block  rounded-2xl bg-white w-full max-w-[60rem] lg:max-w-none mx-auto pb-20 md:pb-0`}
              {...containerProps}
            >
              {/* DashboardHeader above is `position: fixed`; PageHeaderTitle (with
                  mobileTopClass) is the spacer that clears it. The indicator renders
                  right after that spacer, same placement that works on Portfolio and
                  the league member profile. */}
              {!game_id && (
                <PullToRefreshIndicator pullDistance={pullDistance} isRefreshing={isRefreshing} />
              )}
              <main className="h-full bg-white justify-center">
                {/* <div className="p-2 md:p-8 rounded-2xl border bg-[#FBFCFC] border-white-500 max-w-[60rem] mx-auto"> */}
                {showPublicLayout ? (
                  profileReady ? (
                    <PublicProfileHeader
                      profile={profile}
                      userImg={userImg}
                      selectedTradingStyle={selectedTradingStyle}
                      onFollow={handleFollow}
                      onUnfollow={handleUnfollow}
                      onMessage={handleclick}
                      onLinkClick={handleLinkClick}
                      isDisabled={isDisabled}
                      rankReady={financialsReady}
                      rankLabel={rankLabel}
                      qushiRecordHref={qushiRecordHref}
                    />
                  ) : (
                    <ProfileHeaderSkeleton variant="public" rankLabel={rankLabel} />
                  )
                ) : (
                <>
                {profileReady ? (
                  <PublicProfileHeader
                    variant="private"
                    only="mobile"
                    profile={profile}
                    userImg={userImg}
                    selectedTradingStyle={selectedTradingStyle}
                    onEdit={handleClick}
                    onViewAsPublic={() =>
                      navigate(`${location.pathname}?view=public`)
                    }
                    rankReady={financialsReady}
                    rankLabel={rankLabel}
                    showOwnerActions={!game_id}
                  />
                ) : (
                  <ProfileHeaderSkeleton
                    variant="private"
                    only="mobile"
                    rankLabel={rankLabel}
                  />
                )}
                {false && (
                <>
                <div className="flex flex-col  lg:mx-16 md:py-2  space-y-3">
                  <div className="flex justify-between items-center flex-row md:text-base text-sm relative">
                    <div>
                      <img
                        src={userImg}
                        alt="userImage"
                        className="w-16 h-16 md:w-24 md:h-24 rounded-full object-cover"
                      />
                    </div>
                    <div
                      id="profile-guide-performance"
                      className=" flex flex-col items-center	font-bold	cursor-pointer"
                        onClick={(e) => {
                          navigateToPortfolio(
                          profile && profile?.user_name
                            ? "@" + profile?.user_name
                            : profile.full_name
                        )
                      }}

                    >
                      <h1
                        className={` whitespace-nowrap font-poppins font-extrabold ${
                          profile.performance < 0
                            ? "text-[20px] text-red-600"
                            : "text-[20px] text-greenXD"
                        }`}
                      >
                        {profile.performance}%{" "}
                        {profile.performance < 0 ? "" : "+"}
                      </h1>

                      <h1 className="text-[#707070]">Performance</h1>
                      {/* 4 */}
                    </div>
                    <div
                      id={isMobileView ? "profile-guide-mobile-portfolio" : "profile-guide-portfolio-balance"}
                      className=" flex flex-col items-center font-bold cursor-pointer"
                      onClick={(e) => {
                        portfolioNavi(profile?.wallet_coin ? profile.wallet_coin.toFixed(2) : "");
                      }}
                    >
                      {!loading && traderProfile ? (
                        <h1
                          className={`text-[20px] font-poppins font-bold ${
                            profile.wallet_coin < 0
                              ? "text-red-600"
                              : "text-greenXD"
                          }`}
                        >
                          {formatPrice(profile.wallet_coin)}
                          {/* {new Intl.NumberFormat("en-US", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          }).format(Math.floor(profile.wallet_coin))} */}
                        </h1>
                      ) : (
                        !loading && (
                          <h1
                            className={
                              profile.wallet_coin > 999999
                                ? `text-[15px] font-poppins font-bold ${
                                    profile.wallet_coin < 0
                                      ? "text-red-600"
                                      : "text-greenXD"
                                  }`
                                : `text-[20px] font-poppins font-bold ${
                                    profile.wallet_coin < 0
                                      ? "text-red-600"
                                      : "text-greenXD"
                                  }`
                            }
                          >
                            {profile.wallet_coin > 0 ? (
                              <span>{formatPrice(profile.wallet_coin)}</span>
                            ) : (
                              <span>
                                {Number(profile.wallet_coin).toFixed(2)}
                              </span>
                            )}
                          </h1>
                        )
                      )}

                      <h1 className="text-[#707070]">Portfolio</h1>
                      {/* 3 mobile */}


                    </div>

                    <div
                      className=" flex flex-col items-center font-bold cursor-pointer"
                      onClick={() =>
                        navigateToFollowers(
                          profile && profile?.user_name
                            ? "@" + profile?.user_name
                            : profile.full_name
                        )
                      }
                    >
                      <h1 className="text-[20px] text-greenXD  font-extrabold">
                        {profile.follower_count === 0
                          ? "0"
                          : profile.follower_count}
                      </h1>
                      <h1 className="text-[#707070]">Followers</h1>
                    </div>
                  </div>

                  {/* <span className="px-1 ml-0 sm:ml-[16] text-[17px] text-black font-bold font-poppins whitespace-nowrap">
                    {profile && profile?.user_name
                      ? "@" + profile?.user_name
                      : profile.full_name}{" "}
                      {
                        COUNTRIES.filter(item => item.iso2 === profile.country_code).length > 0
                        ? COUNTRIES.filter(item => item.iso2 === profile.country_code).map(item => (
                            <span className="inline ml-2" style={{ width: 24, height: "auto" }}  key={item.iso2}>{item.flag}</span>
                          ))
                        : <Flag code={profile.country_code} style={{ width: 23, height: "auto" }} className="inline ml-2" />
                      }
                  </span> */}
                  <span className="px-1 ml-0 sm:ml-[16] text-[17px] text-black font-bold font-poppins whitespace-nowrap">
  {profile && profile?.user_name
    ? "@" + profile?.user_name
    : profile.full_name}{" "}

  {
    COUNTRIES.some(item => item.iso2 === profile.country_code)
      ? COUNTRIES.filter(item => item.iso2 === profile.country_code).map(item => (
          item.flag.startsWith("/") ? (
            // If flag is a PNG path, render an <img> tag
            <img
              key={item.iso2}
              src={item.flag}
              alt={item.name}
              width="24"
              height="16"
              className="inline ml-2"
              onError={(e) => { e.target.src = "/flags/default.png"; }} // Fallback flag
            />
          ) : (
            // If flag is an emoji, render a <span>
            <span className="inline ml-2" key={item.iso2}>{item.flag}</span>
          )
        ))
      : <Flag code={profile.country_code} style={{ width: 23, height: "auto" }} className="inline ml-2" />
  }
</span>


                  <div>
                    <h1>{profile.title}</h1>
                  </div>
                  <div className="flex space-x-3">
                    <h1 className="text-[#707070]">Trading Style</h1>
                    <span className="w-[156px] text-[#707070] ml-12 whitespace-nowrap">
                      {selectedTradingStyle}
                    </span>
                  </div>
                  <h1 className="text-[#707070]">{profile?.biography}</h1>

                  {userId && user_id !== userId && (
                    <div className="flex">
                      {profile?.link && profile?.link !== "null" && (
                        <>
                          <FontAwesomeIcon icon={faLink} className="mt-1" />
                          <a
                            href={
                              profile?.link &&
                              (profile.link.startsWith("http")
                                ? profile?.link
                                : `https://${profile?.link}`)
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            className="ml-1 text-[#71AB59]"
                            onClick={() => handleLinkClick(profile.link)}
                          >
                            {isMobileView ? (
                              <p className="text-xs font-bold">
                                {profile?.link}
                              </p>
                            ) : (
                              <strong>{profile?.link}</strong>
                            )}
                          </a>
                        </>
                      )}
                    </div>
                  )}

                  {isMobileView && !userId && (
                    <>
                      {profile?.link && profile?.link !== "null" && (
                        <div className="mb-2 flex  items-center">
                          <FontAwesomeIcon icon={faLink} className="mr-2" />
                          <a
                            href={
                              profile.link.startsWith("http")
                                ? profile.link
                                : `https://${profile.link}`
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-[#71AB59] break-all whitespace-normal"
                            onClick={() => handleLinkClick(profile.link)}
                            style={{ maxWidth: "100%" }}
                          >
                            {isMobileView ? (
                              <p className="text-xs font-bold">
                                {profile?.link}
                              </p>
                            ) : (
                              <strong>{profile?.link}</strong>
                            )}
                          </a>
                        </div>
                      )}

                      {!game_id && (
                        <>
                        <div className="flex justify-center mb-4 px-2 gap-2 relative">
                          <button
                            id="profile-guide-edit-profile"
                            onClick={() => {
                              handleClick();
                            }}
                            className={`w-full px-4 py-2 rounded-l-md focus:outline-none transition-colors ${
                              activeButtons === "EditProfile"
                                ? "bg-primaryColor text-white border"
                                : "bg-white text-[#8A8B8F] border border-black"
                            } ${isMobileView && "text-xs"}`}
                          >
                            Edit Profile
                          </button>
                       {/* 1 */}
                      <button
                        id={isMobileView ? "profile-guide-mobile-watchlist" : undefined}
                          onClick={() => {
                            setActiveButtons("Watchlist");
                            navigate("/search");
                          }}
                        className={`w-full px-4 py-2 focus:outline-none transition-colors ${
                          activeButtons === "Watchlist"
                            ? "bg-primaryColor text-white border"
                            : "bg-white text-[#8A8B8F] border border-black"
                        } ${isMobileView && "text-xs"}`}
                      >
                        Watchlist
                        {/* 2 mobile */}
                      </button>
                          <button
                            onClick={() => {
                              resetPortfolio();
                            }}
                            className={`w-full px-4 py-2 rounded-r-md  focus:outline-none transition-colors ${
                              activeButtons === "Reset Portfolio"
                                ? "bg-primaryColor text-white border "
                                : "bg-white text-[#8A8B8F]  border border-black"
                            } ${isMobileView && "text-xs"}`}
                          >
                            The Comeback
                          </button>
                        </div>
                              {userReferralCode ? (
                                <ReferAFriend
                                  referralCode={userReferralCode}
                                />
                              ) : (
                                <span className="text-gray-500 text-sm">
                                  Loading referral code...
                                </span>
                              )}

                        </>
                      )}
                    </>
                  )}

                  {!game_id && userId === user_id ? (
                    <div className="flex space-x-3 items-center">
                      <button
                        id={!isMobileView ? "profile-guide-edit-profile" : undefined}
                        onClick={handleClick}
                        type="button"
                        className=" text-primaryColor font-poppins hover:text-white border border-primaryColor hover:bg-primaryColor focus:ring-4 focus:outline-none focus:ring-primaryColor-300  rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-green-500 dark:text-primaryColor dark:hover:text-white dark:hover:bg-primaryColor dark:focus:ring-green-800 font-bold"
                      >
                        Edit Profile
                      </button>
                    </div>
                  ) : !game_id && !isMobileView && !userId ? (
                    <>
                    <div className="flex space-x-3  items-center top-0">
                      <button
                        id={!isMobileView ? "profile-guide-edit-profile" : undefined}
                        onClick={handleClick}
                        type="button"
                        className="flex-shrink-0 text-primaryColor font-poppins hover:text-white border border-primaryColor hover:bg-primaryColor focus:ring-4 focus:outline-none focus:ring-primaryColor-300  rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-green-500 dark:text-primaryColor dark:hover:text-white dark:hover:bg-primaryColor dark:focus:ring-green-800 font-bold"
                      >
                        Edit Profile
                      </button>
                      <button
                        onClick={resetPortfolio}
                        type="button"
                        className=" text-primaryColor font-poppins hover:text-white border border-primaryColor hover:bg-primaryColor focus:ring-4 focus:outline-none focus:ring-primaryColor-300  rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-green-500 dark:text-primaryColor dark:hover:text-white dark:hover:bg-primaryColor dark:focus:ring-green-800 font-bold"
                      >
                        The Comeback
                      </button>
                      {/* <button
                        type="button"
                        onClick={() => setShowModal(true)}
                        className="text-primaryColor font-poppins hover:text-white border border-primaryColor hover:bg-primaryColor focus:ring-4 focus:outline-none focus:ring-primaryColor-300 rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 font-bold"
                      >
                        Referral Program
                      </button> */}

                      {profile?.link && profile?.link !== "null" && (
                        <div className="mb-2 flex  items-center">
                          <FontAwesomeIcon icon={faLink} className="mr-2" />
                          <a
                            href={
                              profile.link.startsWith("http")
                                ? profile.link
                                : `https://${profile.link}`
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-[#71AB59] break-all whitespace-normal"
                            onClick={() => handleLinkClick(profile.link)}
                            style={{ maxWidth: "100%" }}
                          >
                            {isMobileView ? (
                              <p className="text-xs font-bold">
                                {profile?.link}
                              </p>
                            ) : (
                              <strong>{profile?.link}</strong>
                            )}
                          </a>
                        </div>
                      )}
                    </div>
                                              {userReferralCode ? (
                              <ReferAFriend referralCode={userReferralCode} />
                            ) : (
                              <span className="text-gray-500 text-sm">Loading referral code...</span>
                            )}
                    </>
                  ) : (
                    userId !== user_id && ""
                  )}

                  {SUBSCRIPTION_ENABLED ? (
                    userId === user_id ? (
                      <div>
                        <button
                          type="button"
                          // onClick={handleSubscription}
                          onMouseEnter={handleMouseEnter2}
                          onMouseLeave={handleMouseLeave2}
                          style={{
                            color: isHovered2 ? "white" : "#004c50",
                            background: isHovered2 ? "#004C50" : "white",
                            width: "100%",
                            border: "1px solid #004c50",
                            borderRadius: "8px",
                            fontSize: "0.875rem",
                            padding: "0.59rem 1.05rem",
                            textAlign: "center",
                            outline: "none",
                            marginBottom: "0.5rem",
                            transition:
                              "background-color 0.2s, border-color 0.2s",
                          }}
                          className="font-bold"
                        >
                          SUBSCRIPTIONS{" "}
                          <span className="rounded-full bg-primaryColor text-white px-2">
                            {profile?.subscriber_count}
                          </span>
                        </button>
                      </div>
                    ) : !userId ? (
                      <div>
                        <button
                          type="button"
                          // onClick={handleSubscription}
                          onMouseEnter={handleMouseEnter2}
                          onMouseLeave={handleMouseLeave2}
                          style={{
                            color: isHovered2 ? "white" : "#004c50",
                            background: isHovered2 ? "#004C50" : "white",
                            width: "100%",
                            border: "1px solid #004c50",
                            borderRadius: "8px",
                            fontSize: "0.875rem",
                            padding: "0.59rem 1.05rem",
                            marginBottom: "0.5rem",
                            textAlign: "center",
                            outline: "none",
                            transition:
                              "background-color 0.2s, border-color 0.2s",
                          }}
                          className="font-bold"
                        >
                          SUBSCRIPTIONS{" "}
                          <span className="rounded-full bg-primaryColor text-white px-2">
                            {profile?.subscriber_count}
                          </span>
                        </button>
                      </div>
                    ) : (
                      userId !== user_id && ""
                    )
                  ) : null}

                  {profile?.green_tick && SUBSCRIPTION_ENABLED ? (
                    <>
                      {userId &&
                      userId !== user_id &&
                      !profile?.is_subscribed ? (
                        <div>
                          <button
                            type="button"
                            onClick={handleSubscription}
                            onMouseEnter={handleMouseEnter2}
                            onMouseLeave={handleMouseLeave2}
                            style={{
                              color: isHovered2 ? "white" : "white",
                              background: isHovered2 ? "#004C50" : "#004C50",
                              width: "100%",
                              border: "1px solid #004c50",
                              borderRadius: "8px",
                              fontSize: "0.875rem",
                              padding: "0.59rem 1.05rem",
                              textAlign: "center",
                              marginBottom: "0.5rem",
                              outline: "none",
                              transition:
                                "background-color 0.2s, border-color 0.2s",
                            }}
                            className="font-bold"
                          >
                            SUBSCRIBE
                          </button>
                        </div>
                      ) : (
                        profile?.is_subscribed && (
                          <div>
                            <button
                              type="button"
                              onMouseEnter={handleMouseEnter2}
                              onMouseLeave={handleMouseLeave2}
                              style={{
                                color: isHovered2 ? "white" : "white",
                                background: isHovered2 ? "#004C50" : "#004C50",
                                width: "100%",
                                border: "1px solid #004c50",
                                borderRadius: "8px",
                                fontSize: "0.875rem",
                                padding: "0.59rem 1.05rem",
                                marginBottom: "0.5rem",
                                textAlign: "center",
                                outline: "none",
                                transition:
                                  "background-color 0.2s, border-color 0.2s",
                              }}
                              className="font-bold"
                            >
                              SUBSCRIBED
                            </button>
                          </div>
                        )
                      )}
                    </>
                  ) : (
                    <div className="mt-2"></div>
                  )}
                </div>
                <div className="w-full">
                  {userId !== user_id ? renderButton() : ""}
                </div>
                <div></div>
                </>
                )}
                </>
                )}

                {/* Desktop 2-column wrapper (public + private): content left,
                    Record card (+ owner tools for private) in the right rail.
                    On mobile it's a plain stacked pass-through (no layout change). */}
                <div className="lg:flex lg:items-start lg:gap-8 lg:p-8">
                <div className="lg:flex-1 lg:min-w-0">
                {/* Private desktop: header card lives in the left column (top) */}
                {!showPublicLayout &&
                  (profileReady ? (
                    <PublicProfileHeader
                      variant="private"
                      only="desktop"
                      profile={profile}
                      userImg={userImg}
                      selectedTradingStyle={selectedTradingStyle}
                      onEdit={handleClick}
                      onViewAsPublic={() =>
                        navigate(`${location.pathname}?view=public`)
                      }
                      rankReady={financialsReady}
                      rankLabel={rankLabel}
                      showOwnerActions={!game_id}
                    />
                  ) : (
                    <ProfileHeaderSkeleton
                      variant="private"
                      only="desktop"
                      rankLabel={rankLabel}
                    />
                  ))}
                {/* Left content card (tabs + feed) — bordered box on desktop */}
                <div className="mb-4 lg:border lg:border-[#F3F4F6] lg:rounded-2xl lg:bg-white">
                {showPublicLayout && (
                  <>
                    {/* Record card: shown here on mobile; on desktop it moves to the right rail */}
                    <div className="lg:hidden">
                      {financialsReady ? (
                        <ProfileRecordCard
                          profile={profile}
                          userId={userId || user_id}
                          isSelf={!showPublicLayout}
                          inLeague={!!game_id}
                          gameId={game_id}
                          game={game}
                          title={recordTitle}
                          subtitle={recordSubtitle}
                        />
                      ) : (
                        <RecordCardSkeleton
                          chartRight={false}
                          title={recordTitle}
                          subtitle={recordSubtitle}
                        />
                      )}
                    </div>

                    {/* Trophy Case below the Record on mobile, as in the app. Not in a league (item 17). */}
                    {!game_id && (profile?.id || userId || user_id) && (
                      <div className="lg:hidden mt-4">
                        <TrophyCase userId={profile?.id || userId || user_id} isOwn={false} />
                      </div>
                    )}

                    {/* Mobile tabs (public): match desktop — Posts, Holdings, Trade History, Performance. */}
                    <div className="lg:hidden mt-4 flex justify-between gap-2 border-b border-[#F3F4F6] overflow-x-auto overflow-y-hidden no-scrollbar">
                      {[
                        { key: "posts", label: "Posts" },
                        { key: "holdings", label: "Holdings" },
                        { key: "tradeHistory", label: "Trade History" },
                        { key: "performance", label: "Performance" },
                      ].map((t) => (
                        <button
                          key={t.key}
                          type="button"
                          onClick={() => setActiveProfileTab(t.key)}
                          className={`pb-3 whitespace-nowrap text-[13px] lg:text-[15px] border-b-2 -mb-px transition-colors ${
                            activeProfileTab === t.key
                              ? "text-primaryColor font-semibold border-primaryColor"
                              : "text-[#5F6F72] font-medium border-transparent"
                          }`}
                        >
                          {t.label}
                        </button>
                      ))}
                    </div>
                    {/* Desktop tabs (public): no Overview, Posts first. */}
                    <div className="hidden lg:flex lg:mx-8 mt-4 gap-6 border-b border-[#F3F4F6] flex-wrap">
                      {[
                        { key: "posts", label: "Posts" },
                        { key: "holdings", label: "Holdings" },
                        { key: "tradeHistory", label: "Trade History" },
                        { key: "performance", label: "Performance" },
                      ].map((t) => (
                        <button
                          key={t.key}
                          type="button"
                          onClick={() => setActiveProfileTab(t.key)}
                          className={`pb-3 whitespace-nowrap text-[13px] lg:text-[15px] border-b-2 -mb-px transition-colors ${
                            activeProfileTab === t.key
                              ? "text-primaryColor font-semibold border-primaryColor"
                              : "text-[#5F6F72] font-medium border-transparent"
                          }`}
                        >
                          {t.label}
                        </button>
                      ))}
                    </div>

                    {activeProfileTab === "holdings" &&
                      (portfolioLocked ? (
                        <LockedLeagueTab kind="holdings" />
                      ) : (
                        <NewPortfolioSection
                          user_id={userId || user_id}
                          /* Items 14 and 15: Holdings and Trade History are the
                             LEAGUE's, not the member's sitewide record.
                             NewPortfolioSection already threads gameId into
                             get-order and portfolio-metrics; it was simply being
                             handed null. Measured before this on user 437, whose
                             league 352 order count is 0: the Holdings tab listed
                             their sitewide BAL and BTC positions. */
                          gameId={game_id}
                          slug={slug}
                          isSelfProfile={false}
                          embedded
                          hideTabBar
                          initialTab="holdings"
                        />
                      ))}
                    {activeProfileTab === "tradeHistory" &&
                      (portfolioLocked ? (
                        <LockedLeagueTab kind="tradeHistory" />
                      ) : (
                        <NewPortfolioSection
                          user_id={userId || user_id}
                          /* Item 15 — see the Holdings note above. */
                          gameId={game_id}
                          slug={slug}
                          isSelfProfile={false}
                          embedded
                          hideTabBar
                          initialTab="closedTrades"
                        />
                      ))}
                    {/* Items 11 and 16: the Performance tab is the LEAGUE's
                        series inside a league. game_id was never passed here,
                        although PerformanceSection has always accepted it.
                        gameId ONLY — deliberately not `slug`. PerformanceSection
                        renders the legacy in-page league menu whenever it has a
                        slug (PerformanceSection.jsx:230), which put the old
                        Posts / Buy-Sell / Charts list back inside the tab, right
                        after slice 2 removed it from this screen. The scope is
                        what item 16 needs; the slug only drives that menu and a
                        CTA target that was already `/charts` here before. */}
                    {activeProfileTab === "performance" && (
                      <PerformanceSection userId={userId || user_id} gameId={game_id} embedded isSelfProfile={!showPublicLayout} hasTraded={Number(profile?.trades_count) > 0} />
                    )}
                  </>
                )}

                {/* Private profile Part 3: Record + Owner tools + tabs */}
                {!showPublicLayout && (
                  <>
                    {/* Record + Owner tools: shown here on mobile; on desktop they move to the right rail */}
                    <div id="profile-guide-record-mobile" className="lg:hidden">
                      {financialsReady ? (
                        <ProfileRecordCard
                          profile={profile}
                          userId={user_id}
                          chartRight
                          inLeague={!!game_id}
                          gameId={game_id}
                          game={game}
                          isSelf={!showPublicLayout}
                          title={recordTitle}
                          subtitle={recordSubtitle}
                        />
                      ) : (
                        <RecordCardSkeleton
                          chartRight
                          title={recordTitle}
                          subtitle={recordSubtitle}
                        />
                      )}
                    </div>

                    {/* Client League Play Profiles spec, item 17: "Remove QUSHi
                        Coins, The Comeback, Owner Tools, Referral Link and
                        Trophy Case." These are main-account tools — coins,
                        a portfolio reset and a signup referral link are all
                        sitewide, so inside a league they are both irrelevant
                        and misleading (resetting from here would wipe the
                        sitewide record, not the league entry). The block is
                        unchanged on /profile. */}
                    {/* Trophy Case + QUSHi Coins below the Record on mobile, as in the app. */}
                    {!game_id && (profile?.id || user_id) && (
                      <div className="lg:hidden mt-4">
                        <TrophyCase
                          userId={profile?.id || user_id}
                          isOwn
                          coins={profile?.coins || 0}
                          coinsGuideId="profile-guide-coins-mobile"
                        />
                      </div>
                    )}

                    {!game_id && (
                      <div className="lg:hidden">
                        {financialsReady ? (
                          <OwnerToolsBlock
                            showCoins={false}
                            collapsible
                            referralCode={userReferralCode}
                            userName={profile?.user_name}
                            onQushiBank={resetPortfolio}
                          />
                        ) : (
                          <OwnerToolsSkeleton />
                        )}
                      </div>
                    )}

                    {/* Mobile tabs (private): match desktop — Posts, Holdings, Trade History, Performance. */}
                    <div id="profile-guide-tabs-mobile" className="lg:hidden lg:mx-8 mt-4 flex justify-between gap-2 border-b border-[#F3F4F6] overflow-x-auto overflow-y-hidden no-scrollbar">
                      {[
                        { key: "posts", label: "Posts" },
                        { key: "holdings", label: "Holdings" },
                        { key: "tradeHistory", label: "Trade History" },
                        { key: "performance", label: "Performance" },
                      ].map((t) => (
                        <button
                          key={t.key}
                          type="button"
                          onClick={() => setActiveProfileTab(t.key)}
                          className={`pb-3 whitespace-nowrap text-[13px] lg:text-[15px] border-b-2 -mb-px transition-colors ${
                            activeProfileTab === t.key
                              ? "text-primaryColor font-semibold border-primaryColor"
                              : "text-[#5F6F72] font-medium border-transparent"
                          }`}
                        >
                          {t.label}
                        </button>
                      ))}
                    </div>
                    {/* Desktop tabs (no Overview): Posts / Holdings / Trade History / Performance */}
                    <div id="profile-guide-tabs" className="hidden lg:flex mx-8 mt-2 gap-6 border-b border-[#F3F4F6] flex-wrap">
                      {[
                        { key: "posts", label: "Posts" },
                        { key: "holdings", label: "Holdings" },
                        { key: "tradeHistory", label: "Trade History" },
                        { key: "performance", label: "Performance" },
                      ].map((t) => (
                        <button
                          key={t.key}
                          type="button"
                          onClick={() => setActiveProfileTab(t.key)}
                          className={`pb-3 whitespace-nowrap text-[13px] lg:text-[15px] border-b-2 -mb-px transition-colors ${
                            activeProfileTab === t.key
                              ? "text-primaryColor font-semibold border-primaryColor"
                              : "text-[#5F6F72] font-medium border-transparent"
                          }`}
                        >
                          {t.label}
                        </button>
                      ))}
                    </div>

                    {/* Owner's own view of the same two tabs. Items 14 and 15
                        apply here too: standing inside a league, your own
                        Holdings tab must show the league entry, not the sitewide
                        portfolio you also happen to own. Outside a league
                        game_id is null, which is what these already passed. */}
                    {activeProfileTab === "portfolio" && (
                      <NewPortfolioSection
                        gameId={game_id}
                        slug={slug}
                        isSelfProfile={true}
                        embedded
                      />
                    )}
                    {activeProfileTab === "holdings" && (
                      <NewPortfolioSection
                        gameId={game_id}
                        slug={slug}
                        isSelfProfile={true}
                        embedded
                        hideTabBar
                        initialTab="holdings"
                      />
                    )}
                    {activeProfileTab === "tradeHistory" && (
                      <NewPortfolioSection
                        gameId={game_id}
                        slug={slug}
                        isSelfProfile={true}
                        embedded
                        hideTabBar
                        initialTab="closedTrades"
                      />
                    )}
                    {/* Owner's own view — same scoping as the member view above. */}
                    {activeProfileTab === "performance" && (
                      <PerformanceSection userId={user_id} gameId={game_id} embedded isSelfProfile={!showPublicLayout} hasTraded={Number(profile?.trades_count) > 0} />
                    )}
                  </>
                )}

                {/* Item 12: "Keep the four tabs." Posts was gated on `!game_id`,
                    so inside a league the Posts tab rendered NOTHING AT ALL —
                    measured on /testing-public/profile/437, whose author has 15
                    posts in that league: the tab's content area came back 0
                    characters long. The gate is gone; `profilePosts` above is
                    what keeps the two scopes apart now. */}
                {(activeProfileTab === "overview" ||
                  activeProfileTab === "posts") && (
                  <>
                    {/* <ProfileTop /> */}
                    {/* <div className="w-full mt-3 h-px bg-gray-300"></div>{" "} */}
                    {postsLoading ? (
                      // Switching to Paid content swaps the dataset entirely, so
                      // row skeletons are correct here. The page chrome, header
                      // and right rail all stay on screen — only this region
                      // reloads.
                      <div
                        className={`px-4 lg:px-8 ${
                          activeProfileTab === "posts" ? "min-h-screen" : ""
                        }`}
                      >
                        <PostListSkeleton posts={3} />
                      </div>
                    ) : (
                      /* Client: "A brand new user's private profile does not have
                         enough content to require this much vertical scrolling…
                         Can we stop the page shortly after the CTA and leave only
                         a small amount of bottom padding?"

                         `min-h-screen` is what was doing it. Measured on a new
                         user at 390x844: the empty state's CTA ends at y=1359, its
                         own container ends at 1423, and this box was then held
                         open to 1975 — 552px of nothing — pushing the document to
                         2103. The user scrolled most of a second viewport past the
                         last thing on the page.

                         It only ever has an effect when the content is SHORT,
                         which is exactly the case the client is describing; with a
                         real feed the posts are taller than the viewport and it
                         does nothing. So it is kept only while there is something
                         to hold space FOR — posts on screen — and dropped when the
                         empty state is what is showing. Tab switching between two
                         populated tabs still cannot collapse the page. */
                      <div
                        className={`${
                          isMobileView ? " mb-12 -mx-2 w-[calc(100%+1rem)]" : ""
                        } ${
                          activeProfileTab === "posts" && profilePosts.length > 0
                            ? "min-h-screen"
                            : ""
                        }`}
                      >
                        <InfiniteScroll
                          dataLength={profilePosts.length}
                          next={profilePosts.length > 9 && handleLoadMore}
                          hasMore={activeProfileTab === "overview" ? false : hasMore}
                          loader={loader && <PostListSkeleton posts={1} />}
                          style={{
                            overflow: "hidden",
                          }}
                          endMessage={
                            !hasMore && (
                              <p style={{ textAlign: "center" }}>
                                <b>Yay! You have seen it all</b>
                              </p>
                            )
                          }
                        >
                          {(activeProfileTab === "overview"
                            ? profilePosts.some((p) => p.is_pinned)
                            : profilePosts.length > 0) ? (
                            <>
                              {profilePosts
                                .filter(
                                  (post) =>
                                    activeProfileTab !== "overview" ||
                                    post.is_pinned
                                )
                                .map((post, index) => {
                                  return isMobileView ? (
                                    <div
                                      key={index}
                                      className="w-full bg-white"
                                    >
                                      {post.is_pinned && (
                                        <div
                                          className={`flex items-center gap-1.5 px-[18px] pt-3 text-xs font-semibold ${
                                            isPrivateProfile
                                              ? "text-primaryColor"
                                              : "text-green-600"
                                          }`}
                                        >
                                          <img
                                            src={`${process.env.PUBLIC_URL}/${
                                              location.pathname.startsWith(
                                                "/profile/"
                                              )
                                                ? "PinnedPost.svg"
                                                : "PinnedVectorDark.svg"
                                            }`}
                                            alt="Pinned"
                                            className="w-3 h-3"
                                          />
                                          <span>Pinned post</span>
                                        </div>
                                      )}
                                      <div className="py-3.5 px-[18px] flex items-center justify-between gap-2 ">
                                        <div className="flex items-center gap-2">
                                          <div
                                            className={
                                              isMobileView ? "w-10" : ""
                                            }
                                          >
                                            <Link
                                              to={
                                                post?.repost?.id
                                                  ? profilePath(post?.repost?.user?.id)
                                                  : ""
                                              }
                                              className={
                                                isMobileView ? "w-10" : ""
                                              }
                                            >
                                              <img
                                                src={
                                                  post?.repost?.id
                                                    ? post?.repost?.user?.image
                                                    : post?.user?.image
                                                }
                                                className="w-8 h-8 rounded-full border border-[#f0f2f5] object-cover"
                                                alt={`${
                                                  post?.repost?.id
                                                    ? post?.repost?.user
                                                        ?.user_name
                                                    : post.user.user_name
                                                }'s profile`}
                                              />
                                            </Link>
                                          </div>
                                          <div className="text-[15px] font-semibold block leading-tight">
                                            {/* <span
                                                className={
                                                isMobileView
                                                    ? "ml-2 text-[13px] text-black font-bold font-poppins whitespace-nowrap"
                                                    : "px-1 ml-2 text-[13px] text-black font-bold font-poppins whitespace-nowrap"
                                                }
                                            >
                                                {post?.repost?.id
                                                ? post?.repost?.user?.user_name
                                                : post.user.user_name}
                                            </span> */}

                                            <span className="text-[15px] font-semibold block leading-tight">
                                              {post?.repost?.id
                                                ? post?.repost?.user?.user_name
                                                : post.user.user_name}
                                            </span>
                                            {profile.green_tick ? (
                                              <img
                                                src={GreenTick}
                                                className="ml-1 w-5 h-5"
                                                alt="green-tick"
                                              />
                                            ) : // <FontAwesomeIcon icon={faCheckCircle} className="px-1 text-xl md:text-2xl text-primaryColor" />
                                            null}

                                            {post?.repost?.id && (
                                              <span className="text-[11px] font-medium text-[#888888] block">
                                                {post?.user?.user_name} Reposted
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                        <div className="flex items-center justify-between ">
                                          {userId == user_id ? (
                                            <div
                                              style={{ position: "relative" }}
                                              className="ml-4"
                                              data-post-menu
                                            >
                                              <span
                                                onClick={() =>
                                                  toggleDropdown(post.id)
                                                }
                                                type="button"
                                                className="cursor-pointer"
                                              >
                                                {TheDotsIcon}
                                              </span>
                                              {openMenuPostId === post.id && (
                                                <div style={{ zIndex: 1 }} className="z-50 absolute top-8 text-green-500 right-0 md:right-auto md:left-0 w-10 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 md:mr-[220px] mr-[20px]">
                                                  <button
                                                    onClick={() =>
                                                      handlePinPost(post.id)
                                                    }
                                                    className={`block w-full px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900 ${
                                                      post.is_pinned
                                                        ? "text-green-600"
                                                        : "text-primaryColor"
                                                    }`}
                                                    role="menuitem"
                                                    title={
                                                      post.is_pinned
                                                        ? "Unpin"
                                                        : "Pin to profile"
                                                    }
                                                  >
                                                    <div className="flex flex-row justify-center items-center">
                                                      <FontAwesomeIcon
                                                        icon={faThumbtack}
                                                      />
                                                    </div>
                                                  </button>
                                                  <button
                                                    onClick={() =>
                                                      handleDeletePost(post.id)
                                                    }
                                                    className="block text-primaryColor px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                                    role="menuitem"
                                                  >
                                                    <div className="flex flex-row justify-center items-center">
                                                      <FontAwesomeIcon
                                                        icon={faTrash}
                                                      />
                                                    </div>
                                                  </button>
                                                  {post?.repost?.id ? (
                                                    ""
                                                  ) : (
                                                    <button
                                                      onClick={() =>
                                                        handleEditClick(
                                                          post?.repost?.id
                                                            ? post?.repost?.id
                                                            : post.id,
                                                          post?.repost?.id
                                                            ? post?.repost?.created_at
                                                            : post?.created_at
                                                        )
                                                      }
                                                      className="block px-4 py-2 text-sm text-primaryColor hover:bg-gray-100 hover:text-gray-900"
                                                      role="menuitem"
                                                    >
                                                      <div className="flex flex-row justify-center items-center">
                                                        <FontAwesomeIcon
                                                          icon={faEdit}
                                                        />
                                                      </div>
                                                    </button>
                                                  )}
                                                </div>
                                              )}
                                            </div>
                                          ) : !userId ? (
                                            <div
                                              style={{ position: "relative" }}
                                              className="ml-4"
                                              data-post-menu
                                            >
                                              <span
                                                onClick={() =>
                                                  toggleDropdown(post.id)
                                                }
                                                type="button"
                                                className="cursor-pointer"
                                              >
                                                {TheDotsIcon}
                                              </span>
                                              {openMenuPostId === post.id && (
                                                <div style={{ zIndex: 1 }} className="absolute top-8 text-green-500 right-0 md:right-auto md:left-0 w-10 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 md:mr-[220px] mr-[20px]">
                                                  <button
                                                    onClick={() =>
                                                      handlePinPost(post.id)
                                                    }
                                                    className={`block w-full px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900 ${
                                                      post.is_pinned
                                                        ? "text-green-600"
                                                        : "text-primaryColor"
                                                    }`}
                                                    role="menuitem"
                                                    title={
                                                      post.is_pinned
                                                        ? "Unpin"
                                                        : "Pin to profile"
                                                    }
                                                  >
                                                    <div className="flex flex-row justify-center items-center">
                                                      <FontAwesomeIcon
                                                        icon={faThumbtack}
                                                      />
                                                    </div>
                                                  </button>
                                                  <button
                                                    onClick={() =>
                                                      handleDeletePost(post.id)
                                                    }
                                                    className="block text-primaryColor px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                                    role="menuitem"
                                                  >
                                                    <div className="flex flex-row justify-center items-center">
                                                      <FontAwesomeIcon
                                                        icon={faTrash}
                                                      />
                                                    </div>
                                                  </button>
                                                  {post?.repost?.id ? (
                                                    ""
                                                  ) : (
                                                    <button
                                                      onClick={() =>
                                                        handleEditClick(
                                                          post?.repost?.id
                                                            ? post?.repost?.id
                                                            : post.id,
                                                          post?.repost?.id
                                                            ? post?.repost?.created_at
                                                            : post?.created_at
                                                        )
                                                      }
                                                      className="block px-4 py-2 text-sm text-primaryColor hover:bg-gray-100 hover:text-gray-900"
                                                      role="menuitem"
                                                    >
                                                      <div className="flex flex-row justify-center items-center">
                                                        <FontAwesomeIcon
                                                          icon={faEdit}
                                                        />
                                                      </div>
                                                    </button>
                                                  )}
                                                </div>
                                              )}
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>

                                      <div
                                        className="w-full bg-white"
                                      >
                                                                          {post.post_image?.length > 0 ||
                                  post?.repost?.post_image?.length > 0 ? (
                                    post?.repost?.id ? (
                                      post?.repost?.post_image.map(
                                        (image, imageIndex) => {
                                          const key = `${index}-${imageIndex}`;
                                          const shouldShowThumbnail =
                                            !showVideos[key] &&
                                            !videoPlaying[key];

                                          return (
                                            <div
                                              key={imageIndex}
                                              className="p-0 pswp-gallery"
                                            >
                                              {videoExtensionsRegex.test(
                                                image.image.split("?")[0]
                                              ) ? (
                                                <div className="relative" onClick={() => togglePlay(post.id)}
                                                >
                                                {isLoadingVideo[post.id] && (
  <div className="absolute inset-0 bg-[#f8f8f8]" aria-busy="true" aria-label="Video loading">
    <SkeletonBlock width="100%" height="100%" rounded="rounded" />
  </div>
)}
                                                  {/* {shouldShowThumbnail ? (
                                                    <div className="relative">
                                                    <img
                                                      src={image.thumb}
                                                      id={`image-${key}`}
                                                      alt="Video Thumbnail"
                                                      onClick={() =>
                                                        handleVideoClick1(
                                                          index,
                                                          imageIndex
                                                        )
                                                      }
                                                      className="w-full"
                                                    />
                                                    <button
                                                    id={`play-button-${key}`}
                                                    className={
                                                      videoPlaying[key]
                                                        ? "absolute inset-0 flex rounded-lg items-center justify-center text-white"
                                                        : "absolute inset-0 flex  items-center justify-center bg-black bg-opacity-10 text-white"
                                                    }
                                                    style={{
                                                      display: videoPlaying[key]
                                                        ? "none"
                                                        : "block",
                                                    }}
                                                    onClick={() => {
                                                      handleVideoClick1(
                                                        index,
                                                        imageIndex
                                                      );
                                                    }}
                                                  >
                                                    {videoPlaying[key] ? (
                                                      ""
                                                    ) : (
                                                      <FontAwesomeIcon
                                                        className="h-7"
                                                        icon={
                                                          videoPlaying[key]
                                                            ? faPause
                                                            : faPlay
                                                        }
                                                      />
                                                    )}
                                                  </button>
                                                    </div>
                                                  ) : (
                                                    <video
                                                      ref={(el) =>
                                                        (videoRefs.current[
                                                          key
                                                        ] = el)
                                                      }
                                                      autoPlay
                                                      playsInline
                                                      controls
                                                      className="w-full"
                                                      onClick={(e) => {
                                                        e.target.currentTime = 0;
                                                        handleVideoClick1(
                                                          index,
                                                          imageIndex
                                                        );
                                                      }}
                                                    >
                                                      <source
                                                        src={image.image}
                                                      />
                                                    </video>

                                                  )} */}

    {pausedVideoId === post.id && (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
      <FontAwesomeIcon
        icon={faPlay}
        className="text-green-500 text-3xl opacity-60"
      />
    </div>
  )}

<video
  id={post.id}
  ref={(el) => (videosRef.current[post.id] = el)}
  poster={image.thumb}
  src={image.image}
  className="w-full max-h-full object-contain"
  onMouseEnter={() => handleVisibility(post.id, true)}
  onMouseLeave={() => handleVisibility(post.id, false)}
  onClick={() => togglePlay(post.id)}
  loop
  playsInline
  webkit-playsinline="true"
  x5-playsinline="true"
  x-webkit-airplay="deny"
  disablePictureInPicture={true}
  preload="auto"
  autoPlay // ✅ Autoplay enabled
  muted={isMuted} // ✅ Controlled mute state
      onLoadedMetadata={(e) => {
        e.target.setAttribute("playsinline", "true"); // ✅ Force playsInline for iOS
        e.target.setAttribute("muted", "true"); // ✅ Ensure it's muted
        e.target.play().catch((err) => console.warn("Autoplay blocked", err));
        handleVideoCanPlay(post.id,true); // ✅ Call earlier
      }}
      // onCanPlay={(e) => {
      //   console.log(`Video ${post.id} can play now`);
      //   e.target.play(); // ✅ Force play
      //   handleVideoCanPlay(post.id);
      // }}
      onLoadedData={() => handleVideoCanPlay(post.id,true)}
  // onPlay={() => setIsLoading(false)}
/>


              {/* Mute button positioned inside the post at the bottom-right corner */}
<button
  onClick={(e) => {
    e.stopPropagation(); // Prevent click from bubbling to parent
    toggleMute();
  }}
  className="absolute bottom-4 right-4 px-4 py-2 text-sm"
>
  {isMuted ? "🔇" : "🔊"}
</button>
                                                </div>
                                              ) : (
                                                <a
                                                  href={image.image}
                                                  key={`image-${imageIndex}`}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                >
                                                  <img
                                                    src={image.image}
                                                    alt={`Post Image ${
                                                      imageIndex + 1
                                                    }`}
                                                    className="w-full"
                                                    onLoad={(event) =>
                                                      handleImageLoaded(
                                                        event,
                                                        index
                                                      )
                                                    }
                                                  />
                                                </a>
                                              )}
                                            </div>
                                          );
                                        }
                                      )
                                    ) : (
                                      post.post_image.map(
                                        (image, imageIndex) => {
                                          const key = `${index}-${imageIndex}`;
                                          const shouldShowThumbnail =
                                            !showVideos[key] &&
                                            !videoPlaying[key];

                                          return (
                                            <div
                                              key={imageIndex}
                                              className="p-0 pswp-gallery"
                                            >
                                              {videoExtensionsRegex.test(
                                                image.image.split("?")[0]
                                              ) ? (
                                                <div className="relative" onClick={() => togglePlay(post.id)}
                                                >
                                                {isLoadingVideo[post.id] && (
  <div className="absolute inset-0 bg-[#f8f8f8]" aria-busy="true" aria-label="Video loading">
    <SkeletonBlock width="100%" height="100%" rounded="rounded" />
  </div>
)}
                                                  {/* {shouldShowThumbnail ? (
                                                    <div className="relative">
                                                    <img
                                                      src={image.thumb}
                                                      id={`image-${key}`}
                                                      className={"w-full"}
                                                      alt="Video Thumbnail"
                                                      onClick={() =>
                                                        handleVideoClick1(
                                                          index,
                                                          imageIndex
                                                        )
                                                      }
                                                    />
                                                    <button
                                                    id={`play-button-${key}`}
                                                    className={
                                                      videoPlaying[key]
                                                        ? "absolute inset-0 flex rounded-lg items-center justify-center text-white"
                                                        : "absolute inset-0 flex  items-center justify-center bg-black bg-opacity-10 text-white"
                                                    }
                                                    style={{
                                                      display: videoPlaying[key]
                                                        ? "none"
                                                        : "block",
                                                    }}
                                                    onClick={() => {
                                                      handleVideoClick1(
                                                        index,
                                                        imageIndex
                                                      );
                                                    }}
                                                  >
                                                    {videoPlaying[key] ? (
                                                      ""
                                                    ) : (
                                                      <FontAwesomeIcon
                                                        className="h-7"
                                                        icon={
                                                          videoPlaying[key]
                                                            ? faPause
                                                            : faPlay
                                                        }
                                                      />
                                                    )}
                                                  </button>
                                                    </div>
                                                  ) : (
                                                    <video
                                                      ref={(el) =>
                                                        (videoRefs.current[
                                                          key
                                                        ] = el)
                                                      }
                                                      autoPlay
                                                      playsInline
                                                      controls
                                                      className="w-full"
                                                      onClick={(e) => {
                                                        e.target.currentTime = 0;
                                                        handleVideoClick1(
                                                          index,
                                                          imageIndex
                                                        );
                                                      }}
                                                    >
                                                      <source
                                                        src={image.image}
                                                      />
                                                    </video>
                                                  )} */}

                                                                                                      {pausedVideoId === post.id && (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
      <FontAwesomeIcon
        icon={faPlay}
        className="text-green-500 text-3xl opacity-60"
      />
    </div>
  )}

<video
  id={post.id}
  ref={(el) => (videosRef.current[post.id] = el)}
  poster={image.thumb}
  src={image.image}
  className="w-full max-h-full object-contain"
  onMouseEnter={() => handleVisibility(post.id, true)}
  onMouseLeave={() => handleVisibility(post.id, false)}
  onClick={() => togglePlay(post.id)}
  loop
  playsInline
  webkit-playsinline="true"
  x5-playsinline="true"
  x-webkit-airplay="deny"
  disablePictureInPicture={true}
  preload="auto"
  autoPlay // ✅ Autoplay enabled
  muted={isMuted} // ✅ Controlled mute state
      onLoadedMetadata={(e) => {
        e.target.setAttribute("playsinline", "true"); // ✅ Force playsInline for iOS
        e.target.setAttribute("muted", "true"); // ✅ Ensure it's muted
        e.target.play().catch((err) => console.warn("Autoplay blocked", err));
        handleVideoCanPlay(post.id,true); // ✅ Call earlier
      }}
      // onCanPlay={(e) => {
      //   console.log(`Video ${post.id} can play now`);
      //   e.target.play(); // ✅ Force play
      //   handleVideoCanPlay(post.id);
      // }}
      onLoadedData={() => handleVideoCanPlay(post.id,true)}
  // onPlay={() => setIsLoading(false)}
/>


              {/* Mute button positioned inside the post at the bottom-right corner */}
<button
  onClick={(e) => {
    e.stopPropagation(); // Prevent click from bubbling to parent
    toggleMute();
  }}
  className="absolute bottom-4 right-4 px-4 py-2 text-sm"
>
  {isMuted ? "🔇" : "🔊"}
</button>
                                                </div>
                                              ) : (
                                                <a
                                                  href={image.image}
                                                  key={`image-${imageIndex}`}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                >
                                                  <img
                                                    src={image.image}
                                                    alt={`Post Image ${
                                                      imageIndex + 1
                                                    }`}
                                                    className="w-full"
                                                    onLoad={(event) =>
                                                      handleImageLoaded(
                                                        event,
                                                        index
                                                      )
                                                    }
                                                  />
                                                </a>
                                              )}
                                            </div>
                                          );
                                        }
                                      )
                                    )
                                  ) : (
                                    <div className="py-3.5 px-[18px] bg-white">
                                      <p className="text-base whitespace-pre-line font-medium text-black">
                                        {" "}
                                        {post?.repost?.id ? (
                                          <>
                                            {(() => {
                                              const getTrimmedDescription = (
                                                description,
                                                limit
                                              ) => {
                                                if (!description) return "";
                                                if (description.length <= limit)
                                                  return description;

                                                const trimmed =
                                                  description.substring(
                                                    0,
                                                    limit
                                                  );
                                                return (
                                                  trimmed.substring(
                                                    0,
                                                    trimmed.lastIndexOf(" ")
                                                  ) + " "
                                                );
                                              };

                                              const hideUrl = !!linkPreviewData[post?.repost?.id || post.id];
                                              const description =
                                                showFullDescription[index]
                                                  ? post?.description
                                                  : hideUrl
                                                    ? trimTextPreservingUrls(post?.description, 255)
                                                    : getTrimmedDescription(
                                                      post?.description,
                                                      255
                                                    );

                                              if (!description) {
                                                return null;
                                              }

                                              return (
                                                <>
                                                  {renderTextWithLinks(description, hideUrl)}
                                                  {(hideUrl ? getTextOnlyLength(post?.description) > 255 : post?.description?.length > 255) && (
                                                  <>...<button
                                                      onClick={() => {
                                                        setShowFullDescription(
                                                          (prevState) => {
                                                            const newState = [
                                                              ...prevState,
                                                            ];
                                                            newState[index] =
                                                              !newState[index];
                                                            return newState;
                                                          }
                                                        );
                                                      }}
                                                      className="text-[#888888] ml-1"
                                                    >
                                                      {showFullDescription[
                                                        index
                                                      ]
                                                        ? "less"
                                                        : "more"}
                                                    </button>
                                                    </>
                                                  )}
                                                </>
                                              );
                                            })()}
                                          </>
                                        ) : (
                                          <>
                                            {(() => {
                                              const getTrimmedDescription = (
                                                description,
                                                limit
                                              ) => {
                                                if (!description) return "";
                                                if (description.length <= limit)
                                                  return description;

                                                const trimmed =
                                                  description.substring(
                                                    0,
                                                    limit
                                                  );
                                                return (
                                                  trimmed.substring(
                                                    0,
                                                    trimmed.lastIndexOf(" ")
                                                  ) + " "
                                                );
                                              };

                                              const hideUrl = !!linkPreviewData[post?.repost?.id || post.id];
                                              const description =
                                                showFullDescription[index]
                                                  ? post?.description
                                                  : hideUrl
                                                    ? trimTextPreservingUrls(post?.description, 255)
                                                    : getTrimmedDescription(
                                                      post?.description,
                                                      255
                                                    );

                                              if (!description) {
                                                return null;
                                              }

                                              return (
                                                <>
                                                  {renderTextWithLinks(description, hideUrl)}
                                                  {(hideUrl ? getTextOnlyLength(post?.description) > 255 : post?.description?.length > 255) && (
                                                    <>...<button
                                                      onClick={() => {
                                                        setShowFullDescription(
                                                          (prevState) => {
                                                            const newState = [
                                                              ...prevState,
                                                            ];
                                                            newState[index] =
                                                              !newState[index];
                                                            return newState;
                                                          }
                                                        );
                                                      }}
                                                      className="text-[#888888] ml-1"
                                                    >
                                                      {showFullDescription[
                                                        index
                                                      ]
                                                        ? "less"
                                                        : "more"}
                                                    </button>
                                                </>)}
                                                </>
                                              );
                                            })()}
                                          </>
                                        )}
                                      </p>
                                      {linkPreviewData[post?.repost?.id || post.id] && (
                                        <div className="px-[18px] pb-3">
                                          <LinkPreviewCard
                                            url={linkPreviewData[post?.repost?.id || post.id].url}
                                            title={linkPreviewData[post?.repost?.id || post.id].title}
                                            description={linkPreviewData[post?.repost?.id || post.id].description}
                                            image={linkPreviewData[post?.repost?.id || post.id].image}
                                            site_name={linkPreviewData[post?.repost?.id || post.id].site_name}
                                            loading={!!linkPreviewData[post?.repost?.id || post.id]._loading}
                                          />
                                        </div>
                                      )}
                                    </div>
                                  )}

                                        {preview && (
                                          <div
                                            style={{
                                              position: "fixed",
                                              top: 0,
                                              left: 0,
                                              width: "100%",
                                              height: "100%",
                                              backgroundColor:
                                                "rgba(0, 0, 0, 0.5)",
                                              opacity: "1",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              zIndex: 1000, // Set a higher value to ensure it's above the sidebar
                                            }}
                                            onClick={() => setPreview(false)}
                                          >
                                            <TransformWrapper
                                              defaultScale={1}
                                              defaultPositionX={200}
                                              defaultPositionY={100}
                                              className="flex items-center justify-center"
                                            >
                                              {({
                                                zoomIn,
                                                zoomOut,
                                                resetTransform,
                                                positionX,
                                                positionY,
                                                ...rest
                                              }) => (
                                                <>
                                                  <TransformComponent className="flex items-center justify-center">
                                                    <img
                                                      src={activeImage}
                                                      alt="Preview"
                                                      className={
                                                        isMobileView
                                                          ? "ml-3"
                                                          : "ml-6"
                                                      }
                                                      style={{
                                                        maxWidth: "95%",
                                                        maxHeight: "100%",
                                                        objectFit: "contain",
                                                      }}
                                                    />
                                                  </TransformComponent>
                                                </>
                                              )}
                                            </TransformWrapper>
                                          </div>
                                        )}
                                      </div>
                                      <div className="p-4 space-y-2">
                                      <div className="flex items-center justify-between">
                                      <div className="flex items-center gap-4">

                                      <button
                                          onClick={() =>
                                            handleLikeDislike(
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id,
                                              post.total_likes
                                            )
                                          }
                                          className="flex flex-row justify-center items-center"
                                        >

                                          {post?.repost?.id
                                            ? post?.repost?.is_like_by_me
                                              ? HeartFilledIcon
                                              : HeartIcon
                                            : post?.is_like_by_me
                                            ? HeartFilledIcon
                                            : HeartIcon}

                                          <p className="ml-1 md:text-xs text-base">
                                            {post?.repost?.id
                                              ? post?.repost?.total_likes
                                              : post.total_likes}
                                          </p>

                                        </button>

                                        <button
                                          onClick={() =>
                                            handleCommentToggle(
                                              index,
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id
                                            )
                                          }
                                          className="flex flex-row justify-center items-center"
                                        >
                                          {CommentIcon}
                                          <p className="ml-1 md:text-xs text-base">
                                            {post?.repost?.id
                                              ? post?.repost?.total_comments
                                              : post.total_comments}
                                          </p>
                                        </button>

                                        <button
                                          onClick={() =>
                                            handleShare(
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id
                                            )
                                          }
                                          className="flex flex-row justify-center items-center"
                                        >
                                          <FontAwesomeIcon
                                            icon={faArrowUpFromBracket}
                                          />
                                        </button>


                                                                                <button
                                          disabled={isDisabled ? true : false}
                                          onClick={() =>
                                            handleRepost(
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id,
                                              post,
                                              post.id
                                            )
                                          }
                                          className="flex flex-row justify-center items-center "
                                        >
                                          {RepostIcon}
                                          <p className="ml-1 md:text-xs text-base">
                                            {post?.repost?.id
                                              ? post?.repost?.repost_count
                                              : post.repost_count}
                                          </p>
                                        </button>


</div>

                                        {/* <button
                                          disabled={isDisabled ? true : false}
                                          onClick={() =>
                                            handleLikeDislike(
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id,
                                              post?.repost?.id
                                                ? post?.repost?.total_likes
                                                : post.total_likes
                                            )
                                          }
                                          className="flex flex-row justify-center items-center"
                                        >
                                          {post?.repost?.id ? (
                                            <FontAwesomeIcon
                                              icon={
                                                post?.repost?.is_like_by_me
                                                  ? faHeart
                                                  : empty
                                              }
                                            />
                                          ) : (
                                            <FontAwesomeIcon
                                              icon={
                                                post?.is_like_by_me
                                                  ? faHeart
                                                  : empty
                                              }
                                            />
                                          )}
                                          <p className="ml-1 md:text-xs text-base">
                                            {post?.repost?.id
                                              ? post?.repost?.total_likes
                                              : post.total_likes}
                                          </p>
                                        </button> */}
                                      <button
                                        disabled={isDisabled ? true : false}
                                        onClick={() =>
                                          handleSavePost(
                                            post?.repost?.id
                                              ? post?.repost?.id
                                              : post.id
                                          )
                                        }
                                      >
                                        {post?.repost?.id ? (
                                              post?.repost?.is_saved
                                                ? <>{SaveIconFill}</>
                                                :  <>{SaveIcon}</>
                                        ) : (
                                              post.is_saved ? <>{SaveIconFill}</>
                                                :<> {SaveIcon}</>
                                        )}
                                      </button>

                                        {/* <button className="flex flex-row justify-center items-center ">
                                        <FontAwesomeIcon icon={faChartSimple} />
                                        <p className="ml-1 md:text-xs text-xxs">2,434</p>
                                        </button> */}
                                        {isModalOpen && newid === post.id && (
                                          <div
                                            className={
                                              isMobileView
                                                ? "fixed top-0 left-0 h-full flex items-center justify-center right-5"
                                                : "fixed top-0 left-0 w-full h-full flex items-center justify-center"
                                            }
                                          >
                                            <div className="bg-white p-6 rounded shadow-lg text-center">
                                              {/* Modal content goes here */}
                                              <div className="flex justify-center items-center my-2">
                                                <img
                                                  src={"/qushi_logo.png"}
                                                  className="h-24"
                                                  alt="logo"
                                                />
                                              </div>
                                              <p className="mb-4 text-primaryColor">
                                                Delete this post? This can't be
                                                undone.
                                              </p>
                                              <div className="flex justify-center">
                                                <button
                                                  onClick={handleCloseModal}
                                                  className="bg-white border border-gray-300 text-gray-700 py-2 px-4 rounded mr-2"
                                                >
                                                  Cancel
                                                </button>
                                                <button
                                                  disabled={
                                                    isDisabled ? true : false
                                                  }
                                                  onClick={handleDelete}
                                                  className="bg-red-500 text-white py-2 px-4 rounded"
                                                >
                                                  Delete
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                      <p>
                                      <span className="text-sm font-semibold">
                                        {/* {post?.repost?.id
                                          ? post?.repost?.total_likes
                                          : post.total_likes}{" "}
                                        likes */}
                                        {post?.user?.user_name}
                                      </span>{" "}
                                      <span className="text-[#888888] px-2">
                                        ·
                                      </span>
                                      <span className="text-[#888888] text-[12px] font-semibold">
                                        {calculateTimeDifference(
                                          post?.repost?.id
                                            ? post?.repost?.created_at
                                            : post.created_at
                                        )}
                                      </span>
                                    </p>
                                    {post.post_image?.length > 0 && (
                                      <p className="text-base font-medium whitespace-pre-line text-black">
                                        {" "}
                                        {post?.repost?.id ? (
                                          <>
                                            {(() => {
                                              const getTrimmedDescription = (
                                                description,
                                                limit
                                              ) => {
                                                if (!description) return "";
                                                if (description.length <= limit)
                                                  return description;

                                                const trimmed =
                                                  description.substring(
                                                    0,
                                                    limit
                                                  );
                                                return (
                                                  trimmed.substring(
                                                    0,
                                                    trimmed.lastIndexOf(" ")
                                                  ) + " "
                                                );
                                              };

                                              const hideUrl = !!linkPreviewData[post?.repost?.id || post.id];
                                              const description =
                                                showFullDescription[index]
                                                  ? post?.description
                                                  : hideUrl
                                                    ? trimTextPreservingUrls(post?.description, 255)
                                                    : getTrimmedDescription(
                                                      post?.description,
                                                      255
                                                    );

                                              if (!description) {
                                                return null;
                                              }

                                              return (
                                                <>
                                                  {renderTextWithLinks(description, hideUrl)}
                                                  {(hideUrl ? getTextOnlyLength(post?.description) > 255 : post?.description?.length > 255) && (
                                                  <>...<button
                                                      onClick={() => {
                                                        setShowFullDescription(
                                                          (prevState) => {
                                                            const newState = [
                                                              ...prevState,
                                                            ];
                                                            newState[index] =
                                                              !newState[index];
                                                            return newState;
                                                          }
                                                        );
                                                      }}
                                                      className="text-[#888888] ml-1"
                                                    >
                                                      {showFullDescription[
                                                        index
                                                      ]
                                                        ? "less"
                                                        : "more"}
                                                    </button>
                                                    </>
                                                  )}
                                                </>
                                              );
                                            })()}
                                          </>
                                        ) : (
                                          <>
                                            {(() => {
                                              const getTrimmedDescription = (
                                                description,
                                                limit
                                              ) => {
                                                if (!description) return "";
                                                if (description.length <= limit)
                                                  return description;

                                                const trimmed =
                                                  description.substring(
                                                    0,
                                                    limit
                                                  );
                                                return (
                                                  trimmed.substring(
                                                    0,
                                                    trimmed.lastIndexOf(" ")
                                                  ) + " "
                                                );
                                              };

                                              const hideUrl = !!linkPreviewData[post?.repost?.id || post.id];
                                              const description =
                                                showFullDescription[index]
                                                  ? post?.description
                                                  : hideUrl
                                                    ? trimTextPreservingUrls(post?.description, 255)
                                                    : getTrimmedDescription(
                                                      post?.description,
                                                      255
                                                    );

                                              if (!description) {
                                                return null;
                                              }

                                              return (
                                                <>
                                                  {renderTextWithLinks(description, hideUrl)}
                                                  {(hideUrl ? getTextOnlyLength(post?.description) > 255 : post?.description?.length > 255) && (
                                                      <>
                                                    ... <button
                                                      onClick={() => {
                                                        setShowFullDescription(
                                                          (prevState) => {
                                                            const newState = [
                                                              ...prevState,
                                                            ];
                                                            newState[index] =
                                                              !newState[index];
                                                            return newState;
                                                          }
                                                        );
                                                      }}
                                                      className="text-[#888888]"
                                                    >
                                                      {showFullDescription[
                                                        index
                                                      ]
                                                        ? "less"
                                                        : "more"}
                                                    </button>
                                                  </>)}
                                                </>
                                              );
                                            })()}
                                          </>
                                        )}
                                      </p>
                                    )}

                                      {commentOpenStates[index] && (
                                        <div className="mt-4 text-black ml-[20px] md:ml-[60px] lg:ml-[60px]">
                                          <div className="mt-4 space-y-4">
                                            {postComments[
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id
                                            ] &&
                                            postComments[
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id
                                            ].length > 0 ? (
                                              postComments[
                                                post?.repost?.id
                                                  ? post?.repost?.id
                                                  : post.id
                                              ].map((comment) => (
                                                <div
                                                  key={comment.id}
                                                  className="flex items-start mb-2"
                                                >
                                                  <div className="flex-shrink-0">
                                                    <img
                                                      src={comment?.user?.image}
                                                      alt={`${comment?.user?.user_name}'s avatar`}
                                                      className="w-10 h-10 rounded-full mr-2 cursor-pointer hover:opacity-80 transition-opacity"
                                                      onClick={(e) => navigateToUserProfile(e, comment?.user?.id)}
                                                    />
                                                  </div>
                                                  <div className="w-full">
                                                    <div className="flex justify-between mb-1">
                                                      <span
                                                        className="font-semibold ml-2 cursor-pointer hover:underline"
                                                        onClick={(e) => navigateToUserProfile(e, comment?.user?.id)}
                                                      >
                                                        {
                                                          comment?.user
                                                            ?.user_name
                                                        }
                                                      </span>

                                                      {comment?.user.id ===
                                                        userInfo?.id && (
                                                        <button
                                                          disabled={
                                                            isDisabled
                                                              ? true
                                                              : false
                                                          }
                                                          className="px-5 text-green-500"
                                                          onClick={() =>
                                                            handleDeleteComment(
                                                              comment.id
                                                            )
                                                          }
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faTrash}
                                                          />
                                                        </button>
                                                      )}
                                                    </div>
                                                    <div className="flex justify-between">
                                                      <div
                                                        className={
                                                          "md:w-full w-52 ml-2"
                                                        }
                                                      >
                                                        {comment?.comment && (
                                                          <p className="w-full break-words text-lg" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                                            {comment?.comment}
                                                          </p>
                                                        )}
                                                        {comment?.image && (
                                                          <div className="pswp-comment-gallery mt-1.5">
                                                            <a href={comment.image} data-pswp-width="800" data-pswp-height="600" target="_blank" rel="noreferrer">
                                                              <img
                                                                src={comment.image}
                                                                alt="Comment image"
                                                                className="rounded-lg max-w-[200px] max-h-[200px] object-cover cursor-pointer"
                                                                loading="lazy"
                                                                onLoad={(e) => handleImageLoaded(e, 0)}
                                                              />
                                                            </a>
                                                          </div>
                                                        )}
                                                      </div>
                                                    </div>
                                                  {/* Reply button + View replies */}
                                                  <div className="flex items-center gap-3 ml-2 mt-1">
                                                    <button
                                                      className="text-xs text-gray-500 font-semibold hover:text-gray-700"
                                                      onClick={() => handleReply(comment, post?.repost?.id ? post?.repost?.id : post.id)}
                                                    >
                                                      Reply
                                                    </button>
                                                    {comment.replies_count > 0 && (
                                                      <button
                                                        className="text-xs text-blue-500 font-semibold hover:text-blue-700"
                                                        onClick={() => toggleReplies(comment.id)}
                                                      >
                                                        {expandedReplies[comment.id]
                                                          ? 'Hide replies'
                                                          : `View ${comment.replies_count} ${comment.replies_count === 1 ? 'reply' : 'replies'}`}
                                                      </button>
                                                    )}
                                                  </div>
                                                  {/* Nested replies */}
                                                  {expandedReplies[comment.id] && comment.replies?.length > 0 && (
                                                    <div className="ml-8 mt-2 space-y-3 border-l-2 border-gray-200 pl-3">
                                                      {comment.replies.map((reply) => (
                                                        <div key={reply.id} className="flex items-start">
                                                          <div className="flex-shrink-0">
                                                            <img
                                                              src={reply?.user?.image}
                                                              alt={`${reply?.user?.user_name}'s avatar`}
                                                              className="w-7 h-7 rounded-full mr-2 cursor-pointer hover:opacity-80 transition-opacity"
                                                              onClick={(e) => navigateToUserProfile(e, reply?.user?.id)}
                                                            />
                                                          </div>
                                                          <div className="flex-1">
                                                            <div className="flex justify-between mb-0.5">
                                                              <span
                                                                className="font-semibold text-base ml-1 cursor-pointer hover:underline"
                                                                onClick={(e) => navigateToUserProfile(e, reply?.user?.id)}
                                                              >
                                                                {reply?.user?.user_name}
                                                              </span>
                                                              {reply?.user?.id === userInfo?.id && (
                                                                <button
                                                                  disabled={isDisabled}
                                                                  className="px-3 text-green-500"
                                                                  onClick={() => handleDeleteComment(reply.id)}
                                                                >
                                                                  <FontAwesomeIcon icon={faTrash} />
                                                                </button>
                                                              )}
                                                            </div>
                                                            {reply?.comment && (
                                                              <p className="w-full break-words text-lg ml-1" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                                                {reply.comment}
                                                              </p>
                                                            )}
                                                            {reply?.image && (
                                                              <div className="pswp-comment-gallery mt-1">
                                                                <a href={reply.image} data-pswp-width="800" data-pswp-height="600" target="_blank" rel="noreferrer">
                                                                  <img
                                                                    src={reply.image}
                                                                    alt="Reply image"
                                                                    className="rounded-lg max-w-[150px] max-h-[150px] object-cover cursor-pointer"
                                                                    loading="lazy"
                                                                    onLoad={(e) => handleImageLoaded(e, 0)}
                                                                  />
                                                                </a>
                                                              </div>
                                                            )}
                                                            <button
                                                              className="text-xs text-gray-500 font-semibold hover:text-gray-700 ml-1 mt-1"
                                                              onClick={() => handleReply(comment, post?.repost?.id ? post?.repost?.id : post.id)}
                                                            >
                                                              Reply
                                                            </button>
                                                          </div>
                                                        </div>
                                                      ))}
                                                    </div>
                                                  )}
                                                  </div>
                                                </div>
                                              ))
                                            ) : loadingComment ? (
                                              <ListSkeleton
                                                rows={2}
                                                avatarSize={32}
                                                columns={0}
                                                divided={false}
                                                rowClassName="py-3 px-4"
                                              />
                                            ) : (
                                              <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
                                                <p>No comments yet</p>
                                              </div>
                                            )}
                                          </div>

                                          {replyingTo && (
                                            <div className="flex items-center justify-between bg-gray-100 px-3 py-2 rounded-t mb-0">
                                              <span className="text-sm text-gray-600">
                                                Replying to <span className="font-semibold">@{replyingTo.userName}</span>
                                              </span>
                                              <button
                                                className="text-sm text-gray-500 hover:text-gray-700 font-semibold"
                                                onClick={handleCancelReply}
                                              >
                                                Cancel
                                              </button>
                                            </div>
                                          )}
                                          {commentImagePreview && (
                                            <div className="mb-2 relative inline-block">
                                              <img src={commentImagePreview} alt="Preview" className="h-20 w-20 object-cover rounded-lg border border-gray-200" />
                                              <button
                                                className="absolute -top-1.5 -right-1.5 w-5 h-5 bg-gray-800 text-white rounded-full flex items-center justify-center text-xs"
                                                onClick={() => { setCommentImage(null); setCommentImagePreview(null); }}
                                              >&times;</button>
                                            </div>
                                          )}
                                          <div className="flex">
                                            <textarea
                                              value={newComment}
                                              onChange={(e) => setNewComment(e.target.value)}
                                              placeholder="Add a comment..."
                                              className="p-2 border border-emerald-500 rounded w-full text-black"
                                              style={{ flex: 1, resize: 'none', maxHeight: '150px', overflowY: 'auto' }}
                                              rows={4}
                                            />
                                            <div className="flex flex-col ml-2 gap-1">
                                              <button
                                                className="bg-gray-200 hover:bg-gray-300 text-gray-600 px-2 rounded-full focus:outline-none flex items-center justify-center"
                                                onClick={() => commentImageInputRef.current?.click()}
                                                style={{ height: 30, minWidth: 84 }}
                                              >
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-1">
                                                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                                                  <circle cx="8.5" cy="8.5" r="1.5" />
                                                  <polyline points="21 15 16 10 5 21" />
                                                </svg>
                                                Image
                                              </button>
                                              <button
                                                className="bg-primaryColor text-gray-200 hover:bg-primaryColor hover:text-white px-2 rounded-full focus:outline-none"
                                                disabled={isDisabled || (!newComment.trim() && !commentImage)}
                                                onClick={() =>
                                                  handleAddComment(
                                                    post?.repost?.id
                                                      ? post?.repost?.id
                                                      : post.id,
                                                    index
                                                  )
                                                }
                                                style={{ height: 30, minWidth: 84 }}
                                              >
                                                Submit
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                              {(post?.repost?.id ? post?.repost?.total_comments : post.total_comments) >= 1 && (
                                <p
                                  onClick={() =>
                                    handleCommentToggle(
                                      index,
                                      post?.repost?.id ? post?.repost?.id : post.id
                                    )
                                  }
                                  className="cursor-pointer text-[#888888]"
                                >
                                  View all{" "}
                                  <span>
                                    {post?.repost?.id ? post?.repost?.total_comments : post.total_comments}
                                  </span>{" "}
                                  comments
                                </p>
                              )}
                              </div>
                                      <div className="w-full mt-3 h-px bg-[#F3F4F6]"></div>{" "}
                                    </div>
                                  ) : (
                                    <div
                                      key={index}
                                      className={
                                        isMobileView
                                          ? "text-white px-2 py-2  flex flex-col"
                                          : "text-white p-4  flex flex-col"
                                      }
                                    >
                                      {post.is_pinned && (
                                        <div
                                          className={`flex items-center gap-1.5 mb-2 text-xs font-semibold ${
                                            isPrivateProfile
                                              ? "text-primaryColor"
                                              : "text-green-600"
                                          }`}
                                        >
                                          <img
                                            src={`${process.env.PUBLIC_URL}/${
                                              location.pathname.startsWith(
                                                "/profile/"
                                              )
                                                ? "PinnedPost.svg"
                                                : "PinnedVectorDark.svg"
                                            }`}
                                            alt="Pinned"
                                            className="w-3 h-3"
                                          />
                                          <span>Pinned post</span>
                                        </div>
                                      )}
                                      {post?.repost?.id && (
                                        <div className="mt-4 text-black">
                                          <div className="flex items-center mb-2 ml-12">
                                            <FontAwesomeIcon
                                              className="text-primaryColor mr-2"
                                              icon={faRepeat}
                                            />
                                            <p
                                              className="text-md font-bold"
                                              style={{ color: "#004c50" }}
                                            >
                                              {post?.user?.user_name} Reposted
                                            </p>
                                          </div>
                                        </div>
                                      )}
                                      <div className="flex items-center mb-2 justify-between">
                                        <div className="flex items-center">
                                          <div
                                            className={
                                              isMobileView ? "w-10" : ""
                                            }
                                          >
                                            <Link
                                              to={
                                                post?.repost?.id
                                                  ? profilePath(post?.repost?.user?.id)
                                                  : ""
                                              }
                                              className={
                                                isMobileView ? "w-10" : ""
                                              }
                                            >
                                              <img
                                                src={
                                                  post?.repost?.id
                                                    ? post?.repost?.user?.image
                                                    : post?.user?.image
                                                }
                                                className={
                                                  isMobileView
                                                    ? "object-cover h-10 w-full mr-2 rounded-full"
                                                    : "object-cover h-10 w-10  rounded-full"
                                                }
                                                alt={`${
                                                  post?.repost?.id
                                                    ? post?.repost?.user
                                                        ?.user_name
                                                    : post.user.user_name
                                                }'s profile`}
                                              />
                                            </Link>
                                          </div>
                                          <div className="flex">
                                            {/* <span
                                                className={
                                                isMobileView
                                                    ? "ml-2 text-[13px] text-black font-bold font-poppins whitespace-nowrap"
                                                    : "px-1 ml-2 text-[13px] text-black font-bold font-poppins whitespace-nowrap"
                                                }
                                            >
                                                {post?.repost?.id
                                                ? post?.repost?.user?.user_name
                                                : post.user.user_name}
                                            </span> */}

                                            <span
                                              className={
                                                isMobileView
                                                  ? "px-1 -mt-1.5 text-[20px] text-black font-bold font-poppins truncate"
                                                  : "px-1 text-[20px] text-black font-bold font-poppins truncate"
                                              }
                                            >
                                              {post?.repost?.id
                                                ? post?.repost?.user?.user_name
                                                : post.user.user_name}
                                            </span>
                                            {profile.green_tick ? (
                                              <img
                                                src={GreenTick}
                                                className="ml-1 w-5 h-5"
                                                alt="green-tick"
                                              />
                                            ) : // <FontAwesomeIcon icon={faCheckCircle} className="px-1 text-xl md:text-2xl text-primaryColor" />
                                            null}
                                          </div>
                                        </div>
                                        <div className="flex">
                                          <span
                                            className={
                                              isMobileView
                                                ? "ml-[10px] mt-1 truncate white text-base text-gray-600 font-poppins"
                                                : "md:ml-[313px] ml-[80px] mt-1 truncate white text-base text-gray-600 font-poppins"
                                            }
                                          >
                                            {calculateTimeDifference(
                                              post?.repost?.id
                                                ? post?.repost?.created_at
                                                : post.created_at
                                            )}
                                          </span>
                                          {userId == user_id ? (
                                            <div
                                              style={{ position: "relative" }}
                                              className="ml-4"
                                              data-post-menu
                                            >
                                              <button
                                                onClick={() =>
                                                  toggleDropdown(post.id)
                                                }
                                                type="button"
                                                className={
                                                  isMobileView
                                                    ? "z-50 px-4 py-2 bg-white-400 text-green-700 rounded hover:bg-primaryColor hover:text-white flex items-center"
                                                    : "z-50 px-4 py-2 bg-white-400 text-green-700 rounded hover:bg-primaryColor hover:text-white flex items-center"
                                                }
                                                style={{ zIndex: 7 }}
                                              >
                                                <FontAwesomeIcon
                                                  icon={
                                                    isMobileView
                                                      ? faEllipsisV
                                                      : faEllipsisH
                                                  }
                                                  className=""
                                                />
                                              </button>
                                              {openMenuPostId === post.id && (
                                                <div style={{ zIndex: 1 }} className="z-50 absolute top-8 text-green-500 right-0 md:right-auto md:left-0 w-10 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 md:mr-[220px] mr-[20px]">
                                                  <button
                                                    onClick={() =>
                                                      handlePinPost(post.id)
                                                    }
                                                    className={`block w-full px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900 ${
                                                      post.is_pinned
                                                        ? "text-green-600"
                                                        : "text-primaryColor"
                                                    }`}
                                                    role="menuitem"
                                                    title={
                                                      post.is_pinned
                                                        ? "Unpin"
                                                        : "Pin to profile"
                                                    }
                                                  >
                                                    <div className="flex flex-row justify-center items-center">
                                                      <FontAwesomeIcon
                                                        icon={faThumbtack}
                                                      />
                                                    </div>
                                                  </button>
                                                  <button
                                                    onClick={() =>
                                                      handleDeletePost(post.id)
                                                    }
                                                    className="block text-primaryColor px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                                    role="menuitem"
                                                  >
                                                    <div className="flex flex-row justify-center items-center">
                                                      <FontAwesomeIcon
                                                        icon={faTrash}
                                                      />
                                                    </div>
                                                  </button>
                                                  {post?.repost?.id ? (
                                                    ""
                                                  ) : (
                                                    <button
                                                      onClick={() =>
                                                        handleEditClick(
                                                          post?.repost?.id
                                                            ? post?.repost?.id
                                                            : post.id,
                                                          post?.repost?.id
                                                            ? post?.repost?.created_at
                                                            : post?.created_at
                                                        )
                                                      }
                                                      className="block px-4 py-2 text-sm text-primaryColor hover:bg-gray-100 hover:text-gray-900"
                                                      role="menuitem"
                                                    >
                                                      <div className="flex flex-row justify-center items-center">
                                                        <FontAwesomeIcon
                                                          icon={faEdit}
                                                        />
                                                      </div>
                                                    </button>
                                                  )}
                                                </div>
                                              )}
                                            </div>
                                          ) : !userId ? (
                                            <div
                                              style={{ position: "relative" }}
                                              className="ml-4"
                                              data-post-menu
                                            >
                                              <button
                                                onClick={() =>
                                                  toggleDropdown(post.id)
                                                }
                                                type="button"
                                                className={
                                                  isMobileView
                                                    ? "px-4 py-2 bg-white-400 text-green-700 rounded hover:bg-primaryColor hover:text-white flex items-center"
                                                    : "px-4 py-2 bg-white-400 text-green-700 rounded hover:bg-primaryColor hover:text-white flex items-center"
                                                }
                                                style={{ zIndex: 7 }} // Ensure button is above the dropdown
                                              >
                                                <FontAwesomeIcon
                                                  icon={
                                                    isMobileView
                                                      ? faEllipsisV
                                                      : faEllipsisH
                                                  }
                                                  className=""
                                                />
                                              </button>
                                              {openMenuPostId === post.id && (
                                                <div style={{ zIndex: 1 }} className="absolute top-8 text-green-500 right-0 md:right-auto md:left-0 w-10 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 md:mr-[220px] mr-[20px]">
                                                  <button
                                                    onClick={() =>
                                                      handlePinPost(post.id)
                                                    }
                                                    className={`block w-full px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900 ${
                                                      post.is_pinned
                                                        ? "text-green-600"
                                                        : "text-primaryColor"
                                                    }`}
                                                    role="menuitem"
                                                    title={
                                                      post.is_pinned
                                                        ? "Unpin"
                                                        : "Pin to profile"
                                                    }
                                                  >
                                                    <div className="flex flex-row justify-center items-center">
                                                      <FontAwesomeIcon
                                                        icon={faThumbtack}
                                                      />
                                                    </div>
                                                  </button>
                                                  <button
                                                    onClick={() =>
                                                      handleDeletePost(post.id)
                                                    }
                                                    className="block text-primaryColor px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                                    role="menuitem"
                                                  >
                                                    <div className="flex flex-row justify-center items-center">
                                                      <FontAwesomeIcon
                                                        icon={faTrash}
                                                      />
                                                    </div>
                                                  </button>
                                                  {post?.repost?.id ? (
                                                    ""
                                                  ) : (
                                                    <button
                                                      onClick={() =>
                                                        handleEditClick(
                                                          post?.repost?.id
                                                            ? post?.repost?.id
                                                            : post.id,
                                                          post?.repost?.id
                                                            ? post?.repost?.created_at
                                                            : post?.created_at
                                                        )
                                                      }
                                                      className="block px-4 py-2 text-sm text-primaryColor hover:bg-gray-100 hover:text-gray-900"
                                                      role="menuitem"
                                                    >
                                                      <div className="flex flex-row justify-center items-center">
                                                        <FontAwesomeIcon
                                                          icon={faEdit}
                                                        />
                                                      </div>
                                                    </button>
                                                  )}
                                                </div>
                                              )}
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>
                                      <div
                                        className={
                                          isMobileView
                                            ? "ml-12 px-0 my-2 sm:px-10 font-poppins"
                                            : "ml-3 px-0 my-2 sm:px-10 font-poppins"
                                        }
                                      >
                                        {post?.repost?.id ? (
                                          <div className="text-[18px] font-poppins text-[#707070] whitespace-pre-line">
                                            {(() => {
                                              const getTrimmedDescription = (
                                                description,
                                                limit
                                              ) => {
                                                if (!description) return "";
                                                if (description.length <= limit)
                                                  return description;

                                                const trimmed =
                                                  description.substring(
                                                    0,
                                                    limit
                                                  );
                                                return (
                                                  trimmed.substring(
                                                    0,
                                                    trimmed.lastIndexOf(" ")
                                                  ) + " "
                                                );
                                              };

                                              const hideUrl = !!linkPreviewData[post?.repost?.id || post.id];
                                              const description =
                                                showFullDescription[index]
                                                  ? post?.description
                                                  : hideUrl
                                                    ? trimTextPreservingUrls(post?.description, 255)
                                                    : getTrimmedDescription(
                                                      post?.description,
                                                      255
                                                    );

                                              if (!description) {
                                                return null;
                                              }

                                              return (
                                                <>
                                                  {renderTextWithLinks(description, hideUrl)}
                                                  {(hideUrl ? getTextOnlyLength(post?.description) > 255 : post?.description?.length > 255) && (
                                                    <button
                                                      onClick={() => {
                                                        setShowFullDescription(
                                                          (prevState) => {
                                                            const newState = [
                                                              ...prevState,
                                                            ];
                                                            newState[index] =
                                                              !newState[index];
                                                            return newState;
                                                          }
                                                        );
                                                      }}
                                                      className="text-green-500 ml-2"
                                                    >
                                                      {showFullDescription[
                                                        index
                                                      ]
                                                        ? "Show less"
                                                        : "Show more"}
                                                    </button>
                                                  )}
                                                </>
                                              );
                                            })()}
                                          </div>
                                        ) : (
                                          <div className="text-[18px] font-poppins text-[#707070] whitespace-pre-line">
                                            {(() => {
                                              const getTrimmedDescription = (
                                                description,
                                                limit
                                              ) => {
                                                if (!description) return "";
                                                if (description.length <= limit)
                                                  return description;

                                                const trimmed =
                                                  description.substring(
                                                    0,
                                                    limit
                                                  );
                                                return (
                                                  trimmed.substring(
                                                    0,
                                                    trimmed.lastIndexOf(" ")
                                                  ) + " "
                                                );
                                              };

                                              const hideUrl = !!linkPreviewData[post?.repost?.id || post.id];
                                              const description =
                                                showFullDescription[index]
                                                  ? post?.description
                                                  : hideUrl
                                                    ? trimTextPreservingUrls(post?.description, 255)
                                                    : getTrimmedDescription(
                                                      post?.description,
                                                      255
                                                    );

                                              if (!description) {
                                                return null;
                                              }

                                              return (
                                                <>
                                                  {renderTextWithLinks(description, hideUrl)}
                                                  {(hideUrl ? getTextOnlyLength(post?.description) > 255 : post?.description?.length > 255) && (
                                                    <button
                                                      onClick={() => {
                                                        setShowFullDescription(
                                                          (prevState) => {
                                                            const newState = [
                                                              ...prevState,
                                                            ];
                                                            newState[index] =
                                                              !newState[index];
                                                            return newState;
                                                          }
                                                        );
                                                      }}
                                                      className="text-green-500 ml-2"
                                                    >
                                                      {showFullDescription[
                                                        index
                                                      ]
                                                        ? "Show less"
                                                        : "Show more"}
                                                    </button>
                                                  )}
                                                </>
                                              );
                                            })()}
                                          </div>
                                        )}
                                      </div>
                                      {linkPreviewData[post?.repost?.id || post.id] && (
                                        <LinkPreviewCard
                                          url={linkPreviewData[post?.repost?.id || post.id].url}
                                          title={linkPreviewData[post?.repost?.id || post.id].title}
                                          description={linkPreviewData[post?.repost?.id || post.id].description}
                                          image={linkPreviewData[post?.repost?.id || post.id].image}
                                          site_name={linkPreviewData[post?.repost?.id || post.id].site_name}
                                          loading={!!linkPreviewData[post?.repost?.id || post.id]._loading}
                                        />
                                      )}
                                      <div
                                        className={
                                          isMobileView
                                            ? "ml-12  flex px-0 my-2 sm:px-10 flex-wrap pswp-gallery"
                                            : "ml-6  flex px-0 my-2 sm:px-10 flex-wrap pswp-gallery"
                                        }
                                      >
                                        {post?.repost?.id
                                          ? post?.repost?.post_image.map(
                                              (image, imageIndex) => {
                                                const key = `${index}-${imageIndex}`;
                                                const shouldShowThumbnail =
                                                  !showVideos[key] &&
                                                  !videoPlaying[key];
                                                return (
                                                  <div
                                                    key={imageIndex}
                                                    className="mr-2 mb-2"
                                                  >
                                                    {videoExtensionsRegex.test(
                                                      image.image.split("?")[0]
                                                    ) ? (
                                                <div
                                                  className={`relative ${
                                                    post?.repost?.post_image.length == 1
                                                      ? isMobileView
                                                        ? "w-[300px] h-[350px] rounded-lg"
                                                        : "w-[780px] h-[400px] rounded-lg"
                                                      : isMobileView
                                                      ? "w-[300px] h-[350px] rounded-lg"
                                                      : "w-[780px] h-[400px] rounded-lg"
                                                  }`} onClick={() => togglePlay(post.id)}
                                                >

                                                    {pausedVideoId === post.id && (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
      <FontAwesomeIcon
        icon={faPlay}
        className="text-green-500 text-3xl opacity-60"
      />
    </div>
  )}

                                                                                <video
                id={post.id}
                data-id={post.id}
                ref={(el) => (videosRef.current[post.id] = el)}
                poster={image.thumb}
                src={image.image}
                className="w-full max-h-full object-contain"
                // onMouseEnter={() => handleVisibility(post.id, true)}
                // onMouseLeave={() => handleVisibility(post.id, false)}
                onClick={() => togglePlay(post.id)}
                loop
                muted={isMuted}
                playsInline
                onLoadedData={() => handleVideoCanPlay(post.id,true)}
              />
              {/* Mute button positioned inside the post at the bottom-right corner */}
<button
  onClick={(e) => {
    e.stopPropagation(); // Prevent click from bubbling to parent
    toggleMute();
  }}
  className="absolute bottom-4 right-4 px-4 py-2 text-sm"
>
  {isMuted ? "🔇" : "🔊"}
</button>
                                                      </div>
                                                    ) : (
                                                      <div
                                                        id={`gallery-${post.id}`}
                                                        style={galleryStyles}
                                                      >
                                                        <a
                                                          href={image.image}
                                                          key={`image-${imageIndex}`}
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                          style={linkStyles}
                                                        >
                                                          <img
                                                            src={image.image}
                                                            alt={`Post Image ${
                                                              imageIndex + 1
                                                            }`}
                                                            style={imageStyles}
                                                            onLoad={(event) =>
                                                              handleImageLoaded(
                                                                event,
                                                                index
                                                              )
                                                            }
                                                          />
                                                        </a>
                                                      </div>
                                                    )}
                                                  </div>
                                                );
                                              }
                                            )
                                          : post.post_image.map(
                                              (image, imageIndex) => {
                                                const key = `${index}-${imageIndex}`;
                                                const shouldShowThumbnail =
                                                  !showVideos[key] &&
                                                  !videoPlaying[key];
                                                return (
                                                  <div
                                                    key={imageIndex}
                                                    className="mr-2 mb-2"
                                                  >
                                                    {videoExtensionsRegex.test(
                                                      image.image.split("?")[0]
                                                    ) ? (
                                                <div
                                                    className={`relative ${
                                                      post?.repost?.post_image.length == 1
                                                        ? isMobileView
                                                          ? "w-[300px] h-[350px] rounded-lg"
                                                          : "w-[780px] h-[400px] rounded-lg"
                                                        : isMobileView
                                                        ? "w-[300px] h-[350px] rounded-lg"
                                                        : "w-[780px] h-[400px] rounded-lg"
                                                    }`} onClick={() => togglePlay(post.id)}
                                                >
                                                        {/* {shouldShowThumbnail ? (
                                                          <div>
                                                            <img
                                                              src={image.thumb}
                                                              id={`image-${key}`}
                                                              className={
                                                                post?.post_image
                                                                  .length == 1
                                                                  ? isMobileView
                                                                    ? "w-[350px] h-[350px] object-contain rounded-lg "
                                                                    : "w-[780px] h-[400px] object-contain rounded-lg "
                                                                  : isMobileView
                                                                  ? "w-[350px] h-[340px] object-contain rounded-lg "
                                                                  : "w-[780px] h-[400px] object-contain rounded-lg "
                                                              }
                                                              alt="Video Thumbnail"
                                                              onClick={(e) => {
                                                                handleVideoClick1(
                                                                  index,
                                                                  imageIndex
                                                                );
                                                              }}
                                                            />
                                                          </div>
                                                        ) : (
                                                          <video
                                                            ref={(el) =>
                                                              (videoRefs.current[
                                                                key
                                                              ] = el)
                                                            }
                                                            autoPlay
                                                            controls
                                                            autobuffer
                                                            playsInline={true}
                                                            webkit-playsinline="true"
                                                            x5-playsinline="true"
                                                            x-webkit-airplay="deny"
                                                            disablePictureInPicture={
                                                              true
                                                            }
                                                            controlsList="nodownload"
                                                            onContextMenu={(
                                                              e
                                                            ) =>
                                                              e.preventDefault()
                                                            }
                                                            preload="auto"
                                                            id={`video-${key}`}
                                                            controls
                                                            className="w-full h-full object-contain rounded-lg"
                                                            onClick={(e) => {
                                                              e.target.currentTime = 0;
                                                              handleVideoClick1(
                                                                index,
                                                                imageIndex
                                                              );
                                                            }}
                                                          >
                                                            <source
                                                              src={image.image}
                                                            />
                                                          </video>
                                                        )}

                                                        <button
                                                          id={`play-button-${key}`}
                                                          className={
                                                            videoPlaying[key]
                                                              ? "absolute  rounded-lg inset-0 flex items-center justify-center text-white"
                                                              : "absolute  rounded-lg inset-0 flex items-center justify-center bg-black bg-opacity-50 text-white"
                                                          }
                                                          style={{
                                                            display:
                                                              videoPlaying[key]
                                                                ? "none"
                                                                : "block",
                                                          }}
                                                          onClick={() =>
                                                            handleVideoClick1(
                                                              index,
                                                              imageIndex
                                                            )
                                                          }
                                                        >
                                                          {videoPlaying[key] ? (
                                                            ""
                                                          ) : (
                                                            <FontAwesomeIcon
                                                              className="h-7"
                                                              icon={
                                                                videoPlaying[
                                                                  key
                                                                ]
                                                                  ? faPause
                                                                  : faPlay
                                                              }
                                                            />
                                                          )}
                                                        </button> */}
                                                                                                            {pausedVideoId === post.id && (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
      <FontAwesomeIcon
        icon={faPlay}
        className="text-green-500 text-3xl opacity-60"
      />
    </div>
  )}

                                                                              <video
                id={post.id}
                data-id={post.id}
                ref={(el) => (videosRef.current[post.id] = el)}
                poster={image.thumb}
                src={image.image}
                className="w-full max-h-full object-contain"
                // onMouseEnter={() => handleVisibility(post.id, true)}
                // onMouseLeave={() => handleVisibility(post.id, false)}
                onClick={() => togglePlay(post.id)}
                loop
                muted={isMuted}
                playsInline
                onLoadedData={() => handleVideoCanPlay(post.id,true)}
              />
              {/* Mute button positioned inside the post at the bottom-right corner */}
<button
  onClick={(e) => {
    e.stopPropagation(); // Prevent click from bubbling to parent
    toggleMute();
  }}
  className="absolute bottom-4 right-4 px-4 py-2 text-sm"
>
  {isMuted ? "🔇" : "🔊"}
</button>
                                                      </div>
                                                    ) : (
                                                      <div
                                                        id={`gallery-${post.id}`}
                                                        style={galleryStyles}
                                                      >
                                                        {" "}
                                                        <a
                                                          href={image.image}
                                                          key={`image-${imageIndex}`}
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                          style={linkStyles}
                                                        >
                                                          <img
                                                            src={image.image}
                                                            alt={`Post Image ${
                                                              imageIndex + 1
                                                            }`}
                                                            style={imageStyles}
                                                            onLoad={(event) =>
                                                              handleImageLoaded(
                                                                event,
                                                                index
                                                              )
                                                            }
                                                          />
                                                        </a>
                                                      </div>
                                                    )}
                                                  </div>
                                                );
                                              }
                                            )}

                                        {preview && (
                                          <div
                                            style={{
                                              position: "fixed",
                                              top: 0,
                                              left: 0,
                                              width: "100%",
                                              height: "100%",
                                              backgroundColor:
                                                "rgba(0, 0, 0, 0.5)",
                                              opacity: "1",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              zIndex: 1000, // Set a higher value to ensure it's above the sidebar
                                            }}
                                            onClick={() => setPreview(false)}
                                          >
                                            <TransformWrapper
                                              defaultScale={1}
                                              defaultPositionX={200}
                                              defaultPositionY={100}
                                              className="flex items-center justify-center"
                                            >
                                              {({
                                                zoomIn,
                                                zoomOut,
                                                resetTransform,
                                                positionX,
                                                positionY,
                                                ...rest
                                              }) => (
                                                <>
                                                  <TransformComponent className="flex items-center justify-center">
                                                    <img
                                                      src={activeImage}
                                                      alt="Preview"
                                                      className={
                                                        isMobileView
                                                          ? "ml-3"
                                                          : "ml-6"
                                                      }
                                                      style={{
                                                        maxWidth: "95%",
                                                        maxHeight: "100%",
                                                        objectFit: "contain",
                                                      }}
                                                    />
                                                  </TransformComponent>
                                                </>
                                              )}
                                            </TransformWrapper>
                                          </div>
                                        )}
                                      </div>
                                      <div className="flex flex-row md:ml-8 ml-[2.8rem] justify-between items-center px-4 sm:px-8 my-4 text-green-500 space-x-4">
                                        <button
                                          onClick={() =>
                                            handleCommentToggle(
                                              index,
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id
                                            )
                                          }
                                          className="flex flex-row justify-center items-center"
                                        >
                                          <FontAwesomeIcon icon={empty2} />
                                          <p className="ml-1 md:text-xs text-base">
                                            {post?.repost?.id
                                              ? post?.repost?.total_comments
                                              : post.total_comments}
                                          </p>
                                        </button>
                                        <button
                                          disabled={isDisabled ? true : false}
                                          onClick={() =>
                                            handleRepost(
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id,
                                              post,
                                              post.id
                                            )
                                          }
                                          className="flex flex-row justify-center items-center "
                                        >
                                          <FontAwesomeIcon icon={faRepeat} />
                                          <p className="ml-1 md:text-xs text-base">
                                            {post?.repost?.id
                                              ? post?.repost?.repost_count
                                              : post.repost_count}
                                          </p>
                                        </button>
                                        <button
                                          disabled={isDisabled ? true : false}
                                          onClick={() =>
                                            handleLikeDislike(
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id,
                                              post?.repost?.id
                                                ? post?.repost?.total_likes
                                                : post.total_likes
                                            )
                                          }
                                          className="flex flex-row justify-center items-center"
                                        >
                                          {post?.repost?.id ? (
                                            <FontAwesomeIcon
                                              icon={
                                                post?.repost?.is_like_by_me
                                                  ? faHeart
                                                  : empty
                                              }
                                            />
                                          ) : (
                                            <FontAwesomeIcon
                                              icon={
                                                post?.is_like_by_me
                                                  ? faHeart
                                                  : empty
                                              }
                                            />
                                          )}
                                          <p className="ml-1 md:text-xs text-base">
                                            {post?.repost?.id
                                              ? post?.repost?.total_likes
                                              : post.total_likes}
                                          </p>
                                        </button>
                                        <button
                                          disabled={isDisabled ? true : false}
                                          onClick={() =>
                                            handleSavePost(
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id
                                            )
                                          }
                                          className="flex flex-row justify-center items-center "
                                        >
                                          <FontAwesomeIcon
                                            icon={
                                              post?.repost?.is_saved ||
                                              post.is_saved
                                                ? saved
                                                : faBookmark // This will be used if post or repost is not saved
                                            }
                                          />
                                        </button>

                                        {/* <button className="flex flex-row justify-center items-center ">
                                        <FontAwesomeIcon icon={faChartSimple} />
                                        <p className="ml-1 md:text-xs text-xxs">2,434</p>
                                        </button> */}
                                        {isModalOpen && newid === post.id && (
                                          <div
                                            className={
                                              isMobileView
                                                ? "fixed top-0 left-0 h-full flex items-center justify-center right-5"
                                                : "fixed top-0 left-0 w-full h-full flex items-center justify-center"
                                            }
                                          >
                                            <div className="bg-white p-6 rounded shadow-lg text-center">
                                              {/* Modal content goes here */}
                                              <div className="flex justify-center items-center my-2">
                                                <img
                                                  src={"/qushi_logo.png"}
                                                  className="h-24"
                                                  alt="logo"
                                                />
                                              </div>
                                              <p className="mb-4 text-primaryColor">
                                                Delete this post? This can't be
                                                undone.
                                              </p>
                                              <div className="flex justify-center">
                                                <button
                                                  onClick={handleCloseModal}
                                                  className="bg-white border border-gray-300 text-gray-700 py-2 px-4 rounded mr-2"
                                                >
                                                  Cancel
                                                </button>
                                                <button
                                                  disabled={
                                                    isDisabled ? true : false
                                                  }
                                                  onClick={handleDelete}
                                                  className="bg-red-500 text-white py-2 px-4 rounded"
                                                >
                                                  Delete
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                        <button
                                          onClick={() =>
                                            handleShare(
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id
                                            )
                                          }
                                          className="flex flex-row justify-center items-center"
                                        >
                                          <FontAwesomeIcon
                                            icon={faArrowUpFromBracket}
                                          />
                                        </button>
                                      </div>
                                      {commentOpenStates[index] && (
                                        <div className="mt-4 text-black ml-[20px] md:ml-[60px] lg:ml-[60px]">
                                          <div className="mt-4 space-y-4">
                                            {postComments[
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id
                                            ] &&
                                            postComments[
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id
                                            ].length > 0 ? (
                                              postComments[
                                                post?.repost?.id
                                                  ? post?.repost?.id
                                                  : post.id
                                              ].map((comment) => (
                                                <div
                                                  key={comment.id}
                                                  className="flex items-start mb-2"
                                                >
                                                  <div className="flex-shrink-0">
                                                    <img
                                                      src={comment?.user?.image}
                                                      alt={`${comment?.user?.user_name}'s avatar`}
                                                      className="w-10 h-10 rounded-full mr-2 cursor-pointer hover:opacity-80 transition-opacity"
                                                      onClick={(e) => navigateToUserProfile(e, comment?.user?.id)}
                                                    />
                                                  </div>
                                                  <div className="w-full">
                                                    <div className="flex justify-between mb-1">
                                                      <span
                                                        className="font-semibold ml-2 cursor-pointer hover:underline"
                                                        onClick={(e) => navigateToUserProfile(e, comment?.user?.id)}
                                                      >
                                                        {
                                                          comment?.user
                                                            ?.user_name
                                                        }
                                                      </span>

                                                      {comment?.user.id ===
                                                        userInfo?.id && (
                                                        <button
                                                          disabled={
                                                            isDisabled
                                                              ? true
                                                              : false
                                                          }
                                                          className="px-5 text-green-500"
                                                          onClick={() =>
                                                            handleDeleteComment(
                                                              comment.id
                                                            )
                                                          }
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faTrash}
                                                          />
                                                        </button>
                                                      )}
                                                    </div>
                                                    <div className="flex justify-between">
                                                      <div
                                                        className={
                                                          "md:w-full w-52 ml-2"
                                                        }
                                                      >
                                                        {comment?.comment && (
                                                          <p className="w-full break-words text-lg" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                                            {comment?.comment}
                                                          </p>
                                                        )}
                                                        {comment?.image && (
                                                          <div className="pswp-comment-gallery mt-1.5">
                                                            <a href={comment.image} data-pswp-width="800" data-pswp-height="600" target="_blank" rel="noreferrer">
                                                              <img
                                                                src={comment.image}
                                                                alt="Comment image"
                                                                className="rounded-lg max-w-[200px] max-h-[200px] object-cover cursor-pointer"
                                                                loading="lazy"
                                                                onLoad={(e) => handleImageLoaded(e, 0)}
                                                              />
                                                            </a>
                                                          </div>
                                                        )}
                                                      </div>
                                                    </div>
                                                  {/* Reply button + View replies */}
                                                  <div className="flex items-center gap-3 ml-2 mt-1">
                                                    <button
                                                      className="text-xs text-gray-500 font-semibold hover:text-gray-700"
                                                      onClick={() => handleReply(comment, post?.repost?.id ? post?.repost?.id : post.id)}
                                                    >
                                                      Reply
                                                    </button>
                                                    {comment.replies_count > 0 && (
                                                      <button
                                                        className="text-xs text-blue-500 font-semibold hover:text-blue-700"
                                                        onClick={() => toggleReplies(comment.id)}
                                                      >
                                                        {expandedReplies[comment.id]
                                                          ? 'Hide replies'
                                                          : `View ${comment.replies_count} ${comment.replies_count === 1 ? 'reply' : 'replies'}`}
                                                      </button>
                                                    )}
                                                  </div>
                                                  {/* Nested replies */}
                                                  {expandedReplies[comment.id] && comment.replies?.length > 0 && (
                                                    <div className="ml-8 mt-2 space-y-3 border-l-2 border-gray-200 pl-3">
                                                      {comment.replies.map((reply) => (
                                                        <div key={reply.id} className="flex items-start">
                                                          <div className="flex-shrink-0">
                                                            <img
                                                              src={reply?.user?.image}
                                                              alt={`${reply?.user?.user_name}'s avatar`}
                                                              className="w-7 h-7 rounded-full mr-2 cursor-pointer hover:opacity-80 transition-opacity"
                                                              onClick={(e) => navigateToUserProfile(e, reply?.user?.id)}
                                                            />
                                                          </div>
                                                          <div className="flex-1">
                                                            <div className="flex justify-between mb-0.5">
                                                              <span
                                                                className="font-semibold text-base ml-1 cursor-pointer hover:underline"
                                                                onClick={(e) => navigateToUserProfile(e, reply?.user?.id)}
                                                              >
                                                                {reply?.user?.user_name}
                                                              </span>
                                                              {reply?.user?.id === userInfo?.id && (
                                                                <button
                                                                  disabled={isDisabled}
                                                                  className="px-3 text-green-500"
                                                                  onClick={() => handleDeleteComment(reply.id)}
                                                                >
                                                                  <FontAwesomeIcon icon={faTrash} />
                                                                </button>
                                                              )}
                                                            </div>
                                                            {reply?.comment && (
                                                              <p className="w-full break-words text-lg ml-1" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                                                {reply.comment}
                                                              </p>
                                                            )}
                                                            {reply?.image && (
                                                              <div className="pswp-comment-gallery mt-1">
                                                                <a href={reply.image} data-pswp-width="800" data-pswp-height="600" target="_blank" rel="noreferrer">
                                                                  <img
                                                                    src={reply.image}
                                                                    alt="Reply image"
                                                                    className="rounded-lg max-w-[150px] max-h-[150px] object-cover cursor-pointer"
                                                                    loading="lazy"
                                                                    onLoad={(e) => handleImageLoaded(e, 0)}
                                                                  />
                                                                </a>
                                                              </div>
                                                            )}
                                                            <button
                                                              className="text-xs text-gray-500 font-semibold hover:text-gray-700 ml-1 mt-1"
                                                              onClick={() => handleReply(comment, post?.repost?.id ? post?.repost?.id : post.id)}
                                                            >
                                                              Reply
                                                            </button>
                                                          </div>
                                                        </div>
                                                      ))}
                                                    </div>
                                                  )}
                                                  </div>
                                                </div>
                                              ))
                                            ) : loadingComment ? (
                                              <ListSkeleton
                                                rows={2}
                                                avatarSize={32}
                                                columns={0}
                                                divided={false}
                                                rowClassName="py-3 px-4"
                                              />
                                            ) : (
                                              <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
                                                <p>No comments yet</p>
                                              </div>
                                            )}
                                          </div>

                                          {replyingTo && (
                                            <div className="flex items-center justify-between bg-gray-100 px-3 py-2 rounded-t mb-0">
                                              <span className="text-sm text-gray-600">
                                                Replying to <span className="font-semibold">@{replyingTo.userName}</span>
                                              </span>
                                              <button
                                                className="text-sm text-gray-500 hover:text-gray-700 font-semibold"
                                                onClick={handleCancelReply}
                                              >
                                                Cancel
                                              </button>
                                            </div>
                                          )}
                                          {commentImagePreview && (
                                            <div className="mb-2 relative inline-block">
                                              <img src={commentImagePreview} alt="Preview" className="h-20 w-20 object-cover rounded-lg border border-gray-200" />
                                              <button
                                                className="absolute -top-1.5 -right-1.5 w-5 h-5 bg-gray-800 text-white rounded-full flex items-center justify-center text-xs"
                                                onClick={() => { setCommentImage(null); setCommentImagePreview(null); }}
                                              >&times;</button>
                                            </div>
                                          )}
                                          <div className="flex">
                                            <textarea
                                              value={newComment}
                                              onChange={(e) => setNewComment(e.target.value)}
                                              placeholder="Add a comment..."
                                              className="p-2 border border-emerald-500 rounded w-full text-black"
                                              style={{ flex: 1, resize: 'none', maxHeight: '150px', overflowY: 'auto' }}
                                              rows={4}
                                            />
                                            <div className="flex flex-col ml-2 gap-1">
                                              <button
                                                className="bg-gray-200 hover:bg-gray-300 text-gray-600 px-2 rounded-full focus:outline-none flex items-center justify-center"
                                                onClick={() => commentImageInputRef.current?.click()}
                                                style={{ height: 30, minWidth: 84 }}
                                              >
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-1">
                                                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                                                  <circle cx="8.5" cy="8.5" r="1.5" />
                                                  <polyline points="21 15 16 10 5 21" />
                                                </svg>
                                                Image
                                              </button>
                                              <button
                                                className="bg-primaryColor text-gray-200 hover:bg-primaryColor hover:text-white px-2 rounded-full focus:outline-none"
                                                disabled={isDisabled || (!newComment.trim() && !commentImage)}
                                                onClick={() =>
                                                  handleAddComment(
                                                    post?.repost?.id
                                                      ? post?.repost?.id
                                                      : post.id,
                                                    index
                                                  )
                                                }
                                                style={{ height: 30, minWidth: 84 }}
                                              >
                                                Submit
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      <div className="w-full mt-3 h-px bg-[#F3F4F6]"></div>{" "}
                                    </div>
                                  );
                                })}
                              {/* <div>
                                {page !== last_page && (
                                    <div className="text-center">
                                    <button
                                        className="py-2 px-4 w-auto mt-2 mr-16 text-lg font-bold text-greenXD justify-end"
                                        onClick={handleLoadMore}
                                    >
                                        More
                                    </button>
                                    </div>
                                )}
                                </div> */}
                            </>
                          ) : activeProfileTab === "overview" ? (
                            // Desktop-only empty state when there is no pinned post
                            // to feature on the Overview.
                            <div className="hidden lg:flex flex-col items-center justify-center text-center pt-6 pb-16 px-6">
                              <span className="w-14 h-14 rounded-full bg-[#F3F4F6] flex items-center justify-center mb-4">
                                <FontAwesomeIcon
                                  icon={faThumbtack}
                                  className="text-[#9CA3AF] text-xl"
                                />
                              </span>
                              {!showPublicLayout ? (
                                profilePosts.length > 0 ? (
                                  // Owner has posts but hasn't pinned one yet.
                                  <>
                                    <p className="text-lg font-bold text-gray-900">
                                      No pinned post yet
                                    </p>
                                    <p className="text-sm text-gray-500 mt-1">
                                      Pin a post to feature it on your profile.
                                    </p>
                                    <button
                                      type="button"
                                      onClick={() => setActiveProfileTab("posts")}
                                      className="mt-4 px-5 py-2.5 rounded-lg bg-primaryColor text-white font-semibold font-poppins"
                                    >
                                      View posts
                                    </button>
                                  </>
                                ) : (
                                  // Owner has no posts at all.
                                  <>
                                    <p className="text-lg font-bold text-gray-900">
                                      No posts yet
                                    </p>
                                    <p className="text-sm text-gray-500 mt-1">
                                      Make your first call.
                                    </p>
                                    <button
                                      type="button"
                                      onClick={() => navigate("/create-post")}
                                      className="mt-4 px-5 py-2.5 rounded-lg bg-primaryColor text-white font-semibold font-poppins"
                                    >
                                      Create a post
                                    </button>
                                  </>
                                )
                              ) : (
                                <>
                                  <p className="text-lg font-bold text-gray-900">
                                    No pinned post yet
                                  </p>
                                  <p className="text-sm text-gray-500 mt-1">
                                    This trader hasn't pinned a post yet.
                                  </p>
                                </>
                              )}
                            </div>
                          ) : (
                            // Posts tab empty state — different copy for owner vs visitor.
                            <div className="flex flex-col items-center justify-center text-center pt-6 pb-16 px-6">
                              <span className="w-14 h-14 rounded-full bg-[#F3F4F6] flex items-center justify-center mb-4">
                                <FontAwesomeIcon
                                  icon={empty2}
                                  className="text-[#9CA3AF] text-xl"
                                />
                              </span>
                              {!showPublicLayout ? (
                                <>
                                  <p className="text-lg font-bold text-gray-900">
                                    Nothing posted yet
                                  </p>
                                  <p className="text-sm text-gray-500 mt-1">
                                    Your record shows what you've done.
                                  </p>
                                  <p className="text-sm text-gray-500">
                                    Your posts show how you think.
                                  </p>
                                  <button
                                    type="button"
                                    onClick={() => navigate("/create-post")}
                                    className="mt-4 px-5 py-2.5 rounded-lg bg-primaryColor text-white font-semibold font-poppins"
                                  >
                                    Talk Your Book
                                  </button>
                                </>
                              ) : (
                                <>
                                  <p className="text-lg font-bold text-gray-900">
                                    No posts yet
                                  </p>
                                  <p className="text-sm text-gray-500 mt-1">
                                    This trader lets the record do the talking.
                                  </p>
                                </>
                              )}
                            </div>
                          )}
                        </InfiniteScroll>
                        {/* Top Holdings is desktop-only now (right rail). Removed
                            from mobile along with the Overview tab. */}
                      </div>
                    )}
                    {/* </div> */}
                  </>
                )}
                </div>
                </div>
                {/* Desktop right rail: Record card + Trophy Case + owner tools on private */}
                <div className="hidden lg:block lg:w-[360px] lg:shrink-0 ">
                  {financialsReady ? (
                    <ProfileRecordCard
                      profile={profile}
                      userId={userId || user_id}
                      chartRight
                      isSelf={!showPublicLayout}
                      inLeague={!!game_id}
                      gameId={game_id}
                      game={game}
                      title={recordTitle}
                      subtitle={recordSubtitle}
                      guideId="profile-guide-record"
                    />
                  ) : (
                    <RecordCardSkeleton
                      chartRight
                      title={recordTitle}
                      subtitle={recordSubtitle}
                    />
                  )}
                  {/* Trophy Case (+ QUSHi Coins on private). Not inside a
                      league — item 17, same as the owner tools below. */}
                  {!game_id && (profile?.id || userId || user_id) && (
                    <TrophyCase
                      userId={profile?.id || userId || user_id}
                      isOwn={!showPublicLayout}
                      coins={profile?.coins || 0}
                      coinsGuideId="profile-guide-coins"
                    />
                  )}
                  {/* item 17 again — see the mobile copy of this block. */}
                  {!showPublicLayout &&
                    !game_id &&
                    (financialsReady ? (
                      <OwnerToolsBlock
                        showCoins={false}
                        referralCode={userReferralCode}
                        userName={profile?.user_name}
                        onQushiBank={resetPortfolio}
                      />
                    ) : (
                      <OwnerToolsSkeleton />
                    ))}
                  {/* Desktop: Top Holdings always shown at the end of the right rail
                      (after Owner tools on private; right after The Record on public).
                      Overview tab was removed on desktop, so this is no longer tab-gated.

                      Client League Play Profiles spec, item 18: "Remove the Top
                      Holdings module — DESKTOP ONLY." Explicitly desktop-only in
                      the client's own words, and it already is: mobile dropped
                      Top Holdings when the Overview tab went. So the one place
                      it still renders is this rail, and inside a league it now
                      does not. The main profile keeps it. Its own request is
                      still fired (it is keyed on the profile id, not on this
                      flag) but nothing on a league profile reads it. */}
                  {!game_id && (
                    <div className="mt-4 rounded-2xl border border-gray-200 bg-white p-4 feed-shadow">
                      {renderTopHoldings()}
                    </div>
                  )}
                </div>
                </div>
              </main>
            </div>

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-96 p-6">
            <h2 className="text-lg font-semibold mb-4 text-center">Your Referral Code</h2>

            {referloading ? (
              <p className="text-center text-gray-500">Generating...</p>
            ) : referralCode ? (
              <div className="flex flex-col items-center gap-3">
                <p className="text-2xl font-bold text-primaryColor">{referralCode}</p>
                <button
                  onClick={() => {
                    navigator.clipboard.writeText(referralCode);
                    alert("Copied to clipboard!");
                  }}
                  className="text-sm text-blue-500 hover:underline"
                >
                  Copy Code
                </button>
              </div>
            ) : error ? (
              <p className="text-center text-red-500">{error}</p>
            ) : (
              <button
                onClick={handleGenerateCode}
                className="bg-primaryColor text-white px-4 py-2 rounded-lg hover:bg-primaryColor-dark"
              >
                Generate My Code
              </button>
            )}

            <div className="text-center mt-4">
              <button
                onClick={() => setShowModal(false)}
                className="text-sm text-gray-500 hover:text-primaryColor"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
            <SubscriptionModal
              isOpen={isSubscribe}
              handleSubscribeCard={handleSubscribeCard}
              handleSubscribeCancel={handleSubscribeCancel}
            >
              <h className="text-lg font-bold text-primaryColor">
                You will be charged ${profile.subscription_plan_amount}
              </h>
              <p>Are you sure you want to subscribe!</p>
            </SubscriptionModal>
            <CardListForSubs
              openModal={openModal}
              isOpen={isOpenCardModal}
              isButtonDisabled={isButtonDisabled}
              handlePaymentCard={handlePaymentCard}
              handlePaymentCancel={handlePaymentCancel}
            >
              <AddCard
                isOpen={isAddModalOpen}
                setIsAddModalOpen={setIsAddModalOpen}
              >
                <Elements stripe={stripePromise}>
                  <CheckoutForm closeModal={closeModal} getCards={getCards} />
                </Elements>
              </AddCard>
              <List
                isChecked={isChecked}
                handlePrimaryValue={handlePrimaryValue}
                cards={cards}
              />
            </CardListForSubs>
            <ResetPortfolioModal
              isOpen={isPortfolioResetModalOpen}
              onClose={closeResetPortfolioModal}
              onConfirm={handleConfirm}
              processing={isLoading}
            />

            {/* Stripe Modal */}
            {isStripeModalOpen && !isLoading && (
              <div className="stripe-modal">
                <Elements stripe={stripeResetPromise}>
                  <CheckoutPortfolioForm
                    profile={profile}
                    clientSecret={clientSecret}
                    onClose={handleStripeModalClose}
                  />
                </Elements>
              </div>
            )}
          </Shell>
        </>
      )}
      <UndoRepostModal
        isOpen={postUndo}
        handleUndoRepost={handleUndoRepost}
        handleUndoCancel={handleUndoCancel}
      >
        <div className={"mb-4"}>
          <p>{"Are you sure you want to undo this reposted post?"}</p>
        </div>
      </UndoRepostModal>
      {isPreviewVideo && (
        <PreviewVideo src={attachments} onClick={handleCloseVideoClick} />
      )}

      {!showProfileGuide && !newTraderGuideActive && !userId && !isSidebarOpen && guideIcon && (
        <GuideLauncher
          title="Drag to move • Click to show guide (Ctrl+G)"
          onOpen={() => {
            setShouldPersistGuideSetting(false);
            setShowProfileGuide(true);
          }}
        />
      )}

      {showProfileGuide && !newTraderGuideActive && (
        <ProfileGuideSteps
          setShowGuide={setShowProfileGuide}
          shouldPersistSetting={shouldPersistGuideSetting}
          onGuideComplete={handleProfileGuideComplete}
        />
      )}

      {newTraderGuideActive && newTraderGuideStep === 1 && (
        <NewTraderGuide step={1} />
      )}

      {newTraderGuideActive && newTraderGuideStep === 3 &&
        localStorage.getItem("qushi_onboarding_persona") === "experienced" && (
          <NewTraderGuide step={3} />
        )}

      {newTraderGuideActive && newTraderGuideStep === 4 &&
        localStorage.getItem("qushi_onboarding_persona") === "creator" && (
          <NewTraderGuide step={4} />
        )}

      {/* Mobile Comment Modal - Instagram Style */}
      {mobileCommentModal.isOpen && (
        <div
          className="fixed inset-0 z-[9999] md:hidden"
          style={{
            touchAction: 'none',
            height: '100%',
            height: '100dvh',
          }}
          ref={commentModalRef}
        >
          {/* Backdrop */}
          <div
            className="absolute inset-0 bg-black bg-opacity-50"
            onClick={() => {
              setMobileCommentModal({ isOpen: false, postId: null, postIndex: null });
              setNewComment("");
              setReplyingTo(null);
            }}
          />

          {/* Modal Content - Dynamic height that adjusts for keyboard */}
          <div
            className="absolute left-0 right-0 bg-white rounded-t-3xl flex flex-col"
            style={{
              animation: commentModalSwipe.isDragging ? 'none' : 'slideUp 0.3s ease-out',
              bottom: 0,
              maxHeight: keyboardHeight > 0
                ? `calc(100dvh - ${keyboardHeight}px)`
                : '80vh',
              height: 'auto',
              minHeight: keyboardHeight > 0 ? '200px' : '65vh',
              transform: `translateY(${Math.max(0, commentModalSwipe.currentY - commentModalSwipe.startY)}px)`,
              transition: commentModalSwipe.isDragging ? 'none' : 'max-height 0.15s ease-out, min-height 0.15s ease-out, transform 0.3s ease-out',
            }}
          >
            {/* Header - Drag handle area */}
            <div
              className="flex items-center justify-center py-2.5 border-b border-gray-200 relative flex-shrink-0 cursor-grab"
              onTouchStart={(e) => {
                setCommentModalSwipe({
                  startY: e.touches[0].clientY,
                  currentY: e.touches[0].clientY,
                  isDragging: true,
                });
              }}
              onTouchMove={(e) => {
                if (commentModalSwipe.isDragging) {
                  setCommentModalSwipe((prev) => ({
                    ...prev,
                    currentY: e.touches[0].clientY,
                  }));
                }
              }}
              onTouchEnd={() => {
                const swipeDistance = commentModalSwipe.currentY - commentModalSwipe.startY;
                if (swipeDistance > 80) {
                  // Close the modal if swiped down more than 80px
                  setMobileCommentModal({ isOpen: false, postId: null, postIndex: null });
                  setNewComment("");
                  setReplyingTo(null);
                }
                setCommentModalSwipe({ startY: 0, currentY: 0, isDragging: false });
              }}
            >
              <div className="absolute left-1/2 transform -translate-x-1/2 top-1.5 w-10 h-1 bg-gray-300 rounded-full" />
              <h3 className="font-semibold text-base mt-1">Comments</h3>
              {/* <button
                className="absolute right-4 top-2 p-1"
                onClick={() => {
                  setMobileCommentModal({ isOpen: false, postId: null, postIndex: null });
                  setNewComment("");
                }}
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M18 6L6 18M6 6l12 12" />
                </svg>
              </button> */}
            </div>

            {/* Comments List - Scrollable area */}
            <div
              data-comment-scroll
              className="flex-1 overflow-y-auto px-4 py-2 overscroll-contain"
              style={{
                minHeight: '80px',
                WebkitOverflowScrolling: 'touch',
              }}
            >
              {loadingComment ? (
                <ListSkeleton
                  rows={3}
                  avatarSize={32}
                  columns={0}
                  divided={false}
                  rowClassName="py-3"
                />
              ) : postComments[mobileCommentModal.postId]?.length > 0 ? (
                postComments[mobileCommentModal.postId].map((comment) => (
                  <div key={comment.id} className="mb-5">
                    <div className="flex items-start">
                      <img
                        src={comment?.user?.image}
                        alt={`${comment?.user?.user_name}'s avatar`}
                        className="w-10 h-10 rounded-full mr-3 flex-shrink-0 cursor-pointer hover:opacity-80 transition-opacity"
                        onClick={(e) => navigateToUserProfile(e, comment?.user?.id)}
                      />
                      <div className="flex-1">
                        <div className="flex items-center gap-2">
                          <span
                            className="font-semibold text-base cursor-pointer hover:underline"
                            onClick={(e) => navigateToUserProfile(e, comment?.user?.id)}
                          >
                            {comment?.user?.user_name}
                          </span>
                          <span className="text-sm text-gray-400">
                            {comment?.created_at ? calculateTimeDifference(comment.created_at) : ''}
                          </span>
                        </div>
                        {comment?.comment && (
                          <p className="text-[17px] leading-snug text-gray-800 mt-1" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                            {comment?.comment}
                          </p>
                        )}
                        {comment?.image && (
                          <div className="pswp-comment-gallery mt-1.5">
                            <a href={comment.image} data-pswp-width="800" data-pswp-height="600" target="_blank" rel="noreferrer">
                              <img
                                src={comment.image}
                                alt="Comment image"
                                className="rounded-lg max-w-[200px] max-h-[200px] object-cover cursor-pointer"
                                loading="lazy"
                                onLoad={(e) => handleImageLoaded(e, 0)}
                              />
                            </a>
                          </div>
                        )}
                        {/* Reply button + View replies */}
                        <div className="flex items-center gap-3 mt-1.5">
                          <button
                            className="text-xs text-gray-500 font-semibold"
                            onClick={() => handleReply(comment, mobileCommentModal.postId)}
                          >
                            Reply
                          </button>
                          {comment.replies_count > 0 && (
                            <button
                              className="text-xs text-blue-500 font-semibold"
                              onClick={() => toggleReplies(comment.id)}
                            >
                              {expandedReplies[comment.id]
                                ? 'Hide replies'
                                : `View ${comment.replies_count} ${comment.replies_count === 1 ? 'reply' : 'replies'}`}
                            </button>
                          )}
                        </div>
                      </div>
                      {comment?.user?.id === profile?.id && (
                        <button
                          className="ml-2 p-1.5 text-green-500 hover:text-green-600 flex-shrink-0"
                          onClick={() => handleDeleteComment(comment.id)}
                          disabled={isDisabled}
                          title="Delete comment"
                        >
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
                          </svg>
                        </button>
                      )}
                    </div>
                    {/* Nested replies */}
                    {expandedReplies[comment.id] && comment.replies?.length > 0 && (
                      <div className="ml-12 mt-2 space-y-3 border-l-2 border-gray-200 pl-3">
                        {comment.replies.map((reply) => (
                          <div key={reply.id} className="flex items-start">
                            <img
                              src={reply?.user?.image}
                              alt={`${reply?.user?.user_name}'s avatar`}
                              className="w-7 h-7 rounded-full mr-2 flex-shrink-0 cursor-pointer hover:opacity-80 transition-opacity"
                              onClick={(e) => navigateToUserProfile(e, reply?.user?.id)}
                            />
                            <div className="flex-1">
                              <div className="flex items-center gap-2">
                                <span
                                  className="font-semibold text-base cursor-pointer hover:underline"
                                  onClick={(e) => navigateToUserProfile(e, reply?.user?.id)}
                                >
                                  {reply?.user?.user_name}
                                </span>
                                <span className="text-xs text-gray-400">
                                  {reply?.created_at ? calculateTimeDifference(reply.created_at) : ''}
                                </span>
                              </div>
                              {reply?.comment && (
                                <p className="text-[17px] leading-snug text-gray-800 mt-0.5" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                  {reply.comment}
                                </p>
                              )}
                              {reply?.image && (
                                <div className="pswp-comment-gallery mt-1">
                                  <a href={reply.image} data-pswp-width="800" data-pswp-height="600" target="_blank" rel="noreferrer">
                                    <img
                                      src={reply.image}
                                      alt="Reply image"
                                      className="rounded-lg max-w-[150px] max-h-[150px] object-cover cursor-pointer"
                                      loading="lazy"
                                      onLoad={(e) => handleImageLoaded(e, 0)}
                                    />
                                  </a>
                                </div>
                              )}
                              <button
                                className="text-xs text-gray-500 font-semibold mt-1"
                                onClick={() => handleReply(comment, mobileCommentModal.postId)}
                              >
                                Reply
                              </button>
                            </div>
                            {reply?.user?.id === profile?.id && (
                              <button
                                className="ml-1 p-1 text-green-500 hover:text-green-600 flex-shrink-0"
                                onClick={() => handleDeleteComment(reply.id)}
                                disabled={isDisabled}
                              >
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                                  <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
                                </svg>
                              </button>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <div className="text-center py-8">
                  <p className="text-gray-500 font-medium">No comments yet</p>
                  <p className="text-gray-400 text-sm mt-1">Start the conversation.</p>
                </div>
              )}
            </div>

            {/* Comment Input - Stays above keyboard */}
            <div
              className="border-t border-gray-200 px-3 py-2.5 bg-white flex-shrink-0"
              style={{
                paddingBottom: 'max(10px, env(safe-area-inset-bottom))',
              }}
            >
              {/* Replying to indicator */}
              {replyingTo && (
                <div className="flex items-center justify-between px-3 py-1.5 bg-gray-50 rounded-t mb-1">
                  <span className="text-xs text-gray-600">
                    Replying to <span className="font-semibold">@{replyingTo.userName}</span>
                  </span>
                  <button className="text-xs text-blue-500 font-semibold" onClick={handleCancelReply}>
                    Cancel
                  </button>
                </div>
              )}
              {/* Emoji quick-bar */}
              <div className="flex items-center justify-around px-2 py-1.5">
                {['❤️','📈','🔥','👏','💪','✨','🤣','🚀'].map((emoji) => (
                  <button
                    key={emoji}
                    className="text-3xl p-1 active:scale-125 transition-transform"
                    onClick={() => setNewComment((prev) => prev + emoji)}
                  >
                    {emoji}
                  </button>
                ))}
              </div>
              <div className="flex items-end gap-2">
                <img
                  src={profile?.image || "/qushi_logo.png"}
                  alt="Your avatar"
                  className="w-8 h-8 rounded-full flex-shrink-0 mb-1"
                />
                {/* Image attach button */}
                <button
                  className="w-8 h-8 mb-1 flex items-center justify-center flex-shrink-0 text-gray-500 hover:text-gray-700"
                  onClick={() => commentImageInputRef.current?.click()}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                    <circle cx="8.5" cy="8.5" r="1.5" />
                    <polyline points="21 15 16 10 5 21" />
                  </svg>
                </button>
                <div className="flex-1 flex flex-col bg-gray-100 rounded-2xl pr-1">
                  {commentImagePreview && (
                    <div className="px-3 pt-2 relative inline-block self-start">
                      <img
                        src={commentImagePreview}
                        alt="Preview"
                        className="h-14 w-14 object-cover rounded-lg border border-gray-300"
                      />
                      <button
                        className="absolute top-1 right-0 w-5 h-5 bg-gray-800 text-white rounded-full flex items-center justify-center text-xs"
                        onClick={() => {
                          setCommentImage(null);
                          setCommentImagePreview(null);
                        }}
                      >
                        &times;
                      </button>
                    </div>
                  )}
                  <div className="flex items-end">
                    <div className="flex-1">
                      <textarea
                        ref={commentTextareaRef}
                        value={newComment}
                        onChange={(e) => {
                          setNewComment(e.target.value);
                          // Auto-grow up to 4 full lines; scroll activates at line 5
                          e.target.style.height = 'auto';
                          const maxH = 116;
                          if (e.target.scrollHeight > maxH) {
                            e.target.style.height = maxH + 'px';
                            e.target.style.overflowY = 'auto';
                          } else {
                            e.target.style.height = e.target.scrollHeight + 'px';
                            e.target.style.overflowY = 'hidden';
                          }
                        }}
                        onFocus={(e) => {
                          // Ensure input stays visible when keyboard opens
                          setTimeout(() => {
                            e.target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                          }, 300);
                        }}
                        placeholder="Add a comment..."
                        className="w-full bg-transparent px-4 py-2.5 text-base focus:outline-none text-black resize-none block"
                        style={{
                          maxHeight: '116px',
                          lineHeight: '24px',
                          WebkitOverflowScrolling: 'touch',
                          touchAction: 'pan-y',
                        }}
                        rows={1}
                        enterKeyHint="send"
                        autoComplete="off"
                        autoCorrect="on"
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' && !e.shiftKey && (newComment.trim() || commentImage)) {
                            e.preventDefault();
                            handleAddComment(mobileCommentModal.postId, mobileCommentModal.postIndex);
                          }
                        }}
                      />
                    </div>
                    <button
                      className={`w-8 h-8 mb-1 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${
                        (newComment.trim() || commentImage) ? 'bg-primaryColor' : 'bg-gray-300'
                      }`}
                      disabled={isDisabled || (!newComment.trim() && !commentImage)}
                      onClick={() => handleAddComment(mobileCommentModal.postId, mobileCommentModal.postIndex)}
                    >
                      {(
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="white"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M22 2L11 13" />
                          <path d="M22 2L15 22L11 13L2 9L22 2Z" />
                        </svg>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CSS Animation */}
          <style>{`
            @keyframes slideUp {
              from {
                transform: translateY(100%);
              }
              to {
                transform: translateY(0);
              }
            }
          `}</style>
        </div>
      )}
    </>
  );
};

export default ProfilePage;